/* Fixed wrapper model: measure wrapper height -> pad body; mobile drawer & submenus */
(function () {
  const d = document;
  const $ = (s, c = d) => c.querySelector(s);
  const $$ = (s, c = d) => Array.from(c.querySelectorAll(s));
  const body = d.body;
  const topwrap = $('#HHTop');
  const header = $('.hh-header');

  // Shared HTML-entity escape for any innerHTML interpolation of merchant or
  // shopper-controlled values. See AUDIT.md CR-2 / CR-3 (cart drawer + predictive
  // search were rendering product titles, URLs, and metadata raw, an XSS risk).
  function escapeHtml(s){
    if (s == null) return '';
    return String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  }

  function setTopPadding() {
    const h = topwrap ? Math.round(topwrap.getBoundingClientRect().height) : 0;
    body.style.paddingTop = h + 'px';
    // expose height for overlay pull-up without CLS
    document.documentElement.style.setProperty('--hh-top-h', h + 'px');
    if (header && header.classList.contains('is-overlay')){
      body.classList.add('has-overlay');
    } else {
      body.classList.remove('has-overlay');
    }
  }

  // Coalesce resize-driven recompute to one layout pass per frame.
  let tpRaf = 0;
  function onTopResize(){
    if (tpRaf) return;
    tpRaf = requestAnimationFrame(function(){ tpRaf = 0; setTopPadding(); });
  }

  // Observe size changes (locale dropdown, responsive wraps, etc.)
  function watchTopwrap() {
    if (!topwrap || typeof ResizeObserver === 'undefined') return;
    const ro = new ResizeObserver(() => {
      setTopPadding();
      // Adjust any open mega on wrapper size changes (announcement/header changes)
      $$('.hh-nav__item.open .hh-mega').forEach(m => setMegaTop(m));
    });
    ro.observe(topwrap);
  }

  // Keep mega menu top edge perfectly flush with header/announcement stack
  function setMegaTop(el){
    if (!el) return;
    const dStyle = getComputedStyle(document.documentElement);
    const topH = parseFloat((dStyle.getPropertyValue('--hh-top-h')||'0').trim()) || 0;
    el.style.top = Math.round(topH) + 'px';
  }
  function disableStickyIfNeeded(){
    if (!header || !topwrap) return;
    const stickyEnabled = header.classList.contains('is-sticky');
    if (!stickyEnabled){
      body.style.paddingTop = '0px';
      topwrap.style.position = 'static';
      window.removeEventListener('load', setTopPadding);
      window.removeEventListener('resize', onTopResize);
    }
  }
  function wireScrolledState(){
    if (!header) return;
    const onScroll = () => {
      const scrolled = window.scrollY > 10;
      if (scrolled) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
      // If overlay header, switch text scheme based on scroll position.
      // Only invert at the top when the merchant's header_variant asks for it
      // (data-top-invert), so a light hero keeps its dark logo + nav visible.
      const menuOpen = header.classList.contains('is-menu-open');
      if (header.classList.contains('is-overlay')){
        const wantTopInvert = header.dataset.topInvert === 'true';
        if (wantTopInvert && !menuOpen && !scrolled) header.classList.add('is-invert');
        else header.classList.remove('is-invert');
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
  function wireDesktopMenuKeys(){
    $$('.hh-nav__item').forEach(li => {
      const root = $('.hh-nav__link--root', li);
      const mega = $('.hh-mega', li);
      if (!root || !mega) return;
      // Hover intent with small open/close delay, pointer devices only
      const canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;
      let openTimer = null, closeTimer = null;
      function setShift(){
        // Align the dropdown content closer to the left side (HotDog-like)
        // Measure the inner container and shift it so its left edge sits near
        // the viewport safe margin (container padding), while clamping to edges.
        const dStyle = getComputedStyle(document.documentElement);
        const safeVar = dStyle.getPropertyValue('--hh-edge') || '16px';
        const safe = Math.max(8, parseInt(safeVar, 10) || 16); // px
        const vw = window.innerWidth;
        const prevVis = mega.style.visibility;
        // Reset shift for an accurate measurement
        mega.style.setProperty('--mega-shift', '0px');
        mega.style.visibility = 'hidden';
        const inner = mega.querySelector('.hh-mega__inner');
        const innerRect = inner ? inner.getBoundingClientRect() : mega.getBoundingClientRect();
        const innerWidth = innerRect.width;
        const currentLeft = innerRect.left;
        const minLeft = safe; // target left edge
        const maxLeft = vw - safe - innerWidth; // keep inside viewport
        // Target: left anchored near safe margin
        let targetLeft = minLeft;
        // Compute delta to move inner from currentLeft to targetLeft, with clamping
        targetLeft = Math.max(minLeft, Math.min(maxLeft, targetLeft));
        const delta = Math.round(targetLeft - currentLeft);
        mega.style.setProperty('--mega-shift', delta + 'px');
        mega.style.visibility = prevVis || '';
      }
      function anyOpen(){ return !!header.querySelector('.hh-nav__item.open'); }
      function open(){
        root.setAttribute('aria-expanded','true');
        li.classList.add('open');
        header.classList.add('is-menu-open');
        // allow layout to apply, then adjust position
        requestAnimationFrame(()=>{ setShift(); });
      }
      function close(){
        root.setAttribute('aria-expanded','false');
        li.classList.remove('open');
        if (!anyOpen()) { header.classList.remove('is-menu-open'); }
      }
      if (canHover){
        li.addEventListener('mouseenter', () => {
          header.classList.add('is-menu-open');
          clearTimeout(closeTimer);
          openTimer = setTimeout(()=>{ open(); setTimeout(setShift, 80); }, 80);
        });
        li.addEventListener('mouseleave', () => {
          clearTimeout(openTimer); closeTimer = setTimeout(close, 120);
        });
      }
      // When tabbing into the item, ensure position is clamped after it opens via :focus-within
      li.addEventListener('focusin', () => {
        clearTimeout(closeTimer);
        open();
        setTimeout(() => requestAnimationFrame(()=>{ setShift(); }), 0);
      });
      root.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowDown'){
          e.preventDefault();
          open();
          const first = mega.querySelector('a,button,[tabindex]:not([tabindex="-1"])');
          (first || root).focus();
        }
      });
      li.addEventListener('keydown', (e) => {
        if (e.key === 'Escape'){
          e.stopPropagation();
          close();
          root.focus();
        }
      });
      li.addEventListener('focusout', (e) => {
        if (!li.contains(e.relatedTarget)){
          clearTimeout(closeTimer);
          closeTimer = setTimeout(close, 100);
        }
      });
    });
  }

  // Sliding indicator under root nav links (desktop)
  function wireNavIndicator(){
    const nav = header ? $('.hh-nav', header) : null;
    if (!nav) return;
    const roots = $$('.hh-nav__link--root', nav);
    if (!roots.length) return;
    function setInd(el){
      if (!el) return;
      const navRect = nav.getBoundingClientRect();
      const r = el.getBoundingClientRect();
      nav.style.setProperty('--ind-left', (r.left - navRect.left) + 'px');
      nav.style.setProperty('--ind-width', r.width + 'px');
    }
    function clearInd(){ nav.style.setProperty('--ind-width','0px'); }
    clearInd();
    roots.forEach(a => {
      a.addEventListener('mouseenter', ()=> setInd(a));
      a.addEventListener('focus', ()=> setInd(a));
    });
    header.addEventListener('mouseleave', ()=> clearInd());
    let ciRaf = 0;
    window.addEventListener('resize', function(){ if (ciRaf) return; ciRaf = requestAnimationFrame(function(){ ciRaf = 0; clearInd(); }); }, { passive: true });
  }

  // Re-clamp any open mega menus on resize
  let clampTimer;
  window.addEventListener('resize', () => {
    clearTimeout(clampTimer);
    clampTimer = setTimeout(() => {
      $$('.hh-nav__item.open .hh-mega').forEach(mega => {
        const li = mega.closest('.hh-nav__item');
        if (!li) return;
        const dStyle = getComputedStyle(document.documentElement);
        const safeVar = dStyle.getPropertyValue('--hh-edge') || '16px';
        const safe = Math.max(8, parseInt(safeVar, 10) || 16);
        const vw = window.innerWidth;
        const prevVis = mega.style.visibility;
        mega.style.setProperty('--mega-shift','0px');
        mega.style.visibility = 'hidden';
        const inner = mega.querySelector('.hh-mega__inner');
        const innerRect = inner ? inner.getBoundingClientRect() : mega.getBoundingClientRect();
        const innerWidth = innerRect.width;
        const currentLeft = innerRect.left;
        const minLeft = safe;
        const maxLeft = vw - safe - innerWidth;
        const targetLeft = Math.max(minLeft, Math.min(maxLeft, minLeft));
        const delta = Math.round(targetLeft - currentLeft);
        mega.style.setProperty('--mega-shift', delta + 'px');
        mega.style.visibility = prevVis || '';
        setMegaTop(mega);
      });
    }, 120);
  }, { passive: true });

  /* Mobile drawer (Header navigation) */
  const drawer = header ? $('.hh-drawer', header) : null;
  const openBtn = header ? $('.hh-menu-toggle', header) : null;
  const closeBtn = header ? $('.hh-drawer__close', header) : null;
  const dim = header ? $('.hh-dim', header) : null;
  function lockPage(v){ body.classList.toggle('is-locked', !!v); }
  let focusTrapHandler = null;
  function trapFocus(container){
    releaseFocusTrap();
    const getFocusables = () => Array.from(container.querySelectorAll('a,button,input,select,textarea,[tabindex]:not([tabindex="-1"])')).filter(el=>!el.hasAttribute('disabled'));
    focusTrapHandler = (e) => {
      if (e.key !== 'Tab') return;
      const els = getFocusables();
      if (!els.length) return;
      const first = els[0], last = els[els.length-1];
      if (!container.contains(document.activeElement)){ e.preventDefault(); first.focus(); return; }
      if (e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
    };
    document.addEventListener('keydown', focusTrapHandler);
  }
  function releaseFocusTrap(){ if (focusTrapHandler){ document.removeEventListener('keydown', focusTrapHandler); focusTrapHandler = null; } }
  function openDrawer(){
    if(!drawer) return;
    drawer.hidden=false;
    if (dim) dim.hidden=false;
    drawer.classList.add('is-open');
    openBtn&&openBtn.setAttribute('aria-expanded','true');
    lockPage(true);
    setTimeout(()=>{ closeBtn&&closeBtn.focus(); trapFocus(drawer); },10);
  }
  function closeDrawer(){
    if(!drawer) return;
    drawer.classList.remove('is-open');
    openBtn&&openBtn.setAttribute('aria-expanded','false');
    lockPage(false);
    if (dim) dim.hidden=true;
    // Match the longer CSS transition for smoother close
    setTimeout(()=>{drawer.hidden=true; releaseFocusTrap(); try{ openBtn && openBtn.focus(); }catch(_){} },620);
  }
  function wireDrawer(){
    openBtn && openBtn.addEventListener('click', openDrawer);
    closeBtn && closeBtn.addEventListener('click', closeDrawer);
    dim && dim.addEventListener('click', closeDrawer);
    d.addEventListener('keydown', e => { if(e.key === 'Escape') closeDrawer(); });
  }

  /* Cart drawer */
  const cartDrawer = $('#CartDrawer');
  const cartDim = cartDrawer ? $('.hh-dim', cartDrawer) : null;
  const cartClose = cartDrawer ? $('.hh-drawer__close', cartDrawer) : null;
  const cartList = cartDrawer ? $('[data-cart-list]', cartDrawer) : null;
  const cartTotal = cartDrawer ? $('[data-cart-total]', cartDrawer) : null;
  const cartCountBadge = header ? $('[data-cart-count]', header) : null;
  const cartCountSr = header ? $('[data-cart-count-sr]', header) : null;
  const cartShip = cartDrawer ? $('[data-ship]', cartDrawer) : null;
  const cartShipMsg = cartDrawer ? $('[data-ship-msg]', cartDrawer) : null;
  // Cycle 201: bind the VISIBLE top free-shipping estimator rendered by
  // snippets/cart-drawer.liquid via the hh-shipping-estimator snippet. The
  // legacy [data-ship] block (above) is an orphan we leave intact for
  // back-compat; the user-facing element is [data-cart-ship-top].
  const cartShipTop = cartDrawer ? $('[data-cart-ship-top]', cartDrawer) : null;
  let cartOpenerEl = null;

  function openCartDrawer(){
    if (!cartDrawer) return;
    cartOpenerEl = document.activeElement;
    cartDrawer.hidden = false;
    if (cartDim) cartDim.hidden = false;
    cartDrawer.classList.add('is-open');
    lockPage(true);
    setTimeout(()=>{ cartClose && cartClose.focus(); trapFocus(cartDrawer); }, 10);
    // Cycle 1 :: HH.events :: emit cart_open for programmatic opens.
    // Attribute-driven opens (cart icon click) also fire from data-hh-event,
    // so listeners may see two events; consumers should dedupe by ts if needed.
    try { if (window.HH && window.HH.events) window.HH.events.track('cart_open', { source: 'programmatic' }); } catch(_e){}
  }
  function closeCartDrawer(){
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    lockPage(false);
    if (cartDim) cartDim.hidden = true;
    setTimeout(()=>{ cartDrawer.hidden = true; releaseFocusTrap(); try{ cartOpenerEl && cartOpenerEl.focus(); }catch(_){} }, 360);
  }

  /* Cycle 19: add-to-cart toast (pet-wag + "Added to your pack").
     Singleton; repeated calls restart the 1800ms timer. */
  let hhToastTimer = null;
  let hhToastEyebrowDefault = null;
  function showAddedToast(title){
    const toast = d.querySelector('.hh-toast');
    if (!toast) return;
    const ebReset = toast.querySelector('.hh-toast__eyebrow');
    if (hhToastEyebrowDefault === null && ebReset) hhToastEyebrowDefault = ebReset.textContent;
    toast.classList.remove('hh-toast--error');
    if (ebReset && hhToastEyebrowDefault !== null) ebReset.textContent = hhToastEyebrowDefault;
    const titleEl = toast.querySelector('[data-hh-toast-title]');
    const petSlot = toast.querySelector('.hh-toast__pet');
    const tpl = d.querySelector('#hh-toast-pet-tpl');
    if (petSlot && tpl && !petSlot.firstElementChild){
      // Clone the pet-wag template once; keeps the tail wagging for the life of the page.
      const frag = tpl.content ? tpl.content.cloneNode(true) : null;
      if (frag) petSlot.appendChild(frag);
    }
    if (titleEl){
      titleEl.textContent = (title && String(title).trim()) || 'Item added';
    }
    // Restart timer on repeated adds
    toast.classList.add('is-visible');
    if (hhToastTimer){ clearTimeout(hhToastTimer); }
    hhToastTimer = setTimeout(() => {
      toast.classList.remove('is-visible');
      hhToastTimer = null;
    }, 1800);
  }
  // Allow other modules/sections to trigger the toast without coupling to ATC internals.
  d.addEventListener('hh:cart:added', (e) => {
    const t = e && e.detail && e.detail.title;
    showAddedToast(t);
  });
  // Render the F-03 add-to-cart failure feedback: hh:toast was dispatched
  // (global.js add-guards) but had no consumer, so failed adds were silent.
  if (!d.__hhToastErrBound){
    d.__hhToastErrBound = true;
    d.addEventListener('hh:toast', (e) => {
      const det = (e && e.detail) || {};
      if (det.kind && det.kind !== 'error') return;
      const msg = (det.message && String(det.message).trim()) || 'Could not add to cart.';
      const toast = d.querySelector('.hh-toast');
      if (toast){
        const ebEl = toast.querySelector('.hh-toast__eyebrow');
        if (hhToastEyebrowDefault === null && ebEl) hhToastEyebrowDefault = ebEl.textContent;
        const titleEl = toast.querySelector('[data-hh-toast-title]');
        if (ebEl) ebEl.textContent = 'That did not go through';
        if (titleEl) titleEl.textContent = msg;
        toast.classList.add('hh-toast--error', 'is-visible');
        if (hhToastTimer){ clearTimeout(hhToastTimer); }
        hhToastTimer = setTimeout(() => {
          toast.classList.remove('is-visible', 'hh-toast--error');
          if (ebEl && hhToastEyebrowDefault !== null) ebEl.textContent = hhToastEyebrowDefault;
          hhToastTimer = null;
        }, 4000);
      }
      const live = d.getElementById('hh-live-assertive');
      if (live){ live.textContent = ''; live.textContent = msg; }
    });
  }

  async function refreshCart(){
    try{
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      // AUDIT-CODEX.md F-06: validate response before parsing JSON. Shopify can
      // serve a throttled HTML error page that would otherwise fall into a
      // console-only failure with no user feedback.
      if (!res.ok){
        console.error('refreshCart: non-OK status', res.status);
        return;
      }
      const cart = await res.json();
      if (cartList){
        const emptyPanel = cartDrawer ? cartDrawer.querySelector('.hh-cart-drawer__empty') : null;
        if (!cart.items || cart.items.length === 0){
          // Cycle 14: canonical empty markup lives in the snippet. Toggle it,
          // don't inject a text string.
          while (cartList.firstChild) cartList.removeChild(cartList.firstChild);
          if (emptyPanel){
            emptyPanel.hidden = false;
            cartList.hidden = true;
          } else {
            // Fallback for themes without the new empty block
            const emptyText = cartList.getAttribute('data-empty-text') || 'Your cart is empty';
            const p = document.createElement('p');
            p.className = 'hh-cart__empty';
            p.textContent = emptyText;
            cartList.hidden = false;
            cartList.appendChild(p);
          }
        } else {
          if (emptyPanel) emptyPanel.hidden = true;
          cartList.hidden = false;
          const t = (window.theme && theme.strings) || {};
          // AUDIT.md CR-2: escape every merchant/shopper-controlled string before
          // composing the cart-drawer markup. Use the module-scope escapeHtml.
          const cartHtml = cart.items.map((item, idx) => {
            const linePrice = window.hhFormatMoney ? window.hhFormatMoney(item.final_line_price) : (item.final_line_price/100).toFixed(2);
            const safeKey = escapeHtml(item.key);
            const safeTitle = escapeHtml(item.product_title);
            const safeImg = escapeHtml(item.image || '');
            const safeVariantTitle = escapeHtml(item.variant_title || '');
            const safeQty = escapeHtml(item.quantity);
            const img = item.image ? `<img src="${safeImg}" alt="" loading="lazy">` : '';
            const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<p class=\"hh-cart__sub\">${safeVariantTitle}</p>` : '';
            const removeText = escapeHtml(t.cart_remove || 'Remove');
            const removeLabelRaw = t.cart_remove ? `${t.cart_remove} ${item.product_title}` : `Remove ${item.product_title}`;
            const removeLabel = escapeHtml(removeLabelRaw);
            const qtyLabel = escapeHtml(t.quantity || 'Quantity');
            const decLabel = escapeHtml(t.cart_qty_decrease || 'Decrease quantity');
            const incLabel = escapeHtml(t.cart_qty_increase || 'Increase quantity');
            return `
              <div class=\"hh-cart__item\" data-key=\"${safeKey}\" data-hh-cart-line style=\"--li: ${idx < 12 ? idx : idx % 12}\">
                <div class=\"hh-cart__thumb\">${img}</div>
                <div class=\"hh-cart__meta\">
                  <p class=\"hh-cart__title\">${safeTitle}</p>
                  ${variant}
                  <button class=\"hh-cart__remove\" data-remove aria-label=\"${removeLabel}\">${removeText}</button>
                </div>
                <div class=\"hh-cart__qty\">
                  <button class=\"hh-qtybtn\" data-dec aria-label=\"${decLabel}\">−</button>
                  <input class=\"hh-qtyinput\" type=\"number\" min=\"0\" value=\"${safeQty}\" aria-label=\"${qtyLabel}\">
                  <button class=\"hh-qtybtn\" data-inc aria-label=\"${incLabel}\">+</button>
                  <div class=\"hh-cart__line\">${linePrice}</div>
                </div>
              </div>`;
          }).join('');
          cartList.innerHTML = cartHtml;
        }
      }
      if (cartTotal){
        const total = window.hhFormatMoney ? window.hhFormatMoney(cart.total_price) : (cart.total_price/100).toFixed(2);
        cartTotal.textContent = total;
      }
      // Cycle 266 :: notify HH.cartDrawer to re-bind magnetic + microinteractions on new lines
      try { d.dispatchEvent(new CustomEvent('cart:refresh', { detail: { count: (cart.items || []).length, source: 'refreshCart' } })); } catch(_e){}
      // Free shipping progress
      if (cartShip){
        const thresholdMajor = parseFloat($('.hh-drawer__content', cartDrawer)?.getAttribute('data-freeship') || '0');
        const thresholdMinor = Math.round((isNaN(thresholdMajor)?0:thresholdMajor) * 100);
        if (thresholdMinor > 0){
          cartShip.hidden = false;
          const pct = Math.max(0, Math.min(100, Math.round((cart.total_price / thresholdMinor) * 100)));
          const fill = cartShip.querySelector('.hh-ship__fill');
          if (fill) fill.style.width = pct + '%';
          if (cartShipMsg){
            if (cart.total_price >= thresholdMinor){
              cartShipMsg.textContent = (window.theme && theme.strings && theme.strings.cart_free_shipping_unlocked) || 'Free shipping, sorted.';
            } else {
              const remainMinor = Math.max(0, thresholdMinor - cart.total_price);
              const remainText = window.hhFormatMoney ? window.hhFormatMoney(remainMinor) : (remainMinor/100).toFixed(2);
              const base = (window.theme && theme.strings && theme.strings.cart_free_shipping_progress) || 'You are {amount} away from free shipping.';
              cartShipMsg.textContent = base.replace('{amount}', remainText);
            }
          }
        } else {
          cartShip.hidden = true;
        }
      }
      // Cycle 201: keep the visible top estimator (snippets/cart-drawer.liquid
      // line 14, [data-cart-ship-top]) in sync after AJAX cart updates.
      // Mirrors snippets/hh-shipping-estimator.liquid output exactly:
      //   - empty cart OR threshold<=0  => render nothing (matches outer guard)
      //   - below threshold             => msg "Add {money} for free shipping" + bar
      //   - complete                    => msg with check icon + completion line
      // Approach: rebuild-on-every-refresh of the small <aside> fragment. The
      // check icon SVG mirrors snippets/hh-icon.liquid name='check' size=18.
      // XSS-safe: numeric cart totals only; currency is escapeHtml-wrapped;
      // money string from Shopify.formatMoney is theme-controlled, not shopper.
      if (cartShipTop){
        const thresholdMajorTop = parseFloat($('.hh-drawer__content', cartDrawer)?.getAttribute('data-freeship') || '0');
        const thresholdMinorTop = Math.round((isNaN(thresholdMajorTop) ? 0 : thresholdMajorTop) * 100);
        const itemCount = cart.item_count || (cart.items || []).reduce((n, it) => n + it.quantity, 0);
        if (itemCount <= 0 || thresholdMinorTop <= 0){
          // Outer guard in the snippet renders nothing in these states.
          cartShipTop.innerHTML = '';
        } else {
          const totalMinor = cart.total_price || 0;
          let pctTop = Math.round((totalMinor / thresholdMinorTop) * 100);
          if (pctTop < 0) pctTop = 0;
          if (pctTop > 100) pctTop = 100;
          const complete = totalMinor >= thresholdMinorTop;
          const currency = (cart.currency) || ((window.Shopify && Shopify.currency && Shopify.currency.active) || '');
          const safeCurrency = escapeHtml(currency || '');
          const APOS = String.fromCharCode(8217);
          let msgInner;
          if (complete){
            msgInner = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" class="hh-icon hh-icon--check" aria-hidden="true" focusable="false"><path d="M20 6L9 17l-5-5"/></svg><span>Free shipping' + APOS + 's on us. Nice work.</span>';
          } else {
            const remainMinor = Math.max(0, thresholdMinorTop - totalMinor);
            const remainText = window.hhFormatMoney ? window.hhFormatMoney(remainMinor) : (remainMinor / 100).toFixed(2);
            msgInner = '<span>Add ' + remainText + ' for free shipping</span>';
          }
          // No data-hh-reveal: the bar is always in view while the cart is
          // open, so it must not depend on the scroll IntersectionObserver
          // (which never re-binds after this AJAX swap) or it stays invisible
          // at opacity 0 (c201-p2b).
          const html =
            '<aside class="hh-ship' + (complete ? ' hh-ship--complete' : '') + '" role="status" data-currency="' + safeCurrency + '">' +
              '<p class="hh-ship__msg">' + msgInner + '</p>' +
              '<div class="hh-ship__bar" aria-hidden="true">' +
                '<span class="hh-ship__fill" style="width: ' + pctTop + '%"></span>' +
              '</div>' +
            '</aside>';
          // Gate the role=status live region: only rewrite when the rendered
          // markup actually changes, so qty tweaks that don't move the shipping
          // state don't spuriously re-announce (c201-p2a).
          if (cartShipTop.dataset.hhShipHtml !== html){
            cartShipTop.dataset.hhShipHtml = html;
            cartShipTop.innerHTML = html;
          }
        }
      }
      if (cartCountBadge){
        const count = (cart.items || []).reduce((n, it) => n + it.quantity, 0);
        if (count > 0){ cartCountBadge.textContent = String(count); cartCountBadge.hidden = false; }
        else { cartCountBadge.hidden = true; }
        if (cartCountSr){ cartCountSr.textContent = count + ' items in cart'; }
      }
    }catch(err){ console.error('Cart refresh error', err); }
  }
  async function changeCartQuantity(key, quantity){
    try{
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
      });
      // AUDIT-CODEX.md F-05: don't refresh + emit cart_updated when the change
      // failed. Otherwise the UI implies the new qty was accepted.
      if (!res.ok){
        console.error('Change qty failed:', res.status);
        return;
      }
      await refreshCart();
      // Cycle 1 :: HH.events :: cart_updated after qty change/remove.
      try { if (window.HH && window.HH.events) window.HH.events.track('cart_updated', { source: quantity === 0 ? 'remove' : 'update', key: key, quantity: quantity }); } catch(_e){}
    }catch(err){ console.error('Change qty failed', err); }
  }
  function wireCart(){
    if (cartClose) cartClose.addEventListener('click', closeCartDrawer);
    if (cartDim) cartDim.addEventListener('click', closeCartDrawer);
    const cartLink = header ? $('a[href*="/cart"]', header) : null;
    if (cartLink){
      cartLink.addEventListener('click', async (e) => {
        e.preventDefault();
        await refreshCart();
        openCartDrawer();
      });
    }
    d.addEventListener('keydown', e => { if(e.key === 'Escape') closeCartDrawer(); });
    if (cartList){
      cartList.addEventListener('click', (e) => {
        const itemEl = e.target.closest('[data-key]');
        if (!itemEl) return;
        const key = itemEl.getAttribute('data-key');
        const input = itemEl.querySelector('.hh-qtyinput');
        if (e.target.matches('[data-inc]')) {
          const next = (parseInt(input.value || '0',10) + 1);
          changeCartQuantity(key, next);
        } else if (e.target.matches('[data-dec]')) {
          const next = (parseInt(input.value || '0',10) - 1);
          changeCartQuantity(key, next);
        } else if (e.target.hasAttribute('data-remove')){
          changeCartQuantity(key, 0);
        }
      });
      cartList.addEventListener('change', (e) => {
        const itemEl = e.target.closest('[data-key]');
        if (!itemEl) return;
        if (e.target.matches('.hh-qtyinput')){
          const key = itemEl.getAttribute('data-key');
          const val = parseInt(e.target.value || '0', 10);
          changeCartQuantity(key, val);
        }
      });
    }
    // Success micro-confirm :: spring-pop a check stamp on the ATC button after a
    // confirmed add. Injected (not in markup) so updateUI's textContent rewrites
    // can't wipe it. Skipped under reduced-motion (the toast still announces).
    function showAtcConfirm(btn){
      if (!btn) return;
      try{ if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return; }catch(_){}
      var stamp = d.createElement('span');
      stamp.className = 'hh-atc-stamp';
      stamp.setAttribute('aria-hidden', 'true');
      stamp.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 13l4 4L19 7"/></svg>';
      btn.classList.add('is-added');
      btn.appendChild(stamp);
      setTimeout(function(){ btn.classList.remove('is-added'); if (stamp.parentNode) stamp.parentNode.removeChild(stamp); }, 1100);
    }

    const productForm = d.getElementById('ProductForm');
    if (productForm){
      productForm.addEventListener('submit', async (e) => {
        try{
          e.preventDefault();
          const fd = new FormData(productForm);
          const resp = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', 'Accept': 'application/json' },
            body: new URLSearchParams(fd).toString()
          });
          // AUDIT-CODEX.md F-03: do not refresh + open the drawer when the
          // add failed (sold-out, invalid variant, rate-limited). Surface the
          // error to the user instead of pretending success.
          if (!resp.ok){
            let errMsg = 'Could not add to cart.';
            try{
              const errData = await resp.clone().json();
              if (errData && errData.description) errMsg = errData.description;
            }catch(_){}
            console.error('cart/add failed:', resp.status, errMsg);
            try{ d.dispatchEvent(new CustomEvent('hh:toast', { detail: { message: errMsg, kind: 'error' } })); }catch(_){}
            return;
          }
          // Parse title from response; fall back to the product page heading.
          let addedTitle = '';
          try{
            const data = await resp.clone().json();
            addedTitle = (data && (data.product_title || data.title)) || '';
          }catch(_){}
          if (!addedTitle){
            const h = d.querySelector('.hh-product__title');
            if (h) addedTitle = (h.textContent || '').trim();
          }
          await refreshCart();
          showAtcConfirm(productForm.querySelector('button[type="submit"]'));
          openCartDrawer();
          showAddedToast(addedTitle);
          // Cycle 1 :: HH.events :: cart_updated after PDP add.
          try { if (window.HH && window.HH.events) window.HH.events.track('cart_updated', { source: 'add', surface: 'pdp', title: addedTitle }); } catch(_e){}
        }catch(err){ console.error('Add to cart failed', err); }
      });
    }
    // Quick add on product cards
    d.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-quick-add]');
      if (!btn) return;
      e.preventDefault();
      const id = btn.getAttribute('data-quick-add');
      try{
        const resp = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', 'Accept': 'application/json' },
          body: new URLSearchParams({ id, quantity: 1 }).toString()
        });
        // AUDIT-CODEX.md F-03 (quick-add parity): do not refresh + open the
        // drawer or emit cart_updated when the add failed (sold-out, invalid
        // variant, rate-limited). Surface the error instead of a phantom add.
        if (!resp.ok){
          let errMsg = 'Could not add to cart.';
          try{
            const errData = await resp.clone().json();
            if (errData && errData.description) errMsg = errData.description;
          }catch(_){}
          console.error('quick-add failed:', resp.status, errMsg);
          try{ d.dispatchEvent(new CustomEvent('hh:toast', { detail: { message: errMsg, kind: 'error' } })); }catch(_){}
          return;
        }
        // Parse title from response; fall back to the card title (product-card.liquid line 26).
        let addedTitle = '';
        try{
          const data = await resp.clone().json();
          addedTitle = (data && (data.product_title || data.title)) || '';
        }catch(_){}
        if (!addedTitle){
          const card = btn.closest('.hh-card, [data-product-card]') || btn.closest('article, li, div');
          const t = card ? card.querySelector('.hh-card__title') : null;
          if (t) addedTitle = (t.textContent || '').trim();
        }
        await refreshCart();
        openCartDrawer();
        showAddedToast(addedTitle);
        // c172 :: HH.events :: paired cart_add + cart_updated after quick-add from card (mirrors sticky-ATC c155).
        try { if (window.HH && window.HH.events) { window.HH.events.track('cart_add', { variant_id: id, surface: 'quick_add', title: addedTitle }); window.HH.events.track('cart_updated', { source: 'add', surface: 'quick_add', variant_id: id, title: addedTitle }); } } catch(_e){}
      }catch(err){ console.error('Quick add failed', err); }
    });
  }

  /* Mobile submenu accordions */
  function wireMobileSubmenus() {
    $$('.hh-nav-mobile .hh-nav__item').forEach(li => {
      const toggle = $('.hh-subtoggle', li);
      const submenu = $('.hh-submenu', li);
      if (submenu){
        li.classList.add('has-children');
        function setOpen(v){
          li.classList.toggle('open', !!v);
          if (toggle) toggle.setAttribute('aria-expanded', v ? 'true' : 'false');
          if (v) submenu.removeAttribute('hidden'); else submenu.setAttribute('hidden','');
        }
        function handleToggle(e){
          e.preventDefault();
          setOpen(!li.classList.contains('open'));
        }
        // Chevron is the sole submenu disclosure control; the parent
        // label <a> keeps its native navigation to the category page.
        toggle && toggle.addEventListener('click', handleToggle);
        // Optional: tapping the row (outside submenu) toggles
        li.addEventListener('click', (e)=>{
          if (!submenu.contains(e.target) && (e.target === li)){
            handleToggle(e);
          }
        });
      }
    });
  }

  function init(){
    setTopPadding();      // compute immediately
    watchTopwrap();       // stay in sync if height changes
    disableStickyIfNeeded();
    wireScrolledState();
    wireDesktopMenuKeys();
    wireNavIndicator();
    wireDrawer();
    wireCart();
    wireMobileSubmenus();
    try{ preventTopBounce(); }catch(_){ }
  }

  // Run ASAP (no waiting for window load)
  if (d.readyState !== 'loading') init();
  else d.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', setTopPadding);   // final pass after images/fonts
  window.addEventListener('resize', onTopResize, { passive: true }); // keep accurate on resize (rAF-coalesced, passive)
})();

/* Predictive search overlay */
(function(){
  const d = document;
  const $ = (s, c = d) => c.querySelector(s);
  const overlay = $('#HHSearch');
  if (!overlay) return;
  if (overlay.dataset.hhSearchWired === '1') return;
  overlay.dataset.hhSearchWired = '1';
  const panel = $('.hh-searchdlg__panel', overlay);
  const input = $('#HHSearchInput', overlay);
  const results = $('[data-search-results]', overlay);
  const closeBtn = $('.hh-searchdlg__close', overlay);
  const dim = $('.hh-dim', overlay);
  const header = $('.hh-header');
  // AUDIT-CODEX.md F-08: bind the overlay-open handler to every header /search
  // link, not just the first one. Mobile + desktop have separate links and
  // their order in the DOM has flipped historically; binding only the first
  // match meant desktop search would navigate to /search instead of opening
  // the overlay.
  // Scope to the dedicated search anchors only. The old 'a[href*="/search"]' substring
  // match also caught the Adoptions menu link (/blogs/searching-for-housemate), hijacking
  // it to open the overlay instead of navigating. href$="/search" matches the real search
  // links (incl. locale prefixes like /en/search) and excludes "-housemate".
  const headerSearchLinks = header ? Array.from(header.querySelectorAll('a[data-hh-search-open], a[href$="/search"]')) : [];
  const headerSearchLink = headerSearchLinks[0] || null;
  const prefersReduce = () => window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Merchant-configurable endpoints from server-rendered data-attrs
  const SHOP_ALL_URL = overlay.getAttribute('data-shop-all-url') || '/collections/all';
  const CONTACT_URL = overlay.getAttribute('data-contact-url') || '/pages/contact';
  const FEATURED_URL = overlay.getAttribute('data-featured-collection-url') || '';
  const FEATURED_TITLE = overlay.getAttribute('data-featured-collection-title') || '';

  // Snapshot the server-rendered empty state so we can restore it on reopen
  const emptyEl = results.querySelector('[data-search-empty]');
  const EMPTY_HTML = emptyEl ? emptyEl.outerHTML : `<p class="hh-searchdlg__hint">${input ? input.placeholder : 'Search'}</p>`;

  let lastTrigger = null;

  function escapeHtml(s){ return String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c])); }
  function getFocusables(){ return Array.from(panel.querySelectorAll('a,button,input,select,textarea,[tabindex]:not([tabindex="-1"])')).filter(el=>!el.hasAttribute('disabled') && el.offsetParent !== null); }
  const RECENT_KEY = 'hh_recent_searches';
  function getRecent(){ try{ return JSON.parse(localStorage.getItem(RECENT_KEY)||'[]'); }catch(_){ return []; } }
  function addRecent(q){ try{ if(!q) return; const arr = getRecent().filter(x=>x.toLowerCase()!==q.toLowerCase()); arr.unshift(q); localStorage.setItem(RECENT_KEY, JSON.stringify(arr.slice(0,5))); }catch(_){} }

  function renderEmpty(){
    const recent = getRecent();
    const recentHtml = recent.length
      ? `<div class="hh-searchdlg__group"><p class="hh-searchdlg__label">Recent</p>${recent.map(q=>`<a class="hh-searchdlg__item" href="/search?q=${encodeURIComponent(q)}">${escapeHtml(q)}</a>`).join('')}</div>`
      : '';
    results.innerHTML = recentHtml + EMPTY_HTML;
  }
  function open(trigger){
    lastTrigger = trigger || d.activeElement || null;
    overlay.hidden = false;
    if (dim) dim.hidden = false;
    void overlay.offsetWidth; // force reflow so transition plays next frame
    overlay.classList.add('is-open');
    d.body.classList.add('is-locked');
    renderEmpty();
    const delay = prefersReduce() ? 0 : 20;
    setTimeout(()=> input && input.focus(), delay);
  }
  function close(){
    overlay.classList.remove('is-open');
    d.body.classList.remove('is-locked');
    const done = () => {
      if (dim) dim.hidden = true;
      overlay.hidden = true;
      if (lastTrigger && typeof lastTrigger.focus === 'function'){
        try { lastTrigger.focus(); } catch(_){}
      }
      lastTrigger = null;
    };
    if (prefersReduce()) done();
    else setTimeout(done, 260);
  }

  function wire(){
    headerSearchLinks.forEach((link)=>{
      link.addEventListener('click', (e)=>{ e.preventDefault(); open(link); });
    });
    closeBtn && closeBtn.addEventListener('click', close);
    dim && dim.addEventListener('click', close);

    // Document-level keys: ESC closes; "/" opens when not in an input/editable
    d.addEventListener('keydown', (e)=>{
      if (e.key === 'Escape' && !overlay.hidden){ close(); return; }
      if (e.key === '/' && overlay.hidden && !e.ctrlKey && !e.metaKey && !e.altKey){
        const tgt = e.target;
        const tag = tgt && tgt.tagName ? tgt.tagName.toLowerCase() : '';
        const editable = tgt && (tgt.isContentEditable || ['input','textarea','select'].includes(tag));
        if (editable) return;
        e.preventDefault();
        open(tgt && tgt.focus ? tgt : null);
      }
    });

    let t;
    input && input.addEventListener('input', ()=>{
      clearTimeout(t);
      const q = input.value.trim();
      if (!q){ renderEmpty(); return; }
      loading();
      t = setTimeout(()=> suggest(q), 160);
    });

    // Focus trap + arrow nav + enter-select
    panel.addEventListener('keydown', (e)=>{
      if (e.key === 'Tab'){
        const els = getFocusables();
        if (!els.length) return;
        const first = els[0], last = els[els.length-1];
        const active = d.activeElement;
        if (e.shiftKey && active === first){ e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && active === last){ e.preventDefault(); first.focus(); }
      }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp'){
        e.preventDefault();
        const items = Array.from(results.querySelectorAll('.hh-searchdlg__item'));
        if (!items.length) return;
        let idx = items.findIndex(el => el.classList.contains('is-active'));
        if (idx < 0) idx = -1;
        items.forEach(el => el.classList.remove('is-active'));
        if (e.key === 'ArrowDown') idx = Math.min(idx + 1, items.length - 1);
        else idx = Math.max(idx - 1, 0);
        const target = items[idx];
        if (target){ target.classList.add('is-active'); target.focus(); }
      }
      if (e.key === 'Enter'){
        const active = results.querySelector('.hh-searchdlg__item.is-active');
        if (active){ addRecent(input.value.trim()); window.location.href = active.getAttribute('href'); }
      }
    });
    const form = panel.querySelector('form');
    form && form.addEventListener('submit', ()=> addRecent(input.value.trim()));
  }
  // Escape the source text first so attacker-controlled product titles can't
  // smuggle markup; only the <mark> wrapper around matches stays as raw HTML.
  function highlight(text, q){ try{ const safe = escapeHtml(text); if(!q) return safe; const re = new RegExp(`(${q.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')})`,'ig'); return safe.replace(re,'<mark>$1</mark>'); }catch(_){ return escapeHtml(text); } }
  function loading(){ results.innerHTML = `<div class="hh-searchdlg__group"><div class="hh-skel" style="height:16px;margin:8px 0"></div><div class="hh-skel" style="height:16px;margin:8px 0"></div><div class="hh-skel" style="height:16px;margin:8px 0"></div></div>`; }
  function noResultsHtml(q){
    const noResLabel = (window.theme && theme.strings && theme.strings.general_quick_search_no_results) || 'Nothing fetched.';
    const body = `We came back empty-pawed for &ldquo;${escapeHtml(q)}&rdquo;. Try a different word, or wander somewhere cosy instead.`;
    const shopBtn = `<a class="hh-searchdlg__cta hh-searchdlg__cta--primary" href="${escapeHtml(SHOP_ALL_URL)}">Shop all</a>`;
    const featBtn = (FEATURED_URL && FEATURED_TITLE) ? `<a class="hh-searchdlg__cta" href="${escapeHtml(FEATURED_URL)}">${escapeHtml(FEATURED_TITLE)}</a>` : '';
    const contactBtn = `<a class="hh-searchdlg__cta" href="${escapeHtml(CONTACT_URL)}">Ask a human</a>`;
    return `<div class="hh-searchdlg__noresults" role="status" aria-live="polite">`
      + `<p class="hh-searchdlg__label">${escapeHtml(noResLabel)}</p>`
      + `<p class="hh-searchdlg__nohint">${body}</p>`
      + `<div class="hh-searchdlg__ctas">${shopBtn}${featBtn}${contactBtn}</div>`
      + `</div>`;
  }
  let __suggestSeq = 0;
  async function suggest(q){
    if (!q){ renderEmpty(); return; }
    const myId = ++__suggestSeq;
    try{
      const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,article,page&resources[limit]=5`;
      const res = await fetch(url, { headers: { 'Accept': 'application/json' }});
      if (myId !== __suggestSeq) return; // a newer keystroke superseded this response
      if (!res.ok){ results.innerHTML = noResultsHtml(q); return; }
      const data = await res.json();
      if (myId !== __suggestSeq) return;
      const rootRes = (data && data.resources) || {};
      // Shopify nests predictive results under resources.results.{products,pages,articles};
      // older shapes put them directly on resources. Read results first, fall back to root.
      const resources = rootRes.results || rootRes;
      const html = [
        renderGroup('Products', resources.products || [], (p)=>{
          const safeUrl = escapeHtml(p.url || '');
          const img = (p.image && p.image) ? `<img class="hh-sugg__img" src="${escapeHtml(p.image)}" alt="" loading="lazy">` : '';
          const price = (typeof p.price !== 'undefined' && window.hhFormatMoney) ? `<span class="hh-sugg__price">${window.hhFormatMoney(p.price)}</span>` : '';
          const showMeta = !window.theme || !theme.settings || theme.settings.search_show_vendor_type !== false;
          const metaText = [p.vendor, p.type].filter(Boolean).join(', ');
          const meta = showMeta && metaText ? `<span class="hh-sugg__meta">${escapeHtml(metaText)}</span>` : '';
          return `<a class="hh-searchdlg__item hh-sugg" href="${safeUrl}">${img}<span class="hh-sugg__title">${highlight(p.title, q)}</span>${meta}${price}</a>`;
        }),
        renderGroup('Pages', resources.pages || [], (p)=>`<a class="hh-searchdlg__item" href="${escapeHtml(p.url || '')}">${highlight(p.title, q)}</a>`),
        renderGroup('Articles', resources.articles || [], (p)=>`<a class="hh-searchdlg__item" href="${escapeHtml(p.url || '')}">${highlight(p.title, q)}</a>`)
      ].filter(Boolean).join('');
      results.innerHTML = html || noResultsHtml(q);
    }catch(err){
      console.error('Predictive search error', err);
      if (myId === __suggestSeq){ results.innerHTML = noResultsHtml(q); }
    }
  }
  function renderGroup(label, items, tpl){
    if (!items || !items.length) return '';
    const list = items.map(tpl).join('');
    return `<div class="hh-searchdlg__group"><p class="hh-searchdlg__label">${label}</p>${list}</div>`;
  }
  if (d.readyState !== 'loading') wire(); else d.addEventListener('DOMContentLoaded', wire);
})();

/* =========================================================
   HH motion primitives :: reveal / parallax / cursor magnet / hero cue
   Exposed on window.HH so sections can opt in via data attrs:
     data-hh-reveal="up|fade|left|scale"   → fade+slide on enter viewport
     data-hh-parallax="0.25"               → translateY at speed × scrollY
     data-hh-magnet                        → cursor-attraction hover (desktop)
   All respect prefers-reduced-motion.
   ========================================================= */
(function(){
  const d = document;
  const prefersReduce = () => window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const canHover = () => window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---- reveal: IntersectionObserver-based fade/slide ---- */
  function reveal(root = d){
    const els = Array.from(root.querySelectorAll('[data-hh-reveal]'));
    if (!els.length) return;
    if (prefersReduce()){
      els.forEach(el => el.classList.add('is-visible'));
      return;
    }
    if (!('IntersectionObserver' in window)){
      els.forEach(el => el.classList.add('is-visible'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting){
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(el => io.observe(el));
  }

  /* ---- parallax: rAF-throttled translateY on scroll ---- */
  let parallaxEls = [];
  let parallaxTicking = false;
  function parallaxFrame(){
    const y = window.scrollY || window.pageYOffset || 0;
    for (let i = 0; i < parallaxEls.length; i++){
      const { el, speed } = parallaxEls[i];
      const rect = el.getBoundingClientRect();
      // Only transform when element is near the viewport
      if (rect.bottom < -200 || rect.top > window.innerHeight + 200) continue;
      const offset = (rect.top + y - (window.innerHeight * 0.5)) * speed * -1;
      el.style.transform = `translate3d(0, ${offset.toFixed(1)}px, 0)`;
    }
    parallaxTicking = false;
  }
  function parallax(root = d){
    if (prefersReduce()) return;
    parallaxEls = Array.from(root.querySelectorAll('[data-hh-parallax]')).map(el => ({
      el,
      speed: parseFloat(el.getAttribute('data-hh-parallax')) || 0.2
    }));
    if (!parallaxEls.length) return;
    const onScroll = () => {
      if (parallaxTicking) return;
      parallaxTicking = true;
      requestAnimationFrame(parallaxFrame);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    parallaxFrame(); // initial position
  }

  /* ---- cursor magnet: soft translate toward pointer (desktop only) ---- */
  function cursorMagnet(root = d){
    if (prefersReduce() || !canHover()) return;
    const els = Array.from(root.querySelectorAll('[data-hh-magnet]'));
    els.forEach(el => {
      const strength = parseFloat(el.getAttribute('data-hh-magnet')) || 12;
      let rafId = null;
      function onMove(e){
        const r = el.getBoundingClientRect();
        const cx = r.left + r.width / 2;
        const cy = r.top + r.height / 2;
        const dx = (e.clientX - cx) / r.width;
        const dy = (e.clientY - cy) / r.height;
        cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(() => {
          el.style.transform = `translate(${(dx * strength).toFixed(1)}px, ${(dy * strength).toFixed(1)}px)`;
        });
      }
      function reset(){ cancelAnimationFrame(rafId); el.style.transform = ''; }
      el.addEventListener('pointermove', onMove);
      el.addEventListener('pointerleave', reset);
      el.addEventListener('blur', reset);
    });
  }

  /* ---- hero scroll cue: fade after 3s or first user scroll ---- */
  function heroCue(){
    const cue = d.querySelector('[data-hh-cue]');
    if (!cue) return;
    let hidden = false;
    const hide = () => {
      if (hidden) return;
      hidden = true;
      cue.classList.add('is-hidden');
      window.removeEventListener('scroll', onScroll);
      clearTimeout(timer);
    };
    const onScroll = () => { if ((window.scrollY || 0) > 30) hide(); };
    const timer = setTimeout(hide, 3200);
    window.addEventListener('scroll', onScroll, { passive: true });
    cue.addEventListener('click', () => {
      const next = d.querySelector('.hh-hero') ? d.querySelector('.hh-hero').nextElementSibling : null;
      if (next) next.scrollIntoView({ behavior: prefersReduce() ? 'auto' : 'smooth', block: 'start' });
      hide();
    });
  }

  /* ---- boot ---- */
  function boot(){ reveal(); parallax(); cursorMagnet(); heroCue(); }
  window.HH = Object.assign(window.HH || {}, { reveal, parallax, cursorMagnet, heroCue });
  if (d.readyState !== 'loading') boot(); else d.addEventListener('DOMContentLoaded', boot);
})();

/* Prevent rubber-band bounce above first section sitewide
   (keeps header/drawer interactions reliable when scrolled to very top). */
(function(){
  const body = document.body;
  function preventTopBounce(){
    if (window.__hhBounceGuard) return; // run once
    window.__hhBounceGuard = true;
    const scrollEl = document.scrollingElement || document.documentElement;
    let startY = 0;
    window.addEventListener('touchstart', (e)=>{
      if(e.touches && e.touches[0]) startY = e.touches[0].pageY;
    }, { passive: true, capture: true });
    window.addEventListener('touchmove', (e)=>{
      // allow scrolling inside drawers/overlays
      if (body.classList.contains('is-locked')) return;
      const touch = (e.touches && e.touches[0]);
      if (!touch) return;
      const currY = touch.pageY;
      const pullingDown = currY > startY + 1;
      const pullingUp = currY < startY - 1;
      const atTop = (scrollEl.scrollTop || 0) <= 0;
      const atBottom = (scrollEl.scrollTop + window.innerHeight) >= (scrollEl.scrollHeight - 1);
      if ((atTop && pullingDown) || (atBottom && pullingUp)){
        e.preventDefault();
      }
    }, { passive: false, capture: true });
  }
  window.preventTopBounce = preventTopBounce;
  try{ preventTopBounce(); }catch(_){ }
})();

/* ================================================================
   Cycle 257 :: HH.heroKx
   Additive kinetic + parallax controller for the hero.
   - Reveals [data-hh-kx-headline] per-glyph via IntersectionObserver
   - Maps scroll progress (0..1 within hero rect) to --kx-y on each
     .hh-hero-kx-layer weighted by data-rate.
   - Aborts cleanly if prefers-reduced-motion: reduce matches.
   - Does not touch any pre-existing HH.* namespace.
   ================================================================ */
(function(){
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  const d = document;
  const w = window;

  const reduceMQ = (typeof w.matchMedia === 'function')
    ? w.matchMedia('(prefers-reduced-motion: reduce)')
    : { matches: false, addEventListener: function(){}, addListener: function(){} };

  function revealHeadlines(){
    const heads = d.querySelectorAll('[data-hh-kx-headline]');
    if (!heads.length) return;
    if (reduceMQ.matches){
      heads.forEach(function(h){ h.classList.add('is-revealed'); });
      return;
    }
    if (typeof w.IntersectionObserver !== 'function'){
      heads.forEach(function(h){ h.classList.add('is-revealed'); });
      return;
    }
    const io = new w.IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting){
          entry.target.classList.add('is-revealed');
        } else if (entry.intersectionRatio === 0 && entry.boundingClientRect.top > 0){
          // Re-arm only when scrolled fully out below; lets the user trigger
          // the reveal again after scrolling back from the top.
          entry.target.classList.remove('is-revealed');
        }
      });
    }, { threshold: [0, 0.18, 0.55] });
    heads.forEach(function(h){ io.observe(h); });
  }

  function setupParallax(){
    const heroes = d.querySelectorAll('[data-hh-hero]');
    if (!heroes.length) return function noop(){};
    if (reduceMQ.matches){
      // Settle layers to neutral and bail out of rAF loop.
      heroes.forEach(function(hero){
        const layers = hero.querySelectorAll('.hh-hero-kx-layer');
        layers.forEach(function(l){ l.style.setProperty('--kx-y', '0px'); });
      });
      return function noop(){};
    }

    const heroData = [];
    heroes.forEach(function(hero){
      const layers = hero.querySelectorAll('.hh-hero-kx-layer');
      if (!layers.length) return;
      const layerEntries = [];
      layers.forEach(function(layer){
        const r = parseFloat(layer.getAttribute('data-rate'));
        layerEntries.push({ el: layer, rate: isNaN(r) ? 0.1 : r });
      });
      heroData.push({ hero: hero, layers: layerEntries });
    });
    if (!heroData.length) return function noop(){};

    let ticking = false;
    let lastY = (typeof w.scrollY === 'number') ? w.scrollY : (w.pageYOffset || 0);

    function frame(){
      ticking = false;
      const viewportH = w.innerHeight || d.documentElement.clientHeight || 0;
      heroData.forEach(function(entry){
        const rect = entry.hero.getBoundingClientRect();
        const heroH = rect.height || 1;
        // progress: 0 when hero top hits viewport top, 1 when hero bottom reaches viewport top
        const progress = Math.min(1, Math.max(-1, (-rect.top) / heroH));
        // Allow a small lead-in when the hero is below the fold for a softer entrance.
        const enterProgress = Math.min(1, Math.max(-0.3, (viewportH - rect.top) / (viewportH + heroH) - 0.5));
        const p = (progress + enterProgress) / 2;
        entry.layers.forEach(function(layerEntry){
          // translate negatively as we scroll down (layer rises against motion)
          const y = -p * heroH * layerEntry.rate * 1.0;
          layerEntry.el.style.setProperty('--kx-y', y.toFixed(2) + 'px');
        });
      });
    }

    function onScroll(){
      lastY = (typeof w.scrollY === 'number') ? w.scrollY : (w.pageYOffset || 0);
      if (!ticking){
        ticking = true;
        w.requestAnimationFrame(frame);
      }
    }

    // Initial paint
    w.requestAnimationFrame(frame);

    w.addEventListener('scroll', onScroll, { passive: true });
    w.addEventListener('resize', onScroll, { passive: true });

    return function teardown(){
      w.removeEventListener('scroll', onScroll);
      w.removeEventListener('resize', onScroll);
    };
  }

  let teardown = function(){};

  function boot(){
    try { revealHeadlines(); } catch (_e) {}
    try { teardown = setupParallax() || function(){}; } catch (_e) {}
  }

  function rebind(){
    try { teardown(); } catch (_e) {}
    boot();
  }

  // Re-boot on reduce-motion preference change so the hero respects the user's
  // preference without a page reload.
  if (typeof reduceMQ.addEventListener === 'function'){
    reduceMQ.addEventListener('change', rebind);
  } else if (typeof reduceMQ.addListener === 'function'){
    reduceMQ.addListener(rebind);
  }

  if (d.readyState !== 'loading'){
    boot();
  } else {
    d.addEventListener('DOMContentLoaded', boot);
  }

  w.HH = Object.assign(w.HH || {}, {
    heroKx: { reveal: revealHeadlines, parallax: setupParallax, rebind: rebind }
  });
})();

/* =================================================================
   Cycle 258 -- HH.communityMoments
   :: pointer-tracked 3D tilt + cursor-following bloom (rAF throttled)
   :: scroll-staggered reveal via IntersectionObserver
   :: native <dialog> lightbox with FLIP-style shared-element zoom
   :: respects prefers-reduced-motion + pointer:coarse (live re-bind)
   ================================================================= */
(function(){
  var d = document;
  var w = window;
  var reduceMQ = w.matchMedia ? w.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var coarseMQ = w.matchMedia ? w.matchMedia('(pointer: coarse)') : null;
  var hoverMQ = w.matchMedia ? w.matchMedia('(hover: hover) and (pointer: fine)') : null;

  function prefersReduce(){ return !!(reduceMQ && reduceMQ.matches); }
  function isCoarse(){ return !!(coarseMQ && coarseMQ.matches); }
  function canTilt(){ return !prefersReduce() && !isCoarse() && (!hoverMQ || hoverMQ.matches); }

  var tilesBound = [];
  var revealObserver = null;
  var lightboxState = { dialog: null, lastTrigger: null, raf: 0 };

  function bindTile(tile){
    if (tile.__hhCmBound) return;
    tile.__hhCmBound = true;

    var section = tile.closest('[data-hh-cm-section]');
    var tiltOn = section ? section.getAttribute('data-hh-cm-tilt') === 'on' : true;

    var raf = 0;
    var pending = null;
    var resetTimer = 0;

    function flush(){
      raf = 0;
      if (!pending) return;
      tile.style.setProperty('--mx', pending.mx.toFixed(3));
      tile.style.setProperty('--my', pending.my.toFixed(3));
      tile.style.setProperty('--tx', pending.tx.toFixed(3));
      tile.style.setProperty('--ty', pending.ty.toFixed(3));
      pending = null;
    }

    function onMove(ev){
      if (!tiltOn || !canTilt()) return;
      var rect = tile.getBoundingClientRect();
      if (rect.width === 0 || rect.height === 0) return;
      var px = (ev.clientX - rect.left) / rect.width;
      var py = (ev.clientY - rect.top) / rect.height;
      var tx = (px - 0.5) * 2;
      var ty = (py - 0.5) * 2;
      pending = { mx: px, my: py, tx: tx, ty: ty };
      tile.setAttribute('data-hh-cm-active', '1');
      tile.removeAttribute('data-hh-cm-spring');
      if (resetTimer){ clearTimeout(resetTimer); resetTimer = 0; }
      if (!raf) raf = w.requestAnimationFrame(flush);
    }

    function onLeave(){
      if (raf){ w.cancelAnimationFrame(raf); raf = 0; }
      pending = null;
      tile.removeAttribute('data-hh-cm-active');
      tile.setAttribute('data-hh-cm-spring', '1');
      // Spring back to neutral over ~220ms then drop the spring flag.
      tile.style.setProperty('--tx', '0');
      tile.style.setProperty('--ty', '0');
      tile.style.setProperty('--mx', '0.5');
      tile.style.setProperty('--my', '0.5');
      if (resetTimer) clearTimeout(resetTimer);
      resetTimer = w.setTimeout(function(){
        tile.removeAttribute('data-hh-cm-spring');
        resetTimer = 0;
      }, 240);
    }

    tile.addEventListener('pointermove', onMove);
    tile.addEventListener('pointerleave', onLeave);
    tile.addEventListener('pointercancel', onLeave);

    tilesBound.push({ tile: tile, off: function(){
      tile.removeEventListener('pointermove', onMove);
      tile.removeEventListener('pointerleave', onLeave);
      tile.removeEventListener('pointercancel', onLeave);
      if (raf) w.cancelAnimationFrame(raf);
      if (resetTimer) clearTimeout(resetTimer);
      tile.__hhCmBound = false;
    }});
  }

  function unbindAllTiles(){
    while (tilesBound.length){
      var rec = tilesBound.pop();
      try { rec.off(); } catch (_e){}
    }
  }

  function setupReveal(tiles){
    if (!tiles.length) return;
    if (prefersReduce() || !('IntersectionObserver' in w)){
      tiles.forEach(function(t){ t.classList.add('is-revealed'); });
      return;
    }
    if (revealObserver){ revealObserver.disconnect(); }
    revealObserver = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){
          e.target.classList.add('is-revealed');
          revealObserver.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.15 });
    tiles.forEach(function(t){ revealObserver.observe(t); });
  }

  /* ---- Lightbox :: FLIP shared-element transition ---- */
  function findDialogFor(trigger){
    var sec = trigger.closest('[data-hh-cm-section]');
    if (!sec) return null;
    return sec.querySelector('[data-hh-cm-lightbox]');
  }

  function closeLightbox(){
    var dlg = lightboxState.dialog;
    if (!dlg || !dlg.open) return;
    try { dlg.close(); } catch (_e){}
    var trigger = lightboxState.lastTrigger;
    lightboxState.dialog = null;
    lightboxState.lastTrigger = null;
    dlg.removeAttribute('data-hh-cm-flip');
    if (trigger && typeof trigger.focus === 'function'){
      try { trigger.focus({ preventScroll: true }); } catch (_e){ trigger.focus(); }
    }
  }

  function openLightbox(trigger){
    var dlg = findDialogFor(trigger);
    if (!dlg || typeof dlg.showModal !== 'function') return;

    var srcImg = trigger.querySelector('img');
    var fullSrc = trigger.getAttribute('data-hh-cm-full') || (srcImg && srcImg.currentSrc) || (srcImg && srcImg.src) || '';
    var altText = trigger.getAttribute('data-hh-cm-alt') || (srcImg && srcImg.alt) || '';
    var capText = trigger.getAttribute('data-hh-cm-lb-caption') || trigger.getAttribute('data-hh-cm-caption') || '';

    var lbImg = dlg.querySelector('[data-hh-cm-lb-img]');
    var lbCap = dlg.querySelector('[data-hh-cm-lb-cap]');
    if (!lbImg) return;

    lbImg.removeAttribute('src');
    lbImg.alt = altText;
    if (lbCap) lbCap.textContent = capText;

    var srcRect = srcImg ? srcImg.getBoundingClientRect() : trigger.getBoundingClientRect();

    lightboxState.dialog = dlg;
    lightboxState.lastTrigger = trigger;
    dlg.removeAttribute('data-hh-cm-flip');

    function onCancel(ev){ ev.preventDefault(); closeLightbox(); }
    function onClose(){
      dlg.removeEventListener('cancel', onCancel);
      dlg.removeEventListener('close', onClose);
      dlg.removeEventListener('click', onBackdrop);
    }
    function onBackdrop(ev){
      if (ev.target === dlg) closeLightbox();
      var closer = ev.target && ev.target.closest && ev.target.closest('[data-hh-cm-close]');
      if (closer) closeLightbox();
    }
    dlg.addEventListener('cancel', onCancel);
    dlg.addEventListener('close', onClose);
    dlg.addEventListener('click', onBackdrop);

    function showWithFlip(){
      try { dlg.showModal(); } catch (_e){ try { dlg.show(); } catch (_e2){} }
      if (prefersReduce()){
        return;
      }
      var destRect = lbImg.getBoundingClientRect();
      if (!destRect.width || !destRect.height) return;
      var dx = srcRect.left - destRect.left;
      var dy = srcRect.top - destRect.top;
      var sx = srcRect.width / destRect.width;
      var sy = srcRect.height / destRect.height;
      // Apply inverse delta WITHOUT transition, then double-rAF to identity.
      lbImg.style.transition = 'none';
      lbImg.style.opacity = '0.001';
      lbImg.style.transform = 'translate(' + dx.toFixed(2) + 'px, ' + dy.toFixed(2) + 'px) scale(' + sx.toFixed(4) + ', ' + sy.toFixed(4) + ')';
      // Force layout flush
      void lbImg.offsetWidth;
      w.requestAnimationFrame(function(){
        w.requestAnimationFrame(function(){
          dlg.setAttribute('data-hh-cm-flip', 'enter');
          lbImg.style.transition = '';
          lbImg.style.opacity = '1';
          lbImg.style.transform = 'translate(0, 0) scale(1, 1)';
        });
      });
    }

    // Replace the static placeholder ratio with the image's real intrinsic
    // ratio so the reserved box matches before paint :: zero layout shift.
    function applyNatural(imgEl){
      if (!imgEl) return;
      var nw = imgEl.naturalWidth;
      var nh = imgEl.naturalHeight;
      if (nw && nh){
        lbImg.style.aspectRatio = nw + ' / ' + nh;
        lbImg.width = nw;
        lbImg.height = nh;
      }
    }

    if (fullSrc){
      var preload = new Image();
      preload.decoding = 'async';
      preload.onload = function(){
        applyNatural(preload);
        lbImg.src = fullSrc;
        showWithFlip();
      };
      preload.onerror = function(){
        if (srcImg && srcImg.src){
          applyNatural(srcImg);
          lbImg.src = srcImg.src;
        }
        showWithFlip();
      };
      preload.src = fullSrc;
      // Safety :: if preload is instant from cache, ensure we still show.
      if (preload.complete){
        applyNatural(preload);
        lbImg.src = fullSrc;
        showWithFlip();
      }
    } else if (srcImg && srcImg.src){
      applyNatural(srcImg);
      lbImg.src = srcImg.src;
      showWithFlip();
    } else {
      showWithFlip();
    }
  }

  function bindOpeners(root){
    var openers = (root || d).querySelectorAll('[data-hh-cm-open]');
    openers.forEach(function(btn){
      if (btn.__hhCmOpenerBound) return;
      btn.__hhCmOpenerBound = true;
      btn.addEventListener('click', function(ev){
        ev.preventDefault();
        openLightbox(btn);
      });
    });
  }

  function boot(){
    var tiles = Array.from(d.querySelectorAll('[data-hh-cm-tile]'));
    if (!tiles.length) return;
    setupReveal(tiles);
    if (canTilt()){
      tiles.forEach(bindTile);
    }
    bindOpeners(d);
  }

  function rebind(){
    unbindAllTiles();
    var tiles = Array.from(d.querySelectorAll('[data-hh-cm-tile]'));
    if (canTilt()){
      tiles.forEach(bindTile);
    } else {
      // Clear any leftover transform vars when motion is killed.
      tiles.forEach(function(t){
        t.style.removeProperty('--tx');
        t.style.removeProperty('--ty');
        t.style.removeProperty('--mx');
        t.style.removeProperty('--my');
        t.removeAttribute('data-hh-cm-active');
        t.removeAttribute('data-hh-cm-spring');
      });
    }
  }

  function attachMQ(mq, fn){
    if (!mq) return;
    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', fn);
    else if (typeof mq.addListener === 'function') mq.addListener(fn);
  }
  attachMQ(reduceMQ, rebind);
  attachMQ(coarseMQ, rebind);
  attachMQ(hoverMQ, rebind);

  if (d.readyState !== 'loading') boot();
  else d.addEventListener('DOMContentLoaded', boot);

  w.HH = Object.assign(w.HH || {}, {
    communityMoments: {
      boot: boot,
      rebind: rebind,
      open: openLightbox,
      close: closeLightbox
    }
  });
})();

/* =========================================================
   Cycle 260 :: HH.packsBleed
   Scroll-locked storytelling for the packs-teaser Recipe B
   image-bleed block. IO-driven glyph reveal + rAF parallax on
   the image plate. Idempotent, prefers-reduced-motion guarded,
   self-suspending when off-viewport.
   ========================================================= */
(function (w, d) {
  if (!w || !d) return;
  if (w.__hhPacksBleedBound) return;
  w.__hhPacksBleedBound = true;

  var SECTION_SEL  = '[data-hh-packs-bleed]';
  var HEADLINE_SEL = '[data-hh-packs-headline], .hh-pkx-headline';
  var IMAGE_SEL    = '.hh-pkx-image';

  var reduceMQ = w.matchMedia ? w.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function prefersReduce(){ return !!(reduceMQ && reduceMQ.matches); }

  var sections = [];

  function bindHeadline(section){
    var h = section.querySelector(HEADLINE_SEL);
    if (!h || h.__hhPkxHeadlineBound) return;
    h.__hhPkxHeadlineBound = true;
    if (!h.hasAttribute('data-hh-packs-headline')){
      h.setAttribute('data-hh-packs-headline', '');
    }
    if (prefersReduce() || !('IntersectionObserver' in w)){
      h.classList.add('is-revealed');
      return;
    }
    var io = new IntersectionObserver(function(entries){
      for (var i = 0; i < entries.length; i++){
        var e = entries[i];
        if (e.isIntersecting){
          e.target.classList.add('is-revealed');
          io.unobserve(e.target);
        }
      }
    }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });
    io.observe(h);
  }

  function bindParallax(section){
    var img = section.querySelector(IMAGE_SEL);
    if (!img || img.__hhPkxParallaxBound) return;
    img.__hhPkxParallaxBound = true;

    if (prefersReduce()){
      img.style.removeProperty('--p');
      return;
    }

    var ticking = false;
    var inView  = false;
    var lastP   = 0;
    img.setAttribute('data-p', '');

    function compute(){
      ticking = false;
      var rect = section.getBoundingClientRect();
      var vh   = w.innerHeight || d.documentElement.clientHeight;
      // Center crossing :: 0 when section center sits at viewport bottom,
      // 1 when it has reached viewport top. Clamp + smooth.
      var center = rect.top + rect.height / 2;
      var raw = 1 - (center / vh);
      if (raw < 0) raw = 0;
      else if (raw > 1) raw = 1;
      // Re-shape so motion is centered around viewport mid (-0.5..0.5 -> 0..1).
      var p = (raw - 0.25) * 1.6;
      if (p < 0) p = 0;
      else if (p > 1) p = 1;
      if (Math.abs(p - lastP) < 0.004) return;
      lastP = p;
      img.style.setProperty('--p', p.toFixed(4));
    }

    function onScroll(){
      if (!inView || ticking) return;
      ticking = true;
      w.requestAnimationFrame(compute);
    }

    var visIO = ('IntersectionObserver' in w)
      ? new IntersectionObserver(function(entries){
          for (var i = 0; i < entries.length; i++){
            var e = entries[i];
            if (e.target === section){
              inView = e.isIntersecting;
              if (inView){
                w.requestAnimationFrame(compute);
              }
            }
          }
        }, { threshold: [0, 0.05, 0.5, 1], rootMargin: '20% 0px 20% 0px' })
      : null;
    if (visIO){ visIO.observe(section); inView = true; }
    else { inView = true; }

    w.addEventListener('scroll', onScroll, { passive: true });
    w.addEventListener('resize', onScroll, { passive: true });
    // Prime once so the section isn't stuck on --p:0 before first scroll.
    w.requestAnimationFrame(compute);

    img.__hhPkxParallaxOff = function(){
      try { w.removeEventListener('scroll', onScroll); } catch(_e){}
      try { w.removeEventListener('resize', onScroll); } catch(_e){}
      try { if (visIO) visIO.disconnect(); } catch(_e){}
      img.style.removeProperty('--p');
      img.removeAttribute('data-p');
      img.__hhPkxParallaxBound = false;
    };
  }

  function bindSection(section){
    if (!section || section.__hhPacksBound) return;
    section.__hhPacksBound = true;
    bindHeadline(section);
    bindParallax(section);
    if (w.HH && w.HH.magnetic && typeof w.HH.magnetic.bindNew === 'function'){
      try { w.HH.magnetic.bindNew(section); } catch(_e){}
    }
  }

  function boot(){
    var nodes = d.querySelectorAll(SECTION_SEL);
    sections = Array.prototype.slice.call(nodes);
    for (var i = 0; i < sections.length; i++) bindSection(sections[i]);
  }

  function rebind(){
    // Reduced-motion change :: tear down parallax, then re-bind to either
    // fully animate or stay static depending on the new MQ state.
    for (var i = 0; i < sections.length; i++){
      var sec = sections[i];
      var img = sec.querySelector(IMAGE_SEL);
      if (img && typeof img.__hhPkxParallaxOff === 'function'){
        img.__hhPkxParallaxOff();
      }
      var h = sec.querySelector(HEADLINE_SEL);
      if (prefersReduce() && h){ h.classList.add('is-revealed'); }
      sec.__hhPacksBound = false;
      bindSection(sec);
    }
  }

  function attachMQ(mq, fn){
    if (!mq) return;
    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', fn);
    else if (typeof mq.addListener === 'function') mq.addListener(fn);
  }
  attachMQ(reduceMQ, rebind);

  if (d.readyState !== 'loading') boot();
  else d.addEventListener('DOMContentLoaded', boot);

  w.HH = Object.assign(w.HH || {}, {
    packsBleed: {
      boot:   boot,
      rebind: rebind,
      bind:   bindSection
    }
  });
})(window, document);

/* Cycle 261 :: HH.tiles
   Recipe D Catalog Tilt + corduroy ribs + magnetic bloom hover.
   - Adds .has-offset class to [data-hh-tiles] when enabled.
   - Per [data-hh-tile]: pointermove (rAF-throttled, passive) updates --mx/--my
     normalized 0..1; pointerleave springs vars back via 200ms transition.
   - IO threshold 0.18 to add .is-revealed on title element (per-glyph kinetic).
   - Idempotent flag __hhTilesBound; prefers-reduced-motion + pointer:coarse
     disable pointermove handler. Live re-bind on matchMedia change.
   ========================================================= */
(function (w, d) {
  if (!w || !d) return;
  if (w.__hhTilesBound) return;
  w.__hhTilesBound = true;

  var SECTION_SEL = '[data-hh-tiles]';
  var TILE_SEL    = '[data-hh-tile]';
  var TITLE_SEL   = '[data-hh-tile-title]';

  var reduceMQ = w.matchMedia ? w.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var coarseMQ = w.matchMedia ? w.matchMedia('(pointer: coarse)') : null;
  function prefersReduce(){ return !!(reduceMQ && reduceMQ.matches); }
  function isCoarse(){ return !!(coarseMQ && coarseMQ.matches); }

  var sections = [];

  function bindTitle(tile){
    var title = tile.querySelector(TITLE_SEL);
    if (!title || title.__hhTilesTitleBound) return;
    title.__hhTilesTitleBound = true;
    if (prefersReduce() || !('IntersectionObserver' in w)){
      title.classList.add('is-revealed');
      return;
    }
    var io = new IntersectionObserver(function(entries){
      for (var i = 0; i < entries.length; i++){
        var e = entries[i];
        if (e.isIntersecting){
          e.target.classList.add('is-revealed');
          io.unobserve(e.target);
        }
      }
    }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });
    io.observe(title);
  }

  function bindPointer(tile){
    if (!tile || tile.__hhTilesPointerBound) return;
    if (prefersReduce() || isCoarse()) return;
    tile.__hhTilesPointerBound = true;

    var ticking = false;
    var pendingX = 0.5;
    var pendingY = 0.5;
    var springTimer = 0;

    function flush(){
      ticking = false;
      tile.style.setProperty('--mx', pendingX.toFixed(4));
      tile.style.setProperty('--my', pendingY.toFixed(4));
    }

    function onMove(ev){
      var rect = tile.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      var x = (ev.clientX - rect.left) / rect.width;
      var y = (ev.clientY - rect.top) / rect.height;
      if (x < 0) x = 0; else if (x > 1) x = 1;
      if (y < 0) y = 0; else if (y > 1) y = 1;
      pendingX = x;
      pendingY = y;
      if (!ticking){
        ticking = true;
        w.requestAnimationFrame(flush);
      }
    }

    function onLeave(){
      // Spring vars back via 200ms transition flag.
      tile.setAttribute('data-hh-tile-springing', '1');
      tile.style.transition =
        '--mx 200ms var(--hh-ease-out, cubic-bezier(.2,.8,.2,1)), ' +
        '--my 200ms var(--hh-ease-out, cubic-bezier(.2,.8,.2,1)), ' +
        'transform 320ms var(--hh-ease-out, cubic-bezier(.2,.8,.2,1)), ' +
        'box-shadow 320ms var(--hh-ease-out, cubic-bezier(.2,.8,.2,1))';
      pendingX = 0.5;
      pendingY = 0.5;
      if (!ticking){
        ticking = true;
        w.requestAnimationFrame(flush);
      }
      if (springTimer) w.clearTimeout(springTimer);
      springTimer = w.setTimeout(function(){
        tile.removeAttribute('data-hh-tile-springing');
        tile.style.removeProperty('transition');
      }, 220);
    }

    function onEnter(){
      if (springTimer){ w.clearTimeout(springTimer); springTimer = 0; }
      tile.removeAttribute('data-hh-tile-springing');
      tile.style.removeProperty('transition');
    }

    tile.addEventListener('pointermove', onMove, { passive: true });
    tile.addEventListener('pointerenter', onEnter, { passive: true });
    tile.addEventListener('pointerleave', onLeave, { passive: true });

    tile.__hhTilesPointerOff = function(){
      try { tile.removeEventListener('pointermove', onMove); } catch(_e){}
      try { tile.removeEventListener('pointerenter', onEnter); } catch(_e){}
      try { tile.removeEventListener('pointerleave', onLeave); } catch(_e){}
      if (springTimer){ w.clearTimeout(springTimer); springTimer = 0; }
      tile.style.removeProperty('--mx');
      tile.style.removeProperty('--my');
      tile.style.removeProperty('transition');
      tile.removeAttribute('data-hh-tile-springing');
      tile.__hhTilesPointerBound = false;
    };
  }

  function bindSection(section){
    if (!section || section.__hhTilesSectionBound) return;
    section.__hhTilesSectionBound = true;

    var enableOffset = section.getAttribute('data-hh-tiles-offset') !== '0';
    if (enableOffset) section.classList.add('has-offset');
    else section.classList.remove('has-offset');

    var tiles = section.querySelectorAll(TILE_SEL);
    for (var i = 0; i < tiles.length; i++){
      bindTitle(tiles[i]);
      bindPointer(tiles[i]);
    }

    if (w.HH && w.HH.magnetic && typeof w.HH.magnetic.bindNew === 'function'){
      try { w.HH.magnetic.bindNew(section); } catch(_e){}
    }
  }

  function unbindSection(section){
    var tiles = section.querySelectorAll(TILE_SEL);
    for (var i = 0; i < tiles.length; i++){
      var t = tiles[i];
      if (typeof t.__hhTilesPointerOff === 'function') t.__hhTilesPointerOff();
    }
    section.__hhTilesSectionBound = false;
  }

  function boot(){
    var nodes = d.querySelectorAll(SECTION_SEL);
    sections = Array.prototype.slice.call(nodes);
    for (var i = 0; i < sections.length; i++) bindSection(sections[i]);
  }

  function rebind(){
    for (var i = 0; i < sections.length; i++){
      unbindSection(sections[i]);
      bindSection(sections[i]);
    }
  }

  function attachMQ(mq, fn){
    if (!mq) return;
    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', fn);
    else if (typeof mq.addListener === 'function') mq.addListener(fn);
  }
  attachMQ(reduceMQ, rebind);
  attachMQ(coarseMQ, rebind);

  if (d.readyState !== 'loading') boot();
  else d.addEventListener('DOMContentLoaded', boot);

  w.HH = Object.assign(w.HH || {}, {
    tiles: {
      boot:   boot,
      rebind: rebind,
      bind:   bindSection
    }
  });
})(window, document);

/* Cycle 262 :: HH.footerE (Recipe E constellation, letterform bloom + per-col reveal) */
(function (w, d) {
  'use strict';
  if (w.__hhFooterEBound) return;
  w.__hhFooterEBound = true;

  var FOOTER_SEL  = '[data-hh-footer-e]';
  var COL_SEL     = '[data-hh-reveal]';
  var LETTER_SEL  = '.hh-footer-letterform';
  var BLOOM_ATTR  = 'data-hh-footer-bloom';

  var reduceMQ = (typeof w.matchMedia === 'function') ? w.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var coarseMQ = (typeof w.matchMedia === 'function') ? w.matchMedia('(pointer: coarse)') : null;

  function prefersReduce(){ return !!(reduceMQ && reduceMQ.matches); }
  function isCoarse(){ return !!(coarseMQ && coarseMQ.matches); }

  function bindReveal(footer){
    var cols = footer.querySelectorAll(COL_SEL);
    if (!cols.length) return;

    if (prefersReduce() || typeof w.IntersectionObserver !== 'function'){
      for (var i = 0; i < cols.length; i++) cols[i].classList.add('is-revealed');
      return;
    }

    // Assign --ci index if not already set inline
    for (var k = 0; k < cols.length; k++){
      var c = cols[k];
      if (!c.style.getPropertyValue('--ci')){
        c.style.setProperty('--ci', String(k));
      }
    }

    var io = new IntersectionObserver(function (entries){
      for (var e = 0; e < entries.length; e++){
        var entry = entries[e];
        if (entry.isIntersecting){
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        }
      }
    }, { threshold: 0.15 });

    for (var j = 0; j < cols.length; j++) io.observe(cols[j]);
  }

  function bindBloom(footer){
    if (footer.__hhFooterEBloomBound) return;
    var letterform = footer.querySelector(LETTER_SEL);
    if (!letterform) return;
    if (footer.getAttribute(BLOOM_ATTR) !== '1') return;
    if (prefersReduce() || isCoarse()) return;

    footer.__hhFooterEBloomBound = true;

    var raf = 0;
    var pendingX = 50, pendingY = 60;

    function apply(){
      raf = 0;
      letterform.style.setProperty('--mx', String(pendingX));
      letterform.style.setProperty('--my', String(pendingY));
    }

    function onMove(ev){
      var rect = letterform.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      var x = ((ev.clientX - rect.left) / rect.width) * 100;
      var y = ((ev.clientY - rect.top) / rect.height) * 100;
      pendingX = Math.max(0, Math.min(100, x));
      pendingY = Math.max(0, Math.min(100, y));
      if (!raf) raf = w.requestAnimationFrame(apply);
    }

    function onLeave(){
      pendingX = 50; pendingY = 60;
      if (!raf) raf = w.requestAnimationFrame(apply);
    }

    letterform.addEventListener('pointermove', onMove, { passive: true });
    letterform.addEventListener('pointerleave', onLeave, { passive: true });

    footer.__hhFooterEBloomOff = function(){
      letterform.removeEventListener('pointermove', onMove);
      letterform.removeEventListener('pointerleave', onLeave);
      if (raf){ w.cancelAnimationFrame(raf); raf = 0; }
      letterform.style.removeProperty('--mx');
      letterform.style.removeProperty('--my');
      footer.__hhFooterEBloomBound = false;
    };
  }

  function unbindBloom(footer){
    if (typeof footer.__hhFooterEBloomOff === 'function'){
      footer.__hhFooterEBloomOff();
    }
  }

  function bindMagnetic(footer){
    try {
      if (w.HH && w.HH.magnetic && typeof w.HH.magnetic.bindNew === 'function'){
        w.HH.magnetic.bindNew(footer);
      }
    } catch (_e){}
  }

  function boot(){
    var footers = d.querySelectorAll(FOOTER_SEL);
    for (var i = 0; i < footers.length; i++){
      var footer = footers[i];
      bindReveal(footer);
      bindBloom(footer);
      bindMagnetic(footer);
    }
  }

  function rebind(){
    var footers = d.querySelectorAll(FOOTER_SEL);
    for (var i = 0; i < footers.length; i++){
      unbindBloom(footers[i]);
      bindBloom(footers[i]);
    }
  }

  function attachMQ(mq, fn){
    if (!mq) return;
    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', fn);
    else if (typeof mq.addListener === 'function') mq.addListener(fn);
  }
  attachMQ(reduceMQ, rebind);
  attachMQ(coarseMQ, rebind);

  if (d.readyState !== 'loading') boot();
  else d.addEventListener('DOMContentLoaded', boot);

  w.HH = Object.assign(w.HH || {}, {
    footerE: {
      boot:   boot,
      rebind: rebind
    }
  });
})(window, document);


/* Cycle 263 :: HH.rescueStats */
(function(w, d){
  if (!w || !d) return;
  var SECTION_SEL = '[data-hh-rescue-stats]';

  var reduceMQ = w.matchMedia ? w.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var coarseMQ = w.matchMedia ? w.matchMedia('(pointer: coarse)') : null;

  function prefersReduce(){ return !!(reduceMQ && reduceMQ.matches); }
  function isCoarse(){ return !!(coarseMQ && coarseMQ.matches); }

  var nf;
  try { nf = new Intl.NumberFormat('en-US'); } catch(e){ nf = null; }
  function fmt(n){
    var v = Math.round(n);
    if (nf) return nf.format(v);
    return String(v).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function easeOut(t){
    // Approximate cubic-bezier(.2, .8, .2, 1)
    return 1 - Math.pow(1 - t, 3);
  }

  function setFinal(stat){
    var num = stat.querySelector('[data-hh-stat-num]');
    if (!num) return;
    var target = parseFloat(stat.getAttribute('data-target')) || 0;
    num.textContent = fmt(target);
  }

  function runCountUp(stat, delay){
    var num = stat.querySelector('[data-hh-stat-num]');
    if (!num) return;
    if (stat.__hhCountDone) return;
    stat.__hhCountDone = true;
    var target = parseFloat(stat.getAttribute('data-target')) || 0;
    if (target <= 0){ num.textContent = '0'; return; }
    var dur = 900; // --hh-dur-epic
    var startAt = 0;
    var startedRAF = null;
    function step(now){
      if (startAt === 0) startAt = now;
      var elapsed = now - startAt;
      if (elapsed < 0) elapsed = 0;
      var t = Math.min(1, elapsed / dur);
      var v = easeOut(t) * target;
      num.textContent = fmt(v);
      if (t < 1){
        startedRAF = w.requestAnimationFrame(step);
      } else {
        num.textContent = fmt(target);
      }
    }
    w.setTimeout(function(){
      startedRAF = w.requestAnimationFrame(step);
    }, Math.max(0, delay || 0));
  }

  function bindBloom(section){
    if (section.__hhBloomBound) return;
    if (isCoarse() || prefersReduce()) return;
    if (section.getAttribute('data-hh-bloom') !== '1') return;

    var raf = 0;
    var lastX = 0.85;
    var lastY = 0.15;
    var bbRect = null;

    // Rect cached + refreshed on resize/scroll only, in deliberate parity with
    // the coming-bloom bindBloom; pointermove must stay reflow-free.
    function readBloomRect(){
      try { bbRect = section.getBoundingClientRect(); } catch (_e){ bbRect = null; }
    }

    function onMove(ev){
      var rect = bbRect;
      if (!rect || !rect.width || !rect.height) return;
      lastX = (ev.clientX - rect.left) / rect.width;
      lastY = (ev.clientY - rect.top) / rect.height;
      if (lastX < 0) lastX = 0; else if (lastX > 1) lastX = 1;
      if (lastY < 0) lastY = 0; else if (lastY > 1) lastY = 1;
      if (raf) return;
      raf = w.requestAnimationFrame(function(){
        raf = 0;
        section.style.setProperty('--mx', lastX.toFixed(3));
        section.style.setProperty('--my', lastY.toFixed(3));
      });
    }

    function onRectRefresh(){ readBloomRect(); }

    readBloomRect();
    section.addEventListener('pointermove', onMove, { passive: true });
    w.addEventListener('resize', onRectRefresh, { passive: true });
    w.addEventListener('scroll', onRectRefresh, { passive: true });
    section.__hhBloomBound = true;
    section.__hhBloomMove = onMove;
    section.__hhBloomRectRefresh = onRectRefresh;
  }

  function unbindBloom(section){
    if (!section.__hhBloomBound) return;
    if (section.__hhBloomMove){
      section.removeEventListener('pointermove', section.__hhBloomMove);
    }
    if (section.__hhBloomRectRefresh){
      try { w.removeEventListener('resize', section.__hhBloomRectRefresh); } catch(_e){}
      try { w.removeEventListener('scroll', section.__hhBloomRectRefresh); } catch(_e){}
    }
    section.__hhBloomBound = false;
    section.__hhBloomMove = null;
    section.__hhBloomRectRefresh = null;
  }

  function bindSection(section){
    if (section.__hhRescueStatsBound) return;
    section.__hhRescueStatsBound = true;

    var stats = section.querySelectorAll('[data-hh-stat]');
    for (var i = 0; i < stats.length; i++){
      stats[i].style.setProperty('--si', String(i));
    }

    var countEnabled = section.getAttribute('data-hh-countup-enabled') !== '0';

    if (prefersReduce()){
      section.classList.add('is-revealed');
      for (var j = 0; j < stats.length; j++){
        setFinal(stats[j]);
      }
    } else if ('IntersectionObserver' in w){
      var io = new IntersectionObserver(function(entries){
        for (var k = 0; k < entries.length; k++){
          var entry = entries[k];
          if (!entry.isIntersecting) continue;
          section.classList.add('is-revealed');
          if (countEnabled){
            var localStats = section.querySelectorAll('[data-hh-stat]');
            for (var s = 0; s < localStats.length; s++){
              runCountUp(localStats[s], s * 60);
            }
          } else {
            for (var s2 = 0; s2 < stats.length; s2++){
              setFinal(stats[s2]);
            }
          }
          io.unobserve(section);
        }
      }, { threshold: 0.2 });
      io.observe(section);
    } else {
      section.classList.add('is-revealed');
      for (var m = 0; m < stats.length; m++){
        if (countEnabled) runCountUp(stats[m], m * 60);
        else setFinal(stats[m]);
      }
    }

    bindBloom(section);
  }

  function boot(){
    var sections = d.querySelectorAll(SECTION_SEL);
    for (var i = 0; i < sections.length; i++){
      bindSection(sections[i]);
    }
  }

  function rebind(){
    var sections = d.querySelectorAll(SECTION_SEL);
    for (var i = 0; i < sections.length; i++){
      var s = sections[i];
      unbindBloom(s);
      if (prefersReduce()){
        s.classList.add('is-revealed');
        var stats = s.querySelectorAll('[data-hh-stat]');
        for (var j = 0; j < stats.length; j++) setFinal(stats[j]);
      } else {
        bindBloom(s);
      }
    }
  }

  function attachMQ(mq, fn){
    if (!mq) return;
    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', fn);
    else if (typeof mq.addListener === 'function') mq.addListener(fn);
  }
  attachMQ(reduceMQ, rebind);
  attachMQ(coarseMQ, rebind);

  if (d.readyState !== 'loading') boot();
  else d.addEventListener('DOMContentLoaded', boot);

  w.HH = Object.assign(w.HH || {}, {
    rescueStats: {
      boot:   boot,
      rebind: rebind
    }
  });
})(window, document);

/* Cycle 264 :: HH.comingSoon :: splash reveal + golden-bloom pointer + magnetic rebind */
(function (w, d) {
  if (!w || !d) return;
  var SECTION_SEL = '.hh-coming';
  var reduceMQ = (typeof w.matchMedia === 'function') ? w.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var coarseMQ = (typeof w.matchMedia === 'function') ? w.matchMedia('(pointer: coarse)') : null;

  function prefersReduce(){ return !!(reduceMQ && reduceMQ.matches); }
  function isCoarse(){ return !!(coarseMQ && coarseMQ.matches); }

  function reveal(section){
    if (!section || section.classList.contains('is-revealed')) return;
    section.classList.add('is-revealed');
  }

  function bindReveal(section){
    if (prefersReduce() || !('IntersectionObserver' in w)){
      reveal(section);
      return;
    }
    var io = new IntersectionObserver(function(entries){
      for (var i = 0; i < entries.length; i++){
        var e = entries[i];
        if (e.isIntersecting){
          reveal(section);
          io.unobserve(section);
        }
      }
    }, { threshold: 0.15 });
    io.observe(section);
    section.__hhComingIO = io;
  }

  function bindBloom(section){
    if (section.__hhComingBloomBound) return;
    if (prefersReduce() || isCoarse()) return;

    var rect = null;
    var ticking = false;

    function readRect(){
      try { rect = section.getBoundingClientRect(); } catch (_e){ rect = null; }
    }

    function apply(x, y){
      ticking = false;
      if (!rect) return;
      var w_ = rect.width || 1;
      var h_ = rect.height || 1;
      var mx = (x - rect.left) / w_;
      var my = (y - rect.top) / h_;
      if (mx < 0) mx = 0; else if (mx > 1) mx = 1;
      if (my < 0) my = 0; else if (my > 1) my = 1;
      section.style.setProperty('--mx', mx.toFixed(3));
      section.style.setProperty('--my', my.toFixed(3));
    }

    function onMove(ev){
      if (ticking) return;
      ticking = true;
      var px = ev.clientX, py = ev.clientY;
      w.requestAnimationFrame(function(){ apply(px, py); });
    }

    function onResize(){ readRect(); }

    readRect();
    section.addEventListener('pointermove', onMove, { passive: true });
    w.addEventListener('resize', onResize, { passive: true });
    w.addEventListener('scroll', onResize, { passive: true });

    section.__hhComingBloomBound = true;
    section.__hhComingBloomMove = onMove;
    section.__hhComingBloomResize = onResize;
  }

  function unbindBloom(section){
    if (!section.__hhComingBloomBound) return;
    if (section.__hhComingBloomMove){
      try { section.removeEventListener('pointermove', section.__hhComingBloomMove); } catch(_e){}
    }
    if (section.__hhComingBloomResize){
      try { w.removeEventListener('resize', section.__hhComingBloomResize); } catch(_e){}
      try { w.removeEventListener('scroll', section.__hhComingBloomResize); } catch(_e){}
    }
    section.style.removeProperty('--mx');
    section.style.removeProperty('--my');
    section.__hhComingBloomBound = false;
    section.__hhComingBloomMove = null;
    section.__hhComingBloomResize = null;
  }

  function bindSection(section){
    if (!section || section.__hhComingBound) return;
    section.__hhComingBound = true;
    bindReveal(section);
    bindBloom(section);
    if (w.HH && w.HH.magnetic && typeof w.HH.magnetic.bindNew === 'function'){
      try { w.HH.magnetic.bindNew(section); } catch(_e){}
    }
  }

  function boot(){
    var nodes = d.querySelectorAll(SECTION_SEL);
    for (var i = 0; i < nodes.length; i++) bindSection(nodes[i]);
  }

  function rebind(){
    var nodes = d.querySelectorAll(SECTION_SEL);
    for (var i = 0; i < nodes.length; i++){
      var s = nodes[i];
      unbindBloom(s);
      if (prefersReduce()){
        reveal(s);
      } else {
        bindBloom(s);
      }
    }
  }

  function attachMQ(mq, fn){
    if (!mq) return;
    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', fn);
    else if (typeof mq.addListener === 'function') mq.addListener(fn);
  }
  attachMQ(reduceMQ, rebind);
  attachMQ(coarseMQ, rebind);

  if (d.readyState !== 'loading') boot();
  else d.addEventListener('DOMContentLoaded', boot);

  // Re-boot for Shopify section editor live preview
  d.addEventListener('shopify:section:load', function(ev){
    if (ev && ev.target && ev.target.querySelector){
      var s = ev.target.querySelector(SECTION_SEL);
      if (s) bindSection(s);
    }
  });

  w.HH = Object.assign(w.HH || {}, {
    comingSoon: {
      boot:   boot,
      rebind: rebind
    }
  });
})(window, document);

/* Cycle 265 :: HH.fourOhFour :: paw walk-in 404 narrative */
(function(w, d){
  if (!w || !d) return;

  var SECTION_SEL = '[data-hh-404]';
  var reduceMQ = w.matchMedia ? w.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var coarseMQ = w.matchMedia ? w.matchMedia('(pointer: coarse)') : null;
  function prefersReduce(){ return !!(reduceMQ && reduceMQ.matches); }
  function isCoarse(){ return !!(coarseMQ && coarseMQ.matches); }

  function reveal(section){
    if (!section) return;
    section.classList.add('is-revealed');
  }

  function bindReveal(section){
    if (!section || section.__hh404RevealBound) return;
    section.__hh404RevealBound = true;
    if (prefersReduce() || !('IntersectionObserver' in w)){
      reveal(section);
      return;
    }
    var io = new IntersectionObserver(function(entries){
      for (var i = 0; i < entries.length; i++){
        if (entries[i].isIntersecting){
          reveal(section);
          io.disconnect();
          break;
        }
      }
    }, { threshold: 0.18 });
    io.observe(section);
  }

  function bindBloom(section){
    if (!section || section.__hh404BloomBound) return;
    if (prefersReduce() || isCoarse()) return;
    if (section.getAttribute('data-bloom') === 'false') return;
    section.__hh404BloomBound = true;

    var rafId = 0;
    var px = 0, py = 0;

    function onMove(ev){
      var rect = section.getBoundingClientRect();
      px = ((ev.clientX - rect.left) / rect.width) * 100;
      py = ((ev.clientY - rect.top) / rect.height) * 100;
      if (rafId) return;
      rafId = w.requestAnimationFrame(function(){
        rafId = 0;
        section.style.setProperty('--mx', px + '%');
        section.style.setProperty('--my', py + '%');
      });
    }
    function onLeave(){
      if (rafId){ w.cancelAnimationFrame(rafId); rafId = 0; }
      section.style.removeProperty('--mx');
      section.style.removeProperty('--my');
    }

    section.addEventListener('pointermove', onMove, { passive: true });
    section.addEventListener('pointerleave', onLeave, { passive: true });
    section.__hh404BloomMove = onMove;
    section.__hh404BloomLeave = onLeave;
  }

  function unbindBloom(section){
    if (!section || !section.__hh404BloomBound) return;
    if (section.__hh404BloomMove) section.removeEventListener('pointermove', section.__hh404BloomMove);
    if (section.__hh404BloomLeave) section.removeEventListener('pointerleave', section.__hh404BloomLeave);
    section.style.removeProperty('--mx');
    section.style.removeProperty('--my');
    section.__hh404BloomBound = false;
    section.__hh404BloomMove = null;
    section.__hh404BloomLeave = null;
  }

  function bindMagnetic(section){
    if (!section || prefersReduce() || isCoarse()) return;
    if (w.HH && w.HH.magnetic && typeof w.HH.magnetic.bindNew === 'function'){
      try { w.HH.magnetic.bindNew(section); } catch(_e){}
    }
  }

  function bindSection(section){
    if (!section || section.__hh404Bound) return;
    section.__hh404Bound = true;
    bindReveal(section);
    bindBloom(section);
    bindMagnetic(section);
  }

  function boot(){
    var nodes = d.querySelectorAll(SECTION_SEL);
    for (var i = 0; i < nodes.length; i++) bindSection(nodes[i]);
  }

  function rebind(){
    var nodes = d.querySelectorAll(SECTION_SEL);
    for (var i = 0; i < nodes.length; i++){
      var s = nodes[i];
      unbindBloom(s);
      if (prefersReduce()){
        reveal(s);
      } else {
        bindBloom(s);
      }
    }
  }

  function attachMQ(mq, fn){
    if (!mq) return;
    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', fn);
    else if (typeof mq.addListener === 'function') mq.addListener(fn);
  }
  attachMQ(reduceMQ, rebind);
  attachMQ(coarseMQ, rebind);

  if (d.readyState !== 'loading') boot();
  else d.addEventListener('DOMContentLoaded', boot);

  // Shopify section editor live preview
  d.addEventListener('shopify:section:load', function(ev){
    if (ev && ev.target && ev.target.querySelector){
      var s = ev.target.querySelector(SECTION_SEL);
      if (s) bindSection(s);
    }
  });

  w.HH = Object.assign(w.HH || {}, {
    fourOhFour: {
      boot:   boot,
      rebind: rebind
    }
  });
})(window, document);

/* Cycle 266 :: HH.cartDrawer (choreography + magnetic + bloom + paw close) */
(function(w, d){
  'use strict';
  if (!w || !d) return;
  if (w.__hhCartDrawerBound) return;
  w.__hhCartDrawerBound = true;

  var reduceMQ = w.matchMedia ? w.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var coarseMQ = w.matchMedia ? w.matchMedia('(pointer: coarse)') : null;
  function reduce(){ return !!(reduceMQ && reduceMQ.matches); }
  function coarse(){ return !!(coarseMQ && coarseMQ.matches); }

  var drawer = null;
  var subtotal = null;
  var checkout = null;
  var closeBtn = null;
  var pmRaf = 0;
  var pmPending = null;
  var isOpen = false;

  function bindMagneticInDrawer(){
    if (!drawer) return;
    if (w.HH && w.HH.magnetic && typeof w.HH.magnetic.bindNew === 'function'){
      try { w.HH.magnetic.bindNew(drawer); } catch(_e){}
    }
  }

  function setOpen(v){
    if (!drawer) return;
    if (v === isOpen) return;
    isOpen = v;
    if (v){
      drawer.classList.add('is-open');
      // bind magnetic to the checkout button now that lines/footer are visible
      bindMagneticInDrawer();
      if (subtotal) attachSubtotalPointer();
    } else {
      drawer.classList.remove('is-open');
      detachSubtotalPointer();
    }
  }

  function flushPM(){
    pmRaf = 0;
    if (!subtotal || !pmPending) return;
    var rect = subtotal.getBoundingClientRect();
    var mx = ((pmPending.x - rect.left) / Math.max(1, rect.width)) * 100;
    var my = ((pmPending.y - rect.top) / Math.max(1, rect.height)) * 100;
    pmPending = null;
    if (mx < 0) mx = 0; if (mx > 100) mx = 100;
    if (my < 0) my = 0; if (my > 100) my = 100;
    subtotal.style.setProperty('--mx', String(Math.round(mx)));
    subtotal.style.setProperty('--my', String(Math.round(my)));
  }
  function onSubtotalMove(e){
    if (reduce() || coarse()) return;
    pmPending = { x: e.clientX, y: e.clientY };
    if (!pmRaf) pmRaf = w.requestAnimationFrame(flushPM);
  }
  function attachSubtotalPointer(){
    if (!subtotal || reduce() || coarse()) return;
    subtotal.addEventListener('pointermove', onSubtotalMove, { passive: true });
  }
  function detachSubtotalPointer(){
    if (!subtotal) return;
    subtotal.removeEventListener('pointermove', onSubtotalMove, { passive: true });
    if (pmRaf) { w.cancelAnimationFrame(pmRaf); pmRaf = 0; }
    pmPending = null;
  }

  function onQtyClick(e){
    var btn = e.target.closest && e.target.closest('.hh-qtybtn');
    if (!btn) return;
    if (reduce()) return;
    btn.classList.add('is-bumped');
    w.setTimeout(function(){ btn.classList.remove('is-bumped'); }, 240);
  }

  // 4-paw fade microinteraction near the close button
  function spawnPawFade(originX, originY){
    if (reduce()) return;
    var c = d.createElement('canvas');
    c.className = 'hh-cart-paw-fx';
    c.width = 64; c.height = 64;
    c.style.left = (originX - 32) + 'px';
    c.style.top  = (originY - 32) + 'px';
    var ctx = c.getContext && c.getContext('2d');
    if (ctx){
      // Four small paw dots arranged like a paw print (one main pad + three toes)
      var ink = '#2a2218';
      ctx.fillStyle = ink;
      // main pad
      ctx.beginPath(); ctx.ellipse(32, 38, 9, 7, 0, 0, Math.PI * 2); ctx.fill();
      // three toes
      ctx.beginPath(); ctx.arc(20, 24, 4, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.arc(32, 18, 4, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.arc(44, 24, 4, 0, Math.PI * 2); ctx.fill();
    }
    (drawer || d.body).appendChild(c);
    // force layout, then animate
    w.requestAnimationFrame(function(){
      c.classList.add('is-visible');
    });
    w.setTimeout(function(){
      try { c.parentNode && c.parentNode.removeChild(c); } catch(_e){}
    }, 360);
  }

  function onCloseClick(e){
    if (!closeBtn) return;
    var rect = closeBtn.getBoundingClientRect();
    spawnPawFade(rect.left + rect.width / 2, rect.top + rect.height / 2);
  }

  function observeDrawerState(){
    if (!drawer) return;
    // Detect open via class change (existing JS adds .is-open) and via hidden attr toggling
    var mo = new MutationObserver(function(muts){
      for (var i = 0; i < muts.length; i++){
        var m = muts[i];
        if (m.type === 'attributes'){
          var hasOpen = drawer.classList.contains('is-open');
          var hidden = drawer.hasAttribute('hidden');
          setOpen(hasOpen && !hidden);
        }
      }
    });
    mo.observe(drawer, { attributes: true, attributeFilter: ['class', 'hidden', 'aria-hidden', 'data-state'] });
  }

  function boot(){
    drawer = d.querySelector('[data-hh-cart-drawer]') || d.getElementById('CartDrawer');
    if (!drawer) return;
    if (!drawer.hasAttribute('data-hh-cart-drawer')) drawer.setAttribute('data-hh-cart-drawer', '');
    subtotal = drawer.querySelector('[data-hh-cart-subtotal]');
    checkout = drawer.querySelector('[data-hh-cart-checkout]');
    closeBtn = drawer.querySelector('[data-hh-cart-close]') || drawer.querySelector('.hh-cart-drawer__close');

    observeDrawerState();
    // Initial bind in case drawer is already open at load (rare)
    if (drawer.classList.contains('is-open') && !drawer.hasAttribute('hidden')){
      setOpen(true);
    }

    // Qty + close interactions are delegated on the drawer
    drawer.addEventListener('click', function(e){
      onQtyClick(e);
      if (closeBtn && (e.target === closeBtn || (e.target.closest && e.target.closest('[data-hh-cart-close]')))){
        onCloseClick(e);
      }
    });

    // Re-bind magnetic on cart refresh (fired by refreshCart in this file)
    d.addEventListener('cart:refresh', function(){
      if (isOpen) bindMagneticInDrawer();
    });

    // MQ change :: detach pointer if needed
    function onMQ(){
      if (reduce() || coarse()) detachSubtotalPointer();
      else if (isOpen) attachSubtotalPointer();
    }
    if (reduceMQ){
      if (typeof reduceMQ.addEventListener === 'function') reduceMQ.addEventListener('change', onMQ);
      else if (typeof reduceMQ.addListener === 'function') reduceMQ.addListener(onMQ);
    }
    if (coarseMQ){
      if (typeof coarseMQ.addEventListener === 'function') coarseMQ.addEventListener('change', onMQ);
      else if (typeof coarseMQ.addListener === 'function') coarseMQ.addListener(onMQ);
    }
  }

  if (d.readyState !== 'loading') boot();
  else d.addEventListener('DOMContentLoaded', boot);

  w.HH = Object.assign(w.HH || {}, {
    cartDrawer: {
      boot: boot,
      bindMagnetic: bindMagneticInDrawer,
      setOpen: setOpen
    }
  });
})(window, document);

/* Cycle 267 :: HH.scrollPaws
   Site-wide scroll-progress paw-stamp indicator.
   - Reads [data-hh-scroll-paws] rail with 12 .hh-scroll-paws__stamp children.
   - Seeds each stamp with a deterministic +/-6deg --rot CSS var.
   - rAF-throttled passive scroll listener computes window.scrollY /
     (documentElement.scrollHeight - innerHeight); maps progress to a count of
     visible stamps via Math.floor(progress * stamps.length); toggles the
     .is-visible class to fill/unfill the trail.
   - Self-suspends rAF loop when document.visibilityState === 'hidden';
     resumes on visibilitychange.
   - matchMedia gates: prefers-reduced-motion keeps progress logic but the
     CSS handles motion stripping; pointer:coarse hides the rail entirely.
   - Idempotent flag __hhScrollPawsBound. Live re-bind on matchMedia change.
   ========================================================= */
(function (w, d) {
  if (!w || !d) return;
  if (w.__hhScrollPawsBound) return;
  w.__hhScrollPawsBound = true;

  var RAIL_SEL  = '[data-hh-scroll-paws]';
  var STAMP_SEL = '.hh-scroll-paws__stamp';

  var coarseMQ = w.matchMedia ? w.matchMedia('(pointer: coarse)') : null;
  var narrowMQ = w.matchMedia ? w.matchMedia('(max-width: 760px)') : null;
  function isCoarse(){ return !!(coarseMQ && coarseMQ.matches); }
  function isNarrow(){ return !!(narrowMQ && narrowMQ.matches); }

  var rail = null;
  var stamps = [];
  var rafId = 0;
  var pending = false;
  var lastVisible = -1;

  function seedRotations(){
    for (var i = 0; i < stamps.length; i++){
      // Deterministic +/-6deg seeded by index parity for a typewriter wobble.
      var rot = (i % 2 === 0) ? 6 : -6;
      stamps[i].style.setProperty('--rot', rot + 'deg');
    }
  }

  function compute(){
    pending = false;
    if (!rail || !stamps.length) return;
    var doc = d.documentElement;
    var scrollable = (doc.scrollHeight - w.innerHeight);
    var progress = scrollable > 0 ? (w.scrollY / scrollable) : 0;
    if (progress < 0) progress = 0;
    if (progress > 1) progress = 1;
    var n = Math.floor(progress * stamps.length);
    // At full bottom, light all of them.
    if (progress >= 0.999) n = stamps.length;
    if (n === lastVisible) return;
    lastVisible = n;
    for (var i = 0; i < stamps.length; i++){
      if (i < n) stamps[i].classList.add('is-visible');
      else stamps[i].classList.remove('is-visible');
    }
  }

  function onScroll(){
    if (pending) return;
    if (d.visibilityState === 'hidden') return;
    pending = true;
    rafId = w.requestAnimationFrame(compute);
  }

  function attach(){
    if (!rail) return;
    if (isCoarse() || isNarrow()){
      rail.setAttribute('hidden', '');
      return;
    }
    rail.removeAttribute('hidden');
    seedRotations();
    compute();
  }

  function detach(){
    if (rafId){ w.cancelAnimationFrame(rafId); rafId = 0; }
    pending = false;
  }

  function onVisibility(){
    if (d.visibilityState === 'hidden'){
      detach();
    } else {
      // Resume: recompute now in case scroll happened while hidden.
      onScroll();
    }
  }

  function onMQ(){
    if (!rail) return;
    if (isCoarse() || isNarrow()){
      rail.setAttribute('hidden', '');
      detach();
    } else {
      rail.removeAttribute('hidden');
      onScroll();
    }
  }

  function boot(){
    rail = d.querySelector(RAIL_SEL);
    if (!rail) return;
    stamps = [].slice.call(rail.querySelectorAll(STAMP_SEL));
    if (!stamps.length) return;

    attach();

    w.addEventListener('scroll', onScroll, { passive: true });
    w.addEventListener('resize', onScroll, { passive: true });
    d.addEventListener('visibilitychange', onVisibility);

    if (coarseMQ){
      if (typeof coarseMQ.addEventListener === 'function') coarseMQ.addEventListener('change', onMQ);
      else if (typeof coarseMQ.addListener === 'function') coarseMQ.addListener(onMQ);
    }
    if (narrowMQ){
      if (typeof narrowMQ.addEventListener === 'function') narrowMQ.addEventListener('change', onMQ);
      else if (typeof narrowMQ.addListener === 'function') narrowMQ.addListener(onMQ);
    }
  }

  if (d.readyState !== 'loading') boot();
  else d.addEventListener('DOMContentLoaded', boot);

  w.HH = Object.assign(w.HH || {}, {
    scrollPaws: {
      boot: boot,
      compute: compute
    }
  });
})(window, document);

/* Cycle 268 :: HH.newsletter
   Editorial overhaul on the newsletter section.
   - IO 0.15 reveal toggle adds .is-revealed for per-glyph kinetic H.
   - rAF-throttled passive pointermove updates --mx/--my to drift the
     conic bloom-blob bg. Disabled under prefers-reduced-motion or
     pointer:coarse (CSS handles the fallback positioning).
   - Augments (does NOT replace) the existing Shopify customer form:
     listens for klaviyo:subscribed events, klaviyoForms hook fallback,
     and a MutationObserver on the section for `.hh-success` /
     `[data-hh-news-success]` flips done by upstream handlers. On any
     of those, adds .is-active to the success card so paws draw in.
   - Idempotent flag __hhNewsletterBound. Live re-bind on matchMedia.
   - Magnetic re-bind via window.HH.magnetic.bindNew(section).
   - shopify:section:load handler re-binds in section editor.
   ========================================================= */
(function (w, d) {
  if (!w || !d) return;
  if (w.__hhNewsletterBound) return;
  w.__hhNewsletterBound = true;

  var SECTION_SEL = '[data-hh-newsletter]';

  var reduceMQ = w.matchMedia ? w.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var coarseMQ = w.matchMedia ? w.matchMedia('(pointer: coarse)') : null;
  function prefersReduce(){ return !!(reduceMQ && reduceMQ.matches); }
  function isCoarse(){ return !!(coarseMQ && coarseMQ.matches); }

  function bindMagnetic(section){
    if (!section || prefersReduce() || isCoarse()) return;
    if (w.HH && w.HH.magnetic && typeof w.HH.magnetic.bindNew === 'function'){
      try { w.HH.magnetic.bindNew(section); } catch(_e){}
    }
  }

  function bindReveal(section){
    if (!section || section.__hhNewsRevealBound) return;
    section.__hhNewsRevealBound = true;
    if (prefersReduce() || !w.IntersectionObserver){
      section.classList.add('is-revealed');
      return;
    }
    var io = new w.IntersectionObserver(function (entries){
      for (var i = 0; i < entries.length; i++){
        var en = entries[i];
        if (en.isIntersecting){
          section.classList.add('is-revealed');
          io.disconnect();
          break;
        }
      }
    }, { threshold: 0.15 });
    io.observe(section);
    section.__hhNewsRevealIO = io;
  }

  function bindBloom(section){
    if (!section || section.__hhNewsBloomBound) return;
    if (prefersReduce() || isCoarse()) return;
    section.__hhNewsBloomBound = true;

    var rafId = 0;
    var px = 0.5, py = 0.5;
    function onMove(ev){
      var rect = section.getBoundingClientRect();
      if (rect.width <= 0 || rect.height <= 0) return;
      px = (ev.clientX - rect.left) / rect.width;
      py = (ev.clientY - rect.top) / rect.height;
      if (px < 0) px = 0; if (px > 1) px = 1;
      if (py < 0) py = 0; if (py > 1) py = 1;
      if (rafId) return;
      rafId = w.requestAnimationFrame(function (){
        rafId = 0;
        section.style.setProperty('--mx', px.toFixed(3));
        section.style.setProperty('--my', py.toFixed(3));
      });
    }
    function onLeave(){
      if (rafId){ w.cancelAnimationFrame(rafId); rafId = 0; }
      section.style.removeProperty('--mx');
      section.style.removeProperty('--my');
    }

    section.addEventListener('pointermove', onMove, { passive: true });
    section.addEventListener('pointerleave', onLeave, { passive: true });
    section.__hhNewsBloomMove  = onMove;
    section.__hhNewsBloomLeave = onLeave;
  }

  function unbindBloom(section){
    if (!section || !section.__hhNewsBloomBound) return;
    if (section.__hhNewsBloomMove)  section.removeEventListener('pointermove', section.__hhNewsBloomMove);
    if (section.__hhNewsBloomLeave) section.removeEventListener('pointerleave', section.__hhNewsBloomLeave);
    section.style.removeProperty('--mx');
    section.style.removeProperty('--my');
    section.__hhNewsBloomBound = false;
    section.__hhNewsBloomMove  = null;
    section.__hhNewsBloomLeave = null;
  }

  function activateSuccess(section){
    if (!section) return;
    var cards = section.querySelectorAll('[data-hh-news-success]');
    for (var i = 0; i < cards.length; i++){
      var card = cards[i];
      if (card.hasAttribute('hidden')) card.removeAttribute('hidden');
      card.classList.add('is-active');
    }
  }

  function bindFormHooks(section){
    if (!section || section.__hhNewsFormBound) return;
    section.__hhNewsFormBound = true;

    var form = section.querySelector('form');

    // Klaviyo native event :: augment, do not replace
    var onKlaviyo = function (e){
      if (!e) return;
      var detail = e.detail || {};
      var type = (detail && detail.type) || '';
      if (type === 'submit' || type === 'success' || type === 'subscribed'){
        activateSuccess(section);
      }
    };
    d.addEventListener('klaviyoForms', onKlaviyo);
    d.addEventListener('klaviyo:subscribed', function(){ activateSuccess(section); });
    section.__hhNewsKlaviyoHandler = onKlaviyo;

    // Custom HH event hatch :: anyone can dispatch this on the section
    section.addEventListener('hh:newsletter:success', function(){ activateSuccess(section); });

    // Form submit :: do not block; if upstream handler later flips a
    // .hh-success class or sets data-hh-news-success aria-live, the
    // MutationObserver below will activate. We only optimistically flip
    // when no errors are present after a microtask.
    if (form){
      form.addEventListener('submit', function(){
        // Optimistic: if Shopify customer form posts and reloads with
        // form.posted_successfully?, the .is-active class is already in
        // markup. Klaviyo embeds reuse the same section + emit events.
      });
    }

    // MutationObserver fallback :: watch for upstream success markers
    if (w.MutationObserver){
      var mo = new w.MutationObserver(function (muts){
        for (var i = 0; i < muts.length; i++){
          var m = muts[i];
          if (m.type === 'attributes' || m.type === 'childList'){
            // Look for any sibling with .hh-success class added by
            // theme handler, or aria-live update on the success card.
            if (section.querySelector('.hh-success, [data-hh-news-success].is-active')){
              activateSuccess(section);
            }
          }
        }
      });
      mo.observe(section, {
        attributes: true,
        attributeFilter: ['class', 'aria-live', 'data-state'],
        subtree: true,
        childList: true
      });
      section.__hhNewsMO = mo;
    }
  }

  function bindSection(section){
    if (!section || section.__hhNewsletterSectionBound) return;
    section.__hhNewsletterSectionBound = true;
    bindReveal(section);
    bindBloom(section);
    bindFormHooks(section);
    bindMagnetic(section);
  }

  function boot(){
    var nodes = d.querySelectorAll(SECTION_SEL);
    for (var i = 0; i < nodes.length; i++) bindSection(nodes[i]);
  }

  function rebind(){
    var nodes = d.querySelectorAll(SECTION_SEL);
    for (var i = 0; i < nodes.length; i++){
      var s = nodes[i];
      unbindBloom(s);
      if (prefersReduce()){
        s.classList.add('is-revealed');
      } else if (!isCoarse()){
        bindBloom(s);
      }
    }
  }

  function attachMQ(mq, fn){
    if (!mq) return;
    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', fn);
    else if (typeof mq.addListener === 'function') mq.addListener(fn);
  }
  attachMQ(reduceMQ, rebind);
  attachMQ(coarseMQ, rebind);

  if (d.readyState !== 'loading') boot();
  else d.addEventListener('DOMContentLoaded', boot);

  // Shopify section editor live preview
  d.addEventListener('shopify:section:load', function (ev){
    if (ev && ev.target && ev.target.querySelector){
      var s = ev.target.matches && ev.target.matches(SECTION_SEL)
        ? ev.target
        : ev.target.querySelector(SECTION_SEL);
      if (s) bindSection(s);
    }
  });

  w.HH = Object.assign(w.HH || {}, {
    newsletter: {
      boot:    boot,
      rebind:  rebind,
      success: activateSuccess
    }
  });
})(window, document);

/* Cycle 269 :: HH.pdpGallery :: editorial lens zoom + swatch FLIP cross-fade */
(function (w, d) {
  if (w.__hhPdpGalleryBound) return;
  w.__hhPdpGalleryBound = true;

  var FRAME_SEL = '.hh-product__media-frame';
  var IMG_SEL = '[data-hh-pdp-img]';
  var ZOOM_SEL = '[data-hh-pdp-zoom]';
  var SWATCH_SEL = '.hh-swatch__chip[data-variant-image], .hh-swatch__btn[data-variant-image]';
  var INPUT_SEL = '.hh-swatch__input';

  var reduceMQ = w.matchMedia('(prefers-reduced-motion: reduce)');
  var coarseMQ = w.matchMedia('(pointer: coarse)');

  function shouldDisableLens(){
    return (reduceMQ && reduceMQ.matches) || (coarseMQ && coarseMQ.matches);
  }
  function shouldInstantSwap(){
    return reduceMQ && reduceMQ.matches;
  }

  function clamp(n, min, max){ return n < min ? min : (n > max ? max : n); }

  function bindFrame(frame){
    if (!frame || frame.__hhPdpBound) return;
    frame.__hhPdpBound = true;

    var img = frame.querySelector(IMG_SEL);
    var zoom = frame.querySelector(ZOOM_SEL);
    if (!img) return;

    /* Lens zoom :: pointermove (rAF passive) */
    var rafId = 0;
    var lastX = 50, lastY = 50;
    function applyVars(){
      rafId = 0;
      frame.style.setProperty('--lx', lastX + '%');
      frame.style.setProperty('--ly', lastY + '%');
      frame.style.setProperty('--mx', lastX + '%');
      frame.style.setProperty('--my', lastY + '%');
    }
    function onPointerEnter(){
      if (shouldDisableLens()) return;
      frame.classList.add('is-zooming');
    }
    function onPointerMove(e){
      if (shouldDisableLens()) return;
      var r = frame.getBoundingClientRect();
      if (!r.width || !r.height) return;
      lastX = clamp(((e.clientX - r.left) / r.width) * 100, 0, 100);
      lastY = clamp(((e.clientY - r.top) / r.height) * 100, 0, 100);
      if (!rafId) rafId = w.requestAnimationFrame(applyVars);
    }
    function onPointerLeave(){
      frame.classList.remove('is-zooming');
      lastX = 50; lastY = 50;
      if (!rafId) rafId = w.requestAnimationFrame(applyVars);
    }
    if (frame.matches('[data-hh-pdp-lens]')){
      frame.addEventListener('pointerenter', onPointerEnter, { passive: true });
      frame.addEventListener('pointermove',  onPointerMove,  { passive: true });
      frame.addEventListener('pointerleave', onPointerLeave, { passive: true });
    }

    /* Swatch / thumbnail cross-fade :: single owner of every main-image swap.
       An absolutely-positioned clone holds the OLD pixels above the base img while
       the base img loads the new src underneath, then the clone fades out -> a true
       crossfade with zero layout shift (frame reserves aspect-ratio + overflow:hidden).
       Reduced-motion or flip-disabled frames swap instantly. */
    function flipTo(newSrc){
      if (!newSrc || !img) return;
      if (img.getAttribute('src') === newSrc) return;
      if (frame.__hhFlipTarget === newSrc) return; /* dedupe capture + bubble calls */

      var animate = frame.matches('[data-hh-pdp-flip]') && !shouldInstantSwap();
      frame.__hhFlipTarget = newSrc;

      if (!animate){
        img.srcset = '';
        img.src = newSrc;
        if (zoom && zoom.src !== newSrc) zoom.src = newSrc;
        frame.__hhFlipTarget = null;
        return;
      }

      var overlay = img.cloneNode(false);
      overlay.removeAttribute('id');
      overlay.removeAttribute('data-hh-pdp-img');
      overlay.setAttribute('aria-hidden', 'true');
      overlay.className = 'hh-product__media-flash';
      frame.insertBefore(overlay, img.nextSibling);
      void overlay.offsetWidth; /* commit start state before transition */

      var done = false;
      function cleanup(){
        if (done) return;
        done = true;
        if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
        if (zoom && zoom.src !== img.src) zoom.src = img.src;
        if (frame.__hhFlipTarget === newSrc) frame.__hhFlipTarget = null;
      }
      function fadeOut(){
        if (overlay.classList.contains('is-out')) return;
        overlay.addEventListener('transitionend', cleanup, { once: true });
        overlay.classList.add('is-out');
        w.setTimeout(cleanup, 520); /* failsafe > 320ms transition */
      }

      img.addEventListener('load', fadeOut, { once: true });
      img.srcset = '';
      img.src = newSrc;
      /* cached/synchronous decode: load may have already fired */
      w.requestAnimationFrame(function(){ if (img.complete) fadeOut(); });
    }
    frame.__hhFlipTo = flipTo;

    /* Listen on document scope for variant-driven swaps so we cooperate with existing handlers */
    function findFrameForTarget(target){
      var f = target && target.closest ? target.closest(FRAME_SEL) : null;
      if (f) return f === frame ? frame : null;
      /* fallback: only one PDP frame on a product page */
      return frame;
    }

    function onSwatchChange(e){
      var t = e.target;
      if (!t) return;
      if (t.matches && t.matches(INPUT_SEL)){
        var label = t.labels && t.labels[0];
        if (!label) return;
        var src = label.getAttribute('data-variant-image');
        if (src) flipTo(src);
      }
    }
    function onSwatchClick(e){
      var t = e.target && e.target.closest ? e.target.closest(SWATCH_SEL) : null;
      if (!t) return;
      var src = t.getAttribute('data-variant-image');
      if (src) flipTo(src);
    }

    /* capture phase :: run before existing inline variant handler so we can stage the flip */
    d.addEventListener('change', onSwatchChange, { capture: true, passive: true });
    d.addEventListener('click',  onSwatchClick,  { capture: true, passive: true });

    /* Sync zoom layer when something else (e.g. existing thumb handler) swaps the main img */
    if (zoom && 'MutationObserver' in w){
      var mo = new MutationObserver(function(muts){
        for (var i = 0; i < muts.length; i++){
          if (muts[i].attributeName === 'src'){
            zoom.src = img.src;
          }
        }
      });
      mo.observe(img, { attributes: true, attributeFilter: ['src'] });
    }
  }

  function bootAll(root){
    var scope = root && root.querySelectorAll ? root : d;
    var frames = scope.querySelectorAll(FRAME_SEL);
    for (var i = 0; i < frames.length; i++) bindFrame(frames[i]);
  }

  if (d.readyState !== 'loading') bootAll(d);
  else d.addEventListener('DOMContentLoaded', function(){ bootAll(d); });

  d.addEventListener('shopify:section:load', function(ev){
    if (ev && ev.target) bootAll(ev.target);
  });

  w.HH = Object.assign(w.HH || {}, {
    pdpGallery: {
      boot: bootAll,
      bind: bindFrame,
      flip: function (src) {
        var f = d.querySelector(FRAME_SEL);
        if (f && f.__hhFlipTo) f.__hhFlipTo(src);
      }
    }
  });
})(window, document);

/* =========================================================
   Cycle 270 :: HH.iwt
   Editorial image-with-text overhaul. Per instance:
   - Deterministic seed -> small Ken Burns translate offset
   - IO 0.18 -> .is-revealed (kinetic glyph H)
   - IO 0.10 -> arm Ken Burns rAF (1.0 -> 1.08 over 12000ms,
     ease-out-cubic). Disarm when leaving viewport.
   - Single shared rAF loop drives all visible instances.
   - matchMedia gates: prefers-reduced-motion disables both
     Ken Burns and kinetic. Ken Burns kept on coarse pointers.
   - Idempotent flag __hhIwtBound. shopify:section:load handler.
   ========================================================= */
(function(w, d){
  'use strict';
  if (!w || !d) return;

  var SEL = '[data-hh-iwt]';
  var KB_MAX  = 1.08;
  var KB_MIN  = 1.00;
  var KB_DUR  = 12000;
  var OFFSET_MAX_PCT = 1.5;

  var reduceMQ = w.matchMedia ? w.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function prefersReduce(){ return !!(reduceMQ && reduceMQ.matches); }

  // small deterministic hash -> [-1, 1]
  function hash01(seed){
    var s = String(seed || '0');
    var h = 2166136261;
    for (var i = 0; i < s.length; i++){
      h ^= s.charCodeAt(i);
      h = (h * 16777619) >>> 0;
    }
    return (h >>> 0) / 4294967295;
  }
  function seedOffset(seed, salt){
    var n = hash01(seed + ':' + salt);
    return (n * 2 - 1) * OFFSET_MAX_PCT; // +/- 1.5%
  }

  // ease-out-cubic
  function easeOutCubic(t){ return 1 - Math.pow(1 - t, 3); }

  var armed = []; // { el, start, kxBase, kyBase, active }
  var rafId  = 0;

  function tick(now){
    rafId = 0;
    if (!armed.length) return;
    var any = false;
    for (var i = 0; i < armed.length; i++){
      var inst = armed[i];
      if (!inst.active) continue;
      var t = (now - inst.start) / KB_DUR;
      if (t < 0) t = 0;
      if (t > 1){
        // hold at peak; do not loop
        t = 1;
      }
      var eased = easeOutCubic(t);
      var kb = KB_MIN + (KB_MAX - KB_MIN) * eased;
      // gentle drift on x/y from base seed offset
      var kx = inst.kxBase * eased;
      var ky = inst.kyBase * eased;
      inst.el.style.setProperty('--kb', kb.toFixed(4));
      inst.el.style.setProperty('--kx', kx.toFixed(3) + '%');
      inst.el.style.setProperty('--ky', ky.toFixed(3) + '%');
      if (t < 1) any = true;
    }
    if (any) rafId = w.requestAnimationFrame(tick);
  }

  function ensureLoop(){
    if (rafId) return;
    rafId = w.requestAnimationFrame(tick);
  }

  function arm(inst){
    if (inst.active) return;
    inst.active = true;
    inst.start  = (w.performance && w.performance.now) ? w.performance.now() : Date.now();
    ensureLoop();
  }
  function disarm(inst){
    inst.active = false;
  }

  function bindOne(el){
    if (!el || el.__hhIwtBound) return;
    el.__hhIwtBound = true;

    var seed = el.getAttribute('data-seed') || (el.id || 'iwt');
    var kbEnabled = el.getAttribute('data-kb') !== '0';
    var khEnabled = el.getAttribute('data-kh') !== '0';

    var kxBase = seedOffset(seed, 'x');
    var kyBase = seedOffset(seed, 'y');
    el.style.setProperty('--kx', '0%');
    el.style.setProperty('--ky', '0%');
    el.style.setProperty('--kb', '1');

    var inst = { el: el, start: 0, kxBase: kxBase, kyBase: kyBase, active: false };

    // Kinetic headline reveal (one-shot)
    if (khEnabled && !prefersReduce() && 'IntersectionObserver' in w){
      var revealIO = new IntersectionObserver(function(entries){
        for (var i = 0; i < entries.length; i++){
          if (entries[i].isIntersecting){
            el.classList.add('is-revealed');
            revealIO.disconnect();
            break;
          }
        }
      }, { threshold: 0.18, rootMargin: '0px 0px -10% 0px' });
      revealIO.observe(el);
    } else {
      el.classList.add('is-revealed');
    }

    // Ken Burns arm/disarm (passive, viewport-driven)
    if (kbEnabled && !prefersReduce() && 'IntersectionObserver' in w){
      armed.push(inst);
      var kbIO = new IntersectionObserver(function(entries){
        for (var i = 0; i < entries.length; i++){
          var e = entries[i];
          if (e.isIntersecting) arm(inst);
          else disarm(inst);
        }
      }, { threshold: 0.10 });
      kbIO.observe(el);
    }
  }

  function bootAll(root){
    var scope = root && root.querySelectorAll ? root : d;
    var nodes = scope.querySelectorAll(SEL);
    for (var i = 0; i < nodes.length; i++) bindOne(nodes[i]);
  }

  if (d.readyState !== 'loading') bootAll(d);
  else d.addEventListener('DOMContentLoaded', function(){ bootAll(d); });

  d.addEventListener('shopify:section:load', function(ev){
    if (ev && ev.target) bootAll(ev.target);
  });

  // Reduced-motion live toggle
  if (reduceMQ && reduceMQ.addEventListener){
    reduceMQ.addEventListener('change', function(){
      if (prefersReduce()){
        for (var i = 0; i < armed.length; i++){
          armed[i].active = false;
          armed[i].el.style.setProperty('--kb', '1');
          armed[i].el.style.setProperty('--kx', '0%');
          armed[i].el.style.setProperty('--ky', '0%');
        }
      }
    });
  }

  w.HH = Object.assign(w.HH || {}, {
    iwt: { boot: bootAll, bind: bindOne }
  });
})(window, document);

/* Cycle 271 :: HH.predictive :: editorial gallery + animated empty state
   Strictly additive. Preserves existing fetch, ARIA, focus, ESC, arrow-key.
   Decorates results injected by the predictive search overlay with:
     1. data-hh-predictive-result + --i stagger
     2. .hh-photo class on result imagery (canon §9 filter chain)
     3. paper-grain shimmer loading swap (replaces hh-skel skeleton)
     4. animated empty state with paw cascade (canon §2)
     5. magnetic CTA rebind on freshly rendered panels
     6. pointermove bloom tracking via --mx --my CSS vars
*/
(function(w, d){
  var SEL_PANEL = '[data-hh-predictive]';
  var SEL_RESULTS = '[data-search-results]';
  var SEL_EMPTY = '[data-hh-predictive-empty]';
  var SEL_LOADING_TPL = '[data-hh-predictive-loading]';
  var SEL_NORESULTS = '.hh-searchdlg__noresults';
  var SEL_SKEL = '.hh-skel';
  var SEL_ITEM = '.hh-searchdlg__item';

  var reduceMQ = w.matchMedia ? w.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var coarseMQ = w.matchMedia ? w.matchMedia('(pointer: coarse)') : null;
  function prefersReduce(){ return !!(reduceMQ && reduceMQ.matches); }
  function isCoarse(){ return !!(coarseMQ && coarseMQ.matches); }

  function decorateResult(el, i){
    if (!el || el.__hhPredDecorated) {
      el.style.setProperty('--i', String(i));
      return;
    }
    el.__hhPredDecorated = true;
    el.setAttribute('data-hh-predictive-result', '');
    el.style.setProperty('--i', String(i));

    /* §9 photo treatment :: promote inner img */
    var img = el.querySelector('img');
    if (img && !img.classList.contains('hh-photo')){
      img.classList.add('hh-photo');
    }

    /* pointermove bloom :: rAF throttled */
    if (!prefersReduce() && !isCoarse()){
      var rafId = 0;
      var lastX = 0, lastY = 0;
      function paint(){
        rafId = 0;
        el.style.setProperty('--mx', lastX + '%');
        el.style.setProperty('--my', lastY + '%');
      }
      el.addEventListener('pointermove', function(ev){
        var rect = el.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        lastX = ((ev.clientX - rect.left) / rect.width) * 100;
        lastY = ((ev.clientY - rect.top) / rect.height) * 100;
        if (!rafId) rafId = w.requestAnimationFrame(paint);
      }, { passive: true });
      el.addEventListener('pointerleave', function(){
        el.style.setProperty('--mx', '50%');
        el.style.setProperty('--my', '50%');
      }, { passive: true });
    }
  }

  function swapSkeletonForEditorialLoader(panel, results){
    /* Detect the existing saas-style hh-skel skeleton; swap it for our paper-grain shimmer loader.
       Uses the <template data-hh-predictive-loading> baked into the snippet. */
    var skels = results.querySelectorAll(SEL_SKEL);
    if (!skels.length) return false;
    var tpl = panel.querySelector(SEL_LOADING_TPL);
    if (!tpl || !tpl.content) return false;
    var clone = tpl.content.cloneNode(true);
    /* Replace the entire skeleton group :: walk up to .hh-searchdlg__group if present */
    var group = skels[0].closest('.hh-searchdlg__group') || skels[0].parentNode;
    if (!group || !group.parentNode) return false;
    /* Wipe siblings only inside the skel group; existing fetch logic is left untouched */
    group.parentNode.replaceChild(clone, group);
    return true;
  }

  function applyReveal(panel, items){
    if (prefersReduce()){
      panel.classList.add('is-revealed');
      return;
    }
    panel.classList.remove('is-revealed');
    /* double-rAF lets the browser paint opacity:0 / clipped state before the reveal class flips */
    w.requestAnimationFrame(function(){
      w.requestAnimationFrame(function(){
        panel.classList.add('is-revealed');
      });
    });
  }

  function showEditorialEmpty(panel, results){
    var empty = panel.querySelector(SEL_EMPTY);
    if (!empty) return;
    /* hide the existing noresults block additively (do not delete it) */
    var nores = results.querySelector(SEL_NORESULTS);
    if (nores) nores.setAttribute('hidden', '');
    empty.removeAttribute('hidden');
    /* paw cascade kick :: trigger after layout */
    empty.classList.remove('is-active');
    if (prefersReduce()){
      empty.classList.add('is-active');
    } else {
      w.requestAnimationFrame(function(){
        w.requestAnimationFrame(function(){
          empty.classList.add('is-active');
        });
      });
    }
    /* rebind magnetic on the empty state CTA */
    if (w.HH && w.HH.magnetic && typeof w.HH.magnetic.bindNew === 'function'){
      w.HH.magnetic.bindNew(empty);
    }
  }

  function hideEditorialEmpty(panel){
    var empty = panel.querySelector(SEL_EMPTY);
    if (!empty) return;
    empty.classList.remove('is-active');
    empty.setAttribute('hidden', '');
  }

  function processResults(panel, results){
    /* 1. loading state :: paper-grain shimmer swap */
    if (swapSkeletonForEditorialLoader(panel, results)){
      panel.classList.remove('is-revealed');
      hideEditorialEmpty(panel);
      return;
    }

    var items = results.querySelectorAll(SEL_ITEM);
    var hasNoResults = !!results.querySelector(SEL_NORESULTS);
    var input = panel.querySelector('#HHSearchInput');
    var hasQuery = !!(input && input.value && input.value.trim());

    /* 2. empty state :: query issued, no items rendered (or noresults block present) */
    if (hasQuery && (items.length === 0 || hasNoResults)){
      panel.classList.remove('is-revealed');
      showEditorialEmpty(panel, results);
      return;
    }

    /* 3. populated state :: stagger + reveal + magnetic rebind */
    hideEditorialEmpty(panel);
    if (items.length === 0){
      /* idle/empty default surface :: nothing to reveal */
      return;
    }
    var max = Math.min(items.length, 12);
    for (var i = 0; i < items.length; i++){
      decorateResult(items[i], i < max ? i : max - 1);
    }
    applyReveal(panel, items);
    if (w.HH && w.HH.magnetic && typeof w.HH.magnetic.bindNew === 'function'){
      w.HH.magnetic.bindNew(panel);
    }
  }

  function bindPanel(panel){
    if (!panel || panel.__hhPredictiveBound) return;
    panel.__hhPredictiveBound = true;
    var results = panel.querySelector(SEL_RESULTS);
    if (!results) return;

    /* MutationObserver :: react to every fetch render without touching existing fetch fn */
    var pending = false;
    var mo = new MutationObserver(function(){
      if (pending) return;
      pending = true;
      w.requestAnimationFrame(function(){
        pending = false;
        try { processResults(panel, results); } catch(_){}
      });
    });
    mo.observe(results, { childList: true, subtree: true });

    /* Shopify lifecycle + custom predictive event */
    function refresh(){ try { processResults(panel, results); } catch(_){} }
    d.addEventListener('shopify:section:load', refresh);
    d.addEventListener('predictive-search:rendered', refresh);

    /* matchMedia toggles :: re-process on motion/coarse change */
    function onMQ(){ refresh(); }
    if (reduceMQ){
      if (reduceMQ.addEventListener) reduceMQ.addEventListener('change', onMQ);
      else if (reduceMQ.addListener) reduceMQ.addListener(onMQ);
    }
    if (coarseMQ){
      if (coarseMQ.addEventListener) coarseMQ.addEventListener('change', onMQ);
      else if (coarseMQ.addListener) coarseMQ.addListener(onMQ);
    }

    /* Initial pass :: handle server-rendered empty surface */
    refresh();
  }

  function boot(root){
    var scope = (root && root.querySelectorAll) ? root : d;
    var panels = scope.querySelectorAll(SEL_PANEL);
    for (var i = 0; i < panels.length; i++) bindPanel(panels[i]);
  }

  if (d.readyState !== 'loading') boot(d);
  else d.addEventListener('DOMContentLoaded', function(){ boot(d); });

  d.addEventListener('shopify:section:load', function(ev){
    if (ev && ev.target) boot(ev.target);
  });

  w.HH = Object.assign(w.HH || {}, {
    predictive: {
      boot: boot,
      bindNew: bindPanel
    }
  });
})(window, document);

/* Cycle 272 :: HH.productBenefits
   PDP product-benefits surface enhancement (paired with styles.css block).
   - IO 0.18 fires .is-revealed once on the section so per-block + per-glyph
     cascades trigger together (CSS handles the staggered timing).
   - rAF-throttled passive pointermove writes --mx/--my as percentage CSS
     vars on each [data-hh-benefit] so the conic golden-hour bloom tracks
     the cursor.
   - Decorates [data-hh-benefit-icon] nodes with data-hh-magnetic so the
     existing cycle 259 magnetic system picks them up, then calls
     window.HH.magnetic.bindNew(section) to bind freshly added nodes.
   - matchMedia gates: bypass bloom + magnetic on (prefers-reduced-motion)
     or (pointer: coarse). Live re-bind on MQ change.
   - Idempotent flag __hhProductBenefitsBound. shopify:section:load handler.
   ============================================================ */
(function (w, d) {
  if (!w || !d) return;
  if (w.__hhProductBenefitsBound) return;
  w.__hhProductBenefitsBound = true;

  var SECTION_SEL = '[data-hh-product-benefits]';
  var BENEFIT_SEL = '[data-hh-benefit]';
  var ICON_SEL = '[data-hh-benefit-icon]';

  var reduceMQ = w.matchMedia ? w.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var coarseMQ = w.matchMedia ? w.matchMedia('(pointer: coarse)') : null;
  function prefersReduce(){ return !!(reduceMQ && reduceMQ.matches); }
  function isCoarse(){ return !!(coarseMQ && coarseMQ.matches); }

  function decorateIcons(section){
    if (!section) return;
    var icons = section.querySelectorAll(ICON_SEL);
    for (var i = 0; i < icons.length; i++){
      if (!icons[i].hasAttribute('data-hh-magnetic')){
        icons[i].setAttribute('data-hh-magnetic', '');
      }
    }
  }

  function bindMagnetic(section){
    if (!section || prefersReduce() || isCoarse()) return;
    if (w.HH && w.HH.magnetic && typeof w.HH.magnetic.bindNew === 'function'){
      try { w.HH.magnetic.bindNew(section); } catch(_e){}
    }
  }

  function bindReveal(section){
    if (!section || section.__hhPbRevealBound) return;
    section.__hhPbRevealBound = true;
    if (prefersReduce() || !w.IntersectionObserver){
      section.classList.add('is-revealed');
      return;
    }
    var io = new w.IntersectionObserver(function (entries){
      for (var i = 0; i < entries.length; i++){
        var en = entries[i];
        if (en.isIntersecting){
          section.classList.add('is-revealed');
          io.disconnect();
          break;
        }
      }
    }, { threshold: 0.18 });
    io.observe(section);
  }

  function bindBloom(section){
    if (!section || section.__hhPbBloomBound) return;
    if (prefersReduce() || isCoarse()) return;
    section.__hhPbBloomBound = true;

    var benefits = section.querySelectorAll(BENEFIT_SEL);
    for (var i = 0; i < benefits.length; i++){
      attachBloom(benefits[i]);
    }
  }

  function attachBloom(node){
    if (!node || node.__hhPbBloomNodeBound) return;
    node.__hhPbBloomNodeBound = true;

    var ticking = false;
    var pendingX = 50;
    var pendingY = 30;

    function flush(){
      ticking = false;
      try {
        node.style.setProperty('--mx', pendingX.toFixed(2) + '%');
        node.style.setProperty('--my', pendingY.toFixed(2) + '%');
      } catch(_e){}
    }

    function onMove(ev){
      var rect = node.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      var px = ((ev.clientX - rect.left) / rect.width) * 100;
      var py = ((ev.clientY - rect.top) / rect.height) * 100;
      if (px < 0) px = 0; else if (px > 100) px = 100;
      if (py < 0) py = 0; else if (py > 100) py = 100;
      pendingX = px;
      pendingY = py;
      if (!ticking){
        ticking = true;
        w.requestAnimationFrame(flush);
      }
    }

    function onLeave(){
      pendingX = 50;
      pendingY = 30;
      if (!ticking){
        ticking = true;
        w.requestAnimationFrame(flush);
      }
    }

    node.addEventListener('pointermove', onMove, { passive: true });
    node.addEventListener('pointerleave', onLeave, { passive: true });

    node.__hhPbBloomOff = function(){
      try { node.removeEventListener('pointermove', onMove); } catch(_e){}
      try { node.removeEventListener('pointerleave', onLeave); } catch(_e){}
      node.__hhPbBloomNodeBound = false;
    };
  }

  function teardownBloom(section){
    if (!section) return;
    var benefits = section.querySelectorAll(BENEFIT_SEL);
    for (var i = 0; i < benefits.length; i++){
      var b = benefits[i];
      if (typeof b.__hhPbBloomOff === 'function') b.__hhPbBloomOff();
      try {
        b.style.removeProperty('--mx');
        b.style.removeProperty('--my');
      } catch(_e){}
    }
    section.__hhPbBloomBound = false;
  }

  function bindSection(section){
    if (!section) return;
    decorateIcons(section);
    bindReveal(section);
    bindBloom(section);
    bindMagnetic(section);
  }

  function rebind(){
    var sections = d.querySelectorAll(SECTION_SEL);
    for (var i = 0; i < sections.length; i++){
      var s = sections[i];
      teardownBloom(s);
      // Re-bind bloom + magnetic per current MQ state. Reveal stays intact.
      bindBloom(s);
      bindMagnetic(s);
    }
  }

  function attachMQ(mq, fn){
    if (!mq) return;
    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', fn);
    else if (typeof mq.addListener === 'function') mq.addListener(fn);
  }

  function boot(root){
    var scope = (root && root.querySelectorAll) ? root : d;
    var sections = scope.querySelectorAll(SECTION_SEL);
    for (var i = 0; i < sections.length; i++) bindSection(sections[i]);
  }

  if (d.readyState !== 'loading') boot(d);
  else d.addEventListener('DOMContentLoaded', function(){ boot(d); });

  d.addEventListener('shopify:section:load', function(ev){
    if (ev && ev.target){
      // ev.target may be a wrapper around the section root.
      var root = ev.target;
      var inner = root.querySelector ? root.querySelector(SECTION_SEL) : null;
      if (inner){
        // Force re-bind: clear flags so a re-injected section picks up fresh.
        inner.__hhPbRevealBound = false;
        bindSection(inner);
      } else {
        boot(root);
      }
    }
  });

  attachMQ(reduceMQ, rebind);
  attachMQ(coarseMQ, rebind);

  w.HH = Object.assign(w.HH || {}, {
    productBenefits: {
      boot: boot,
      bindNew: bindSection,
      rebind: rebind
    }
  });
})(window, document);

/* Cycle 273 :: HH.productTrust
   PDP product-trust pill surface enhancement (paired with styles.css block).
   - IO 0.18 fires .is-revealed once on the section so per-pill stagger
     reveal cascades together (CSS handles the staggered timing via --i).
   - rAF-throttled passive pointermove writes --mx/--my as percentage CSS
     vars on each [data-hh-trust-pill] so the conic golden-hour bloom tracks
     the cursor.
   - Decorates icon containers with data-hh-magnetic so the existing cycle
     259 magnetic system picks them up, then calls
     window.HH.magnetic.bindNew(section) to bind freshly added nodes.
   - matchMedia gates: bypass bloom + magnetic on (prefers-reduced-motion)
     or (pointer: coarse). Live re-bind on MQ change.
   - Idempotent flag __hhProductTrustBound. shopify:section:load handler.
   ============================================================ */
(function (w, d) {
  if (!w || !d) return;
  if (w.__hhProductTrustBound) return;
  w.__hhProductTrustBound = true;

  var SECTION_SEL = '[data-hh-product-trust]';
  var PILL_SEL = '[data-hh-trust-pill]';
  var ICON_SEL = '[data-hh-trust-icon]';

  var reduceMQ = w.matchMedia ? w.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var coarseMQ = w.matchMedia ? w.matchMedia('(pointer: coarse)') : null;
  function prefersReduce(){ return !!(reduceMQ && reduceMQ.matches); }
  function isCoarse(){ return !!(coarseMQ && coarseMQ.matches); }

  function decorateIcons(section){
    if (!section) return;
    var icons = section.querySelectorAll(ICON_SEL);
    for (var i = 0; i < icons.length; i++){
      if (!icons[i].hasAttribute('data-hh-magnetic')){
        icons[i].setAttribute('data-hh-magnetic', '');
      }
    }
  }

  function bindMagnetic(section){
    if (!section || prefersReduce() || isCoarse()) return;
    if (w.HH && w.HH.magnetic && typeof w.HH.magnetic.bindNew === 'function'){
      try { w.HH.magnetic.bindNew(section); } catch(_e){}
    }
  }

  function bindReveal(section){
    if (!section || section.__hhPtRevealBound) return;
    section.__hhPtRevealBound = true;
    if (prefersReduce() || !w.IntersectionObserver){
      section.classList.add('is-revealed');
      return;
    }
    var io = new w.IntersectionObserver(function (entries){
      for (var i = 0; i < entries.length; i++){
        var en = entries[i];
        if (en.isIntersecting){
          section.classList.add('is-revealed');
          io.disconnect();
          break;
        }
      }
    }, { threshold: 0.18 });
    io.observe(section);
  }

  function attachBloom(node){
    if (!node || node.__hhPtBloomNodeBound) return;
    node.__hhPtBloomNodeBound = true;

    var ticking = false;
    var pendingX = 50;
    var pendingY = 30;

    function flush(){
      ticking = false;
      try {
        node.style.setProperty('--mx', pendingX.toFixed(2) + '%');
        node.style.setProperty('--my', pendingY.toFixed(2) + '%');
      } catch(_e){}
    }

    function onMove(ev){
      var rect = node.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      var px = ((ev.clientX - rect.left) / rect.width) * 100;
      var py = ((ev.clientY - rect.top) / rect.height) * 100;
      if (px < 0) px = 0; else if (px > 100) px = 100;
      if (py < 0) py = 0; else if (py > 100) py = 100;
      pendingX = px;
      pendingY = py;
      if (!ticking){
        ticking = true;
        w.requestAnimationFrame(flush);
      }
    }

    function onLeave(){
      pendingX = 50;
      pendingY = 30;
      if (!ticking){
        ticking = true;
        w.requestAnimationFrame(flush);
      }
    }

    node.addEventListener('pointermove', onMove, { passive: true });
    node.addEventListener('pointerleave', onLeave, { passive: true });

    node.__hhPtBloomOff = function(){
      try { node.removeEventListener('pointermove', onMove); } catch(_e){}
      try { node.removeEventListener('pointerleave', onLeave); } catch(_e){}
      node.__hhPtBloomNodeBound = false;
    };
  }

  function bindBloom(section){
    if (!section || section.__hhPtBloomBound) return;
    if (prefersReduce() || isCoarse()) return;
    section.__hhPtBloomBound = true;

    var pills = section.querySelectorAll(PILL_SEL);
    for (var i = 0; i < pills.length; i++){
      attachBloom(pills[i]);
    }
  }

  function teardownBloom(section){
    if (!section) return;
    var pills = section.querySelectorAll(PILL_SEL);
    for (var i = 0; i < pills.length; i++){
      var p = pills[i];
      if (typeof p.__hhPtBloomOff === 'function') p.__hhPtBloomOff();
      try {
        p.style.removeProperty('--mx');
        p.style.removeProperty('--my');
      } catch(_e){}
    }
    section.__hhPtBloomBound = false;
  }

  function bindSection(section){
    if (!section) return;
    decorateIcons(section);
    bindReveal(section);
    bindBloom(section);
    bindMagnetic(section);
  }

  function rebind(){
    var sections = d.querySelectorAll(SECTION_SEL);
    for (var i = 0; i < sections.length; i++){
      var s = sections[i];
      teardownBloom(s);
      // Re-bind bloom + magnetic per current MQ state. Reveal stays intact.
      bindBloom(s);
      bindMagnetic(s);
    }
  }

  function attachMQ(mq, fn){
    if (!mq) return;
    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', fn);
    else if (typeof mq.addListener === 'function') mq.addListener(fn);
  }

  function boot(root){
    var scope = (root && root.querySelectorAll) ? root : d;
    var sections = scope.querySelectorAll(SECTION_SEL);
    for (var i = 0; i < sections.length; i++) bindSection(sections[i]);
  }

  if (d.readyState !== 'loading') boot(d);
  else d.addEventListener('DOMContentLoaded', function(){ boot(d); });

  d.addEventListener('shopify:section:load', function(ev){
    if (ev && ev.target){
      var root = ev.target;
      var inner = root.querySelector ? root.querySelector(SECTION_SEL) : null;
      if (inner){
        // Force re-bind: clear flags so a re-injected section picks up fresh.
        inner.__hhPtRevealBound = false;
        bindSection(inner);
      } else {
        boot(root);
      }
    }
  });

  attachMQ(reduceMQ, rebind);
  attachMQ(coarseMQ, rebind);

  w.HH = Object.assign(w.HH || {}, {
    productTrust: {
      boot: boot,
      bindNew: bindSection,
      rebind: rebind
    }
  });
})(window, document);

/* Cycle 274 :: HH.productFaq
   PDP product-faq surface enhancement (paired with styles.css block).
   - IO 0.18 fires .is-revealed once on the section so per-glyph H reveal +
     row-by-row stagger trigger together (CSS handles the staggered timing
     via --i index vars).
   - Pointermove (rAF, passive) on each [data-hh-faq-row] but ONLY while open:
     writes --mx/--my as percentage CSS vars so the conic golden-hour bloom
     tracks the cursor on the active answer panel. We attach on toggle->open
     and detach on toggle->close to avoid wasted listeners.
   - matchMedia gates: bypass bloom + smooth animation on
     (prefers-reduced-motion: reduce) or (pointer: coarse). Live re-bind on
     MQ change.
   - Idempotent flag __hhProductFaqBound. shopify:section:load handler.
   ============================================================ */
(function (w, d) {
  if (!w || !d) return;
  if (w.__hhProductFaqBound) return;
  w.__hhProductFaqBound = true;

  var SECTION_SEL = '[data-hh-product-faq]';
  var ROW_SEL = '[data-hh-faq-row]';

  var reduceMQ = w.matchMedia ? w.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var coarseMQ = w.matchMedia ? w.matchMedia('(pointer: coarse)') : null;
  function prefersReduce(){ return !!(reduceMQ && reduceMQ.matches); }
  function isCoarse(){ return !!(coarseMQ && coarseMQ.matches); }

  function bindReveal(section){
    if (!section || section.__hhPfRevealBound) return;
    section.__hhPfRevealBound = true;
    if (prefersReduce() || !w.IntersectionObserver){
      section.classList.add('is-revealed');
      return;
    }
    var io = new w.IntersectionObserver(function (entries){
      for (var i = 0; i < entries.length; i++){
        var en = entries[i];
        if (en.isIntersecting){
          section.classList.add('is-revealed');
          io.disconnect();
          break;
        }
      }
    }, { threshold: 0.18 });
    io.observe(section);
  }

  function attachRowBloom(row){
    if (!row || row.__hhPfBloomNodeBound) return;
    row.__hhPfBloomNodeBound = true;

    var ticking = false;
    var pendingX = 50;
    var pendingY = 50;

    function flush(){
      ticking = false;
      try {
        row.style.setProperty('--mx', pendingX.toFixed(2) + '%');
        row.style.setProperty('--my', pendingY.toFixed(2) + '%');
      } catch(_e){}
    }

    function onMove(ev){
      var rect = row.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      var px = ((ev.clientX - rect.left) / rect.width) * 100;
      var py = ((ev.clientY - rect.top) / rect.height) * 100;
      if (px < 0) px = 0; else if (px > 100) px = 100;
      if (py < 0) py = 0; else if (py > 100) py = 100;
      pendingX = px;
      pendingY = py;
      if (!ticking){
        ticking = true;
        w.requestAnimationFrame(flush);
      }
    }

    function onLeave(){
      pendingX = 50;
      pendingY = 50;
      if (!ticking){
        ticking = true;
        w.requestAnimationFrame(flush);
      }
    }

    row.addEventListener('pointermove', onMove, { passive: true });
    row.addEventListener('pointerleave', onLeave, { passive: true });

    row.__hhPfBloomOff = function(){
      try { row.removeEventListener('pointermove', onMove); } catch(_e){}
      try { row.removeEventListener('pointerleave', onLeave); } catch(_e){}
      row.__hhPfBloomNodeBound = false;
    };
  }

  function detachRowBloom(row){
    if (!row) return;
    if (typeof row.__hhPfBloomOff === 'function') row.__hhPfBloomOff();
    try {
      row.style.removeProperty('--mx');
      row.style.removeProperty('--my');
    } catch(_e){}
  }

  function bindToggle(section){
    if (!section || section.__hhPfToggleBound) return;
    section.__hhPfToggleBound = true;
    // Toggle event bubbles when added in capture phase. Use capture for cross-browser.
    section.addEventListener('toggle', function (ev){
      var tgt = ev.target;
      if (!tgt || !(tgt instanceof HTMLDetailsElement)) return;
      if (!tgt.matches || !tgt.matches(ROW_SEL)) return;
      if (prefersReduce() || isCoarse()) return;
      if (tgt.open){
        attachRowBloom(tgt);
      } else {
        detachRowBloom(tgt);
      }
    }, true);
  }

  function teardownAllBloom(section){
    if (!section) return;
    var rows = section.querySelectorAll(ROW_SEL);
    for (var i = 0; i < rows.length; i++) detachRowBloom(rows[i]);
  }

  function reattachOpenBloom(section){
    if (!section || prefersReduce() || isCoarse()) return;
    var rows = section.querySelectorAll(ROW_SEL);
    for (var i = 0; i < rows.length; i++){
      if (rows[i].open) attachRowBloom(rows[i]);
    }
  }

  function bindSection(section){
    if (!section) return;
    bindReveal(section);
    bindToggle(section);
    reattachOpenBloom(section);
  }

  function rebind(){
    var sections = d.querySelectorAll(SECTION_SEL);
    for (var i = 0; i < sections.length; i++){
      var s = sections[i];
      teardownAllBloom(s);
      reattachOpenBloom(s);
    }
  }

  function attachMQ(mq, fn){
    if (!mq) return;
    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', fn);
    else if (typeof mq.addListener === 'function') mq.addListener(fn);
  }

  function boot(root){
    var scope = (root && root.querySelectorAll) ? root : d;
    var sections = scope.querySelectorAll(SECTION_SEL);
    for (var i = 0; i < sections.length; i++) bindSection(sections[i]);
  }

  if (d.readyState !== 'loading') boot(d);
  else d.addEventListener('DOMContentLoaded', function(){ boot(d); });

  d.addEventListener('shopify:section:load', function(ev){
    if (ev && ev.target){
      var root = ev.target;
      var inner = root.querySelector ? root.querySelector(SECTION_SEL) : null;
      if (inner){
        inner.__hhPfRevealBound = false;
        inner.__hhPfToggleBound = false;
        bindSection(inner);
      } else {
        boot(root);
      }
    }
  });

  attachMQ(reduceMQ, rebind);
  attachMQ(coarseMQ, rebind);

  w.HH = Object.assign(w.HH || {}, {
    productFaq: {
      boot: boot,
      bindNew: bindSection,
      rebind: rebind
    }
  });
})(window, document);

/* Cycle 275 :: HH.stickyAtc
   Sticky ATC bar enhancement (paired with styles.css block + section markup).
   - Listens to existing .is-visible class change (driven by the section's own
     IntersectionObserver / scroll fallback) via MutationObserver. When visible
     fires for the first time we add .is-revealed (next frame) so the new
     clip-path slide-in plays alongside the existing translateY slide.
   - Fallback path: if MutationObserver is unavailable, a passive rAF scroll
     listener mirrors visibility past the hero region.
   - Pointermove (rAF, passive) on the bar writes --mx/--my percentage CSS vars
     so the conic golden-hour bloom tracks the cursor.
   - Qty +/- buttons (data-hh-qty-bump) get a .is-bumped class for 240ms on
     click for the spring scale microinteraction.
   - matchMedia gates: bypass bloom + spring on (prefers-reduced-motion: reduce)
     or (pointer: coarse). On reveal we call HH.magnetic.bindNew(bar) so the
     CTA picks up cycle 259 magnetic behavior.
   - Idempotent flag __hhStickyAtcBound. shopify:section:load handler.
   ============================================================ */
(function (w, d) {
  if (!w || !d) return;
  if (w.__hhStickyAtcBound) return;
  w.__hhStickyAtcBound = true;

  var BAR_SEL = '[data-hh-sticky-atc]';

  var reduceMQ = w.matchMedia ? w.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var coarseMQ = w.matchMedia ? w.matchMedia('(pointer: coarse)') : null;
  function prefersReduce(){ return !!(reduceMQ && reduceMQ.matches); }
  function isCoarse(){ return !!(coarseMQ && coarseMQ.matches); }

  function bindMagnetic(bar){
    if (w.HH && w.HH.magnetic && typeof w.HH.magnetic.bindNew === 'function'){
      try { w.HH.magnetic.bindNew(bar); } catch(_e){}
    }
  }

  function attachBloom(bar){
    if (!bar || bar.__hhStickyBloomBound) return;
    if (prefersReduce() || isCoarse()) return;
    bar.__hhStickyBloomBound = true;

    var ticking = false;
    var pendingX = 0.85;
    var pendingY = 0.15;

    function flush(){
      ticking = false;
      try {
        bar.style.setProperty('--mx', pendingX.toFixed(3));
        bar.style.setProperty('--my', pendingY.toFixed(3));
      } catch(_e){}
    }

    function onMove(ev){
      var rect = bar.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      var px = (ev.clientX - rect.left) / rect.width;
      var py = (ev.clientY - rect.top) / rect.height;
      if (px < 0) px = 0; else if (px > 1) px = 1;
      if (py < 0) py = 0; else if (py > 1) py = 1;
      pendingX = px;
      pendingY = py;
      if (!ticking){
        ticking = true;
        w.requestAnimationFrame(flush);
      }
    }

    function onLeave(){
      pendingX = 0.85;
      pendingY = 0.15;
      if (!ticking){
        ticking = true;
        w.requestAnimationFrame(flush);
      }
    }

    bar.addEventListener('pointermove', onMove, { passive: true });
    bar.addEventListener('pointerleave', onLeave, { passive: true });

    bar.__hhStickyBloomOff = function(){
      try { bar.removeEventListener('pointermove', onMove); } catch(_e){}
      try { bar.removeEventListener('pointerleave', onLeave); } catch(_e){}
      bar.__hhStickyBloomBound = false;
    };
  }

  function detachBloom(bar){
    if (!bar) return;
    if (typeof bar.__hhStickyBloomOff === 'function') bar.__hhStickyBloomOff();
  }

  function attachQtyBump(bar){
    if (!bar || bar.__hhStickyQtyBound) return;
    bar.__hhStickyQtyBound = true;
    var btns = bar.querySelectorAll('[data-hh-qty-bump]');
    for (var i = 0; i < btns.length; i++){
      (function(btn){
        btn.addEventListener('click', function(){
          if (prefersReduce() || isCoarse()) return;
          btn.classList.add('is-bumped');
          w.setTimeout(function(){
            btn.classList.remove('is-bumped');
          }, 240);
        }, { passive: true });
      })(btns[i]);
    }
  }

  function reveal(bar){
    if (!bar || bar.__hhStickyRevealed) return;
    bar.__hhStickyRevealed = true;
    w.requestAnimationFrame(function(){
      bar.classList.add('is-revealed');
      bindMagnetic(bar);
    });
  }

  function watchVisibility(bar){
    if (!bar || bar.__hhStickyWatchBound) return;
    bar.__hhStickyWatchBound = true;

    if (bar.classList.contains('is-visible')){
      reveal(bar);
      return;
    }

    if (w.MutationObserver){
      var mo = new w.MutationObserver(function (muts){
        for (var i = 0; i < muts.length; i++){
          if (muts[i].attributeName === 'class'){
            if (bar.classList.contains('is-visible')){
              reveal(bar);
              mo.disconnect();
              break;
            }
          }
        }
      });
      mo.observe(bar, { attributes: true, attributeFilter: ['class'] });
    } else {
      // Fallback: passive rAF scroll listener, past 400px reveal.
      var ticking = false;
      function check(){
        ticking = false;
        if (w.scrollY > 400) reveal(bar);
      }
      function onScroll(){
        if (!ticking){
          ticking = true;
          w.requestAnimationFrame(check);
        }
      }
      w.addEventListener('scroll', onScroll, { passive: true });
    }
  }

  function bindBar(bar){
    if (!bar || bar.__hhStickyAtcNodeBound) return;
    bar.__hhStickyAtcNodeBound = true;
    watchVisibility(bar);
    attachBloom(bar);
    attachQtyBump(bar);
  }

  function boot(root){
    var scope = root || d;
    var bar = scope.querySelector ? scope.querySelector(BAR_SEL) : null;
    if (!bar) return;
    bindBar(bar);
  }

  function rebind(){
    var bar = d.querySelector(BAR_SEL);
    if (!bar) return;
    detachBloom(bar);
    if (!prefersReduce() && !isCoarse()){
      attachBloom(bar);
    }
  }

  function attachMQ(mq, fn){
    if (!mq) return;
    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', fn);
    else if (typeof mq.addListener === 'function') mq.addListener(fn);
  }

  if (d.readyState === 'loading'){
    d.addEventListener('DOMContentLoaded', function(){ boot(d); });
  } else {
    boot(d);
  }

  d.addEventListener('shopify:section:load', function(ev){
    if (ev && ev.target){
      var root = ev.target;
      var bar = root.matches && root.matches(BAR_SEL) ? root : (root.querySelector ? root.querySelector(BAR_SEL) : null);
      if (bar){
        bar.__hhStickyAtcNodeBound = false;
        bar.__hhStickyBloomBound = false;
        bar.__hhStickyQtyBound = false;
        bar.__hhStickyWatchBound = false;
        bar.__hhStickyRevealed = false;
        bindBar(bar);
      }
    }
  });

  attachMQ(reduceMQ, rebind);
  attachMQ(coarseMQ, rebind);

  w.HH = Object.assign(w.HH || {}, {
    stickyAtc: {
      boot: boot,
      bindNew: bindBar,
      rebind: rebind
    }
  });
})(window, document);

/* Cycle 276 :: HH.productRecs
   Editorial enhancement on top of Shopify's related-products section.
   - IO 0.18 fires .is-revealed once per [data-hh-product-recs] section so the
     per-glyph H rise (--i) and per-card stagger reveal (--ci) trigger.
   - rAF-throttled passive pointermove writes --mx/--my as % CSS vars on the
     section so the conic golden-hour bloom tracks the cursor.
   - Decorates each .hh-card with data-hh-rec-card + --ci, marks every 3rd
     with .is-offset, and adds .has-offset to the section. The card link
     gets data-hh-magnetic so cycle 259 binds it; HH.magnetic.bindNew is
     called for the section.
   - A document-level MutationObserver catches both inner-HTML replaces and
     full section.replaceWith() swaps fired by the fetch-and-swap flow in
     this file (the section replaces itself with a fresh fragment when
     Shopify returns recommendations).
   - matchMedia gates: prefers-reduced-motion + pointer:coarse hard-disable
     bloom + tilt + magnetic. Live re-bind on MQ change.
   - Idempotent flag __hhProductRecsBound. shopify:section:load handler.
   ============================================================ */
(function (w, d) {
  if (!w || !d) return;
  if (w.__hhProductRecsBound) return;
  w.__hhProductRecsBound = true;

  var SECTION_SEL = '[data-hh-product-recs]';
  var CARD_SEL = '.hh-card';
  var LINK_SEL = '.hh-card__link';

  var reduceMQ = w.matchMedia ? w.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var coarseMQ = w.matchMedia ? w.matchMedia('(pointer: coarse)') : null;
  function prefersReduce(){ return !!(reduceMQ && reduceMQ.matches); }
  function isCoarse(){ return !!(coarseMQ && coarseMQ.matches); }

  function attachMQ(mq, handler){
    if (!mq) return;
    if (typeof mq.addEventListener === 'function'){
      mq.addEventListener('change', handler);
    } else if (typeof mq.addListener === 'function'){
      mq.addListener(handler);
    }
  }

  function decorateCards(section){
    if (!section) return false;
    var cards = section.querySelectorAll(CARD_SEL);
    if (!cards.length) return false;
    var changed = false;
    var hasOffset = false;
    for (var i = 0; i < cards.length; i++){
      var card = cards[i];
      if (!card.hasAttribute('data-hh-rec-card')){
        card.setAttribute('data-hh-rec-card', '');
        changed = true;
      }
      if (card.style.getPropertyValue('--ci') !== String(i)){
        try { card.style.setProperty('--ci', i); } catch(_e){}
      }
      if ((i + 1) % 3 === 0){
        if (!card.classList.contains('is-offset')){
          card.classList.add('is-offset');
          changed = true;
        }
        hasOffset = true;
      }
      var link = card.querySelector(LINK_SEL);
      if (link && !link.hasAttribute('data-hh-magnetic')){
        link.setAttribute('data-hh-magnetic', '');
        changed = true;
      }
    }
    if (hasOffset && !section.classList.contains('has-offset')){
      section.classList.add('has-offset');
    }
    return changed || cards.length > 0;
  }

  function bindMagnetic(section){
    if (!section || prefersReduce() || isCoarse()) return;
    if (w.HH && w.HH.magnetic && typeof w.HH.magnetic.bindNew === 'function'){
      try { w.HH.magnetic.bindNew(section); } catch(_e){}
    }
  }

  function bindReveal(section){
    if (!section || section.__hhRecsRevealBound) return;
    section.__hhRecsRevealBound = true;
    if (prefersReduce() || !w.IntersectionObserver){
      section.classList.add('is-revealed');
      return;
    }
    var io = new w.IntersectionObserver(function (entries){
      for (var i = 0; i < entries.length; i++){
        var en = entries[i];
        if (en.isIntersecting){
          section.classList.add('is-revealed');
          io.disconnect();
          break;
        }
      }
    }, { threshold: 0.18 });
    io.observe(section);
  }

  function bindBloom(section){
    if (!section || section.__hhRecsBloomBound) return;
    if (prefersReduce() || isCoarse()) return;
    section.__hhRecsBloomBound = true;

    var ticking = false;
    var pendingX = 50;
    var pendingY = 30;

    function flush(){
      ticking = false;
      try {
        section.style.setProperty('--mx', pendingX.toFixed(2) + '%');
        section.style.setProperty('--my', pendingY.toFixed(2) + '%');
      } catch(_e){}
    }

    function onMove(ev){
      var rect = section.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      var px = ((ev.clientX - rect.left) / rect.width) * 100;
      var py = ((ev.clientY - rect.top) / rect.height) * 100;
      if (px < 0) px = 0; else if (px > 100) px = 100;
      if (py < 0) py = 0; else if (py > 100) py = 100;
      pendingX = px;
      pendingY = py;
      if (!ticking){
        ticking = true;
        w.requestAnimationFrame(flush);
      }
    }

    function onLeave(){
      pendingX = 50;
      pendingY = 30;
      if (!ticking){
        ticking = true;
        w.requestAnimationFrame(flush);
      }
    }

    section.addEventListener('pointermove', onMove, { passive: true });
    section.addEventListener('pointerleave', onLeave, { passive: true });
  }

  function bindSection(section){
    if (!section) return;
    decorateCards(section);
    bindReveal(section);
    bindBloom(section);
    bindMagnetic(section);
  }

  function bindAll(root){
    var scope = root || d;
    var sections = scope.querySelectorAll
      ? scope.querySelectorAll(SECTION_SEL)
      : [];
    for (var i = 0; i < sections.length; i++){
      bindSection(sections[i]);
    }
    /* Also handle the case where root itself matches the selector (replaceWith) */
    if (root && root.matches && root.matches(SECTION_SEL)){
      bindSection(root);
    }
  }

  function watchDom(){
    if (!w.MutationObserver || d.__hhRecsObserver) return;
    var mo = new w.MutationObserver(function (mutations){
      for (var i = 0; i < mutations.length; i++){
        var m = mutations[i];
        /* New nodes inserted anywhere (covers section replaceWith + innerHTML) */
        if (m.addedNodes && m.addedNodes.length){
          for (var j = 0; j < m.addedNodes.length; j++){
            var node = m.addedNodes[j];
            if (node.nodeType !== 1) continue;
            if (node.matches && node.matches(SECTION_SEL)){
              bindSection(node);
            } else if (node.querySelector){
              var inner = node.querySelector(SECTION_SEL);
              if (inner) bindSection(inner);
              /* Newly added cards inside an already-bound section */
              if (node.matches && node.matches(CARD_SEL)){
                var parent = node.closest && node.closest(SECTION_SEL);
                if (parent) decorateCards(parent), bindMagnetic(parent);
              } else if (node.querySelector(CARD_SEL)){
                var p2 = node.closest && node.closest(SECTION_SEL);
                if (p2) decorateCards(p2), bindMagnetic(p2);
              }
            }
          }
        }
      }
    });
    try { mo.observe(d.body, { childList: true, subtree: true }); } catch(_e){}
    d.__hhRecsObserver = mo;
  }

  function rebindAll(){
    var sections = d.querySelectorAll(SECTION_SEL);
    for (var i = 0; i < sections.length; i++){
      var s = sections[i];
      /* Clear bloom flag so MQ change can rebind it under new state */
      s.__hhRecsBloomBound = false;
      bindBloom(s);
      bindMagnetic(s);
    }
  }

  function boot(){
    bindAll(d);
    watchDom();
  }

  if (d.readyState === 'loading'){
    d.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  d.addEventListener('shopify:section:load', function (ev){
    var target = ev && ev.target;
    if (!target) return;
    bindAll(target);
  });

  attachMQ(reduceMQ, rebindAll);
  attachMQ(coarseMQ, rebindAll);

  w.HH = Object.assign(w.HH || {}, {
    productRecs: {
      boot: boot,
      bindNew: bindSection,
      rebind: rebindAll
    }
  });
})(window, document);

/* Cycle 277 :: HH.adoptionGrid
   Editorial enhancement for sections/adoption-grid.liquid.
   - IO 0.18 fires .is-revealed once per [data-hh-adoption-grid] so the
     per-glyph H rise (--i) and per-card stagger reveal (--ci) trigger.
   - rAF-throttled passive pointermove on each [data-hh-adoption-card]
     writes --mx/--my (0..100%) for the conic warm bloom and --tx/--ty
     (-1..1) for the perspective tilt. pointerleave springs vars back.
   - has-offset class on the section so :nth-child(3n+2) Recipe D fires
     in CSS only (we never re-order the metaobject loop).
   - HH.magnetic.bindNew(section) so cycle 259 binds card links.
   - Optional paw-cursor canvas confined to the section (only when
     enable_paw_cursor is true), capped at 24 stamps, alpha decay 0.92,
     IO-suspended off-viewport.
   - matchMedia gates: prefers-reduced-motion + pointer:coarse hard-disable
     tilt + bloom + paw-cursor. Live re-bind on MQ change.
   - Idempotent flag __hhAdoptionGridBound. shopify:section:load handler.
   ============================================================ */
(function (w, d) {
  if (!w || !d) return;
  if (w.__hhAdoptionGridBound) return;
  w.__hhAdoptionGridBound = true;

  var SECTION_SEL = '[data-hh-adoption-grid]';
  var CARD_SEL = '[data-hh-adoption-card]';
  var LINK_SEL = '.hh-adopt-card__link';

  var reduceMQ = w.matchMedia ? w.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var coarseMQ = w.matchMedia ? w.matchMedia('(pointer: coarse)') : null;
  function prefersReduce(){ return !!(reduceMQ && reduceMQ.matches); }
  function isCoarse(){ return !!(coarseMQ && coarseMQ.matches); }

  function attachMQ(mq, handler){
    if (!mq) return;
    if (typeof mq.addEventListener === 'function'){
      mq.addEventListener('change', handler);
    } else if (typeof mq.addListener === 'function'){
      mq.addListener(handler);
    }
  }

  function readBool(section, attr, fallback){
    if (!section) return fallback;
    var v = section.getAttribute(attr);
    if (v == null) return fallback;
    return v === 'true' || v === '1';
  }

  function decorateCards(section){
    if (!section) return;
    var cards = section.querySelectorAll(CARD_SEL);
    for (var i = 0; i < cards.length; i++){
      var card = cards[i];
      if (card.style.getPropertyValue('--ci') !== String(i)){
        try { card.style.setProperty('--ci', i); } catch(_e){}
      }
      var link = card.querySelector(LINK_SEL);
      if (link && !link.hasAttribute('data-hh-magnetic')){
        link.setAttribute('data-hh-magnetic', '');
      }
    }
    if (readBool(section, 'data-hh-recipe-d', true)){
      if (!section.classList.contains('has-offset')){
        section.classList.add('has-offset');
      }
    }
  }

  function bindMagnetic(section){
    if (!section || prefersReduce() || isCoarse()) return;
    if (w.HH && w.HH.magnetic && typeof w.HH.magnetic.bindNew === 'function'){
      try { w.HH.magnetic.bindNew(section); } catch(_e){}
    }
  }

  function bindReveal(section){
    if (!section || section.__hhAdoptionRevealBound) return;
    section.__hhAdoptionRevealBound = true;
    if (prefersReduce() || !w.IntersectionObserver){
      section.classList.add('is-revealed');
      return;
    }
    var io = new w.IntersectionObserver(function (entries){
      for (var i = 0; i < entries.length; i++){
        var en = entries[i];
        if (en.isIntersecting){
          section.classList.add('is-revealed');
          io.disconnect();
          break;
        }
      }
    }, { threshold: 0.18 });
    io.observe(section);
  }

  function bindCardInteraction(section){
    if (!section || section.__hhAdoptionInteractionBound) return;
    if (prefersReduce() || isCoarse()) return;
    section.__hhAdoptionInteractionBound = true;

    var enableTilt = readBool(section, 'data-hh-card-tilt', true);
    var enableBloom = readBool(section, 'data-hh-card-bloom', true);
    if (!enableTilt && !enableBloom) return;

    var cards = section.querySelectorAll(CARD_SEL);
    for (var i = 0; i < cards.length; i++){
      attachCard(cards[i], enableTilt, enableBloom);
    }
  }

  function attachCard(card, enableTilt, enableBloom){
    if (!card || card.__hhAdoptionCardBound) return;
    card.__hhAdoptionCardBound = true;

    var ticking = false;
    var pendingMx = 50;
    var pendingMy = 30;
    var pendingTx = 0;
    var pendingTy = 0;

    function flush(){
      ticking = false;
      try {
        if (enableBloom){
          card.style.setProperty('--mx', pendingMx.toFixed(2) + '%');
          card.style.setProperty('--my', pendingMy.toFixed(2) + '%');
        }
        if (enableTilt){
          card.style.setProperty('--tx', pendingTx.toFixed(3));
          card.style.setProperty('--ty', pendingTy.toFixed(3));
        }
      } catch(_e){}
    }

    function onMove(ev){
      var rect = card.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      var rx = (ev.clientX - rect.left) / rect.width;
      var ry = (ev.clientY - rect.top) / rect.height;
      if (rx < 0) rx = 0; else if (rx > 1) rx = 1;
      if (ry < 0) ry = 0; else if (ry > 1) ry = 1;
      pendingMx = rx * 100;
      pendingMy = ry * 100;
      pendingTx = (rx - 0.5) * 2;
      pendingTy = (ry - 0.5) * 2;
      if (!ticking){
        ticking = true;
        w.requestAnimationFrame(flush);
      }
    }

    function onLeave(){
      pendingMx = 50;
      pendingMy = 30;
      pendingTx = 0;
      pendingTy = 0;
      try {
        var prev = card.style.transitionProperty;
        card.style.transitionDuration = '320ms';
      } catch(_e){}
      if (!ticking){
        ticking = true;
        w.requestAnimationFrame(flush);
      }
    }

    card.addEventListener('pointermove', onMove, { passive: true });
    card.addEventListener('pointerleave', onLeave, { passive: true });
  }

  /* Optional paw-stamp cursor confined to the section. */
  function bindPawCursor(section){
    if (!section || section.__hhAdoptionPawBound) return;
    if (prefersReduce() || isCoarse()) return;
    if (!readBool(section, 'data-hh-paw-cursor', false)) return;
    if (!w.requestAnimationFrame) return;

    section.__hhAdoptionPawBound = true;

    var canvas = d.createElement('canvas');
    canvas.setAttribute('data-hh-adoption-paw-canvas', '');
    canvas.setAttribute('aria-hidden', 'true');
    section.appendChild(canvas);

    var ctx = canvas.getContext && canvas.getContext('2d');
    if (!ctx){
      try { section.removeChild(canvas); } catch(_e){}
      return;
    }

    var stamps = [];
    var MAX_STAMPS = 24;
    var rafId = 0;
    var visible = true;
    var dpr = w.devicePixelRatio || 1;
    var lastX = -1;
    var lastY = -1;
    var MIN_DIST = 22;

    function size(){
      var rect = section.getBoundingClientRect();
      canvas.width = Math.max(1, Math.floor(rect.width * dpr));
      canvas.height = Math.max(1, Math.floor(rect.height * dpr));
      canvas.style.width = rect.width + 'px';
      canvas.style.height = rect.height + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    function drawPaw(x, y, alpha, angle){
      ctx.save();
      ctx.globalAlpha = alpha;
      ctx.translate(x, y);
      ctx.rotate(angle);
      ctx.fillStyle = '#7a3a1f';
      /* center pad */
      ctx.beginPath();
      ctx.ellipse(0, 4, 7, 9, 0, 0, Math.PI * 2);
      ctx.fill();
      /* four toes */
      var toes = [
        { x: -8, y: -4, rx: 3, ry: 4 },
        { x: -3, y: -10, rx: 3, ry: 4 },
        { x:  3, y: -10, rx: 3, ry: 4 },
        { x:  8, y: -4, rx: 3, ry: 4 }
      ];
      for (var i = 0; i < toes.length; i++){
        var t = toes[i];
        ctx.beginPath();
        ctx.ellipse(t.x, t.y, t.rx, t.ry, 0, 0, Math.PI * 2);
        ctx.fill();
      }
      ctx.restore();
    }

    function tick(){
      rafId = 0;
      ctx.clearRect(0, 0, canvas.width / dpr, canvas.height / dpr);
      var alive = false;
      for (var i = 0; i < stamps.length; i++){
        var s = stamps[i];
        if (s.alpha <= 0.02) continue;
        drawPaw(s.x, s.y, s.alpha, s.angle);
        s.alpha *= 0.92;
        alive = true;
      }
      /* compact array when most stamps faded */
      if (stamps.length > MAX_STAMPS){
        stamps = stamps.slice(stamps.length - MAX_STAMPS);
      }
      if (alive && visible){
        rafId = w.requestAnimationFrame(tick);
      }
    }

    function schedule(){
      if (!rafId && visible){
        rafId = w.requestAnimationFrame(tick);
      }
    }

    function onMove(ev){
      var rect = section.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      var x = ev.clientX - rect.left;
      var y = ev.clientY - rect.top;
      if (lastX >= 0){
        var dx = x - lastX;
        var dy = y - lastY;
        if ((dx * dx + dy * dy) < (MIN_DIST * MIN_DIST)) return;
      }
      var angle = lastX >= 0 ? Math.atan2(y - lastY, x - lastX) : 0;
      lastX = x;
      lastY = y;
      stamps.push({ x: x, y: y, alpha: 0.85, angle: angle });
      if (stamps.length > MAX_STAMPS){
        stamps.shift();
      }
      schedule();
    }

    function onLeave(){
      lastX = -1;
      lastY = -1;
    }

    section.addEventListener('pointermove', onMove, { passive: true });
    section.addEventListener('pointerleave', onLeave, { passive: true });

    /* IO suspends the loop when section is offscreen. */
    if (w.IntersectionObserver){
      var io = new w.IntersectionObserver(function (entries){
        for (var i = 0; i < entries.length; i++){
          visible = entries[i].isIntersecting;
        }
        if (visible) schedule();
      }, { threshold: 0.05 });
      io.observe(section);
    }

    if (w.ResizeObserver){
      var ro = new w.ResizeObserver(size);
      try { ro.observe(section); } catch(_e){}
    } else {
      w.addEventListener('resize', size, { passive: true });
    }

    size();
  }

  function bindSection(section){
    if (!section) return;
    decorateCards(section);
    bindReveal(section);
    bindCardInteraction(section);
    bindMagnetic(section);
    bindPawCursor(section);
  }

  function bindAll(root){
    var scope = root || d;
    var sections = scope.querySelectorAll
      ? scope.querySelectorAll(SECTION_SEL)
      : [];
    for (var i = 0; i < sections.length; i++){
      bindSection(sections[i]);
    }
    if (root && root.matches && root.matches(SECTION_SEL)){
      bindSection(root);
    }
  }

  function rebindAll(){
    var sections = d.querySelectorAll(SECTION_SEL);
    for (var i = 0; i < sections.length; i++){
      var s = sections[i];
      /* Clear interaction flag so MQ change can rebind under new state. */
      s.__hhAdoptionInteractionBound = false;
      bindCardInteraction(s);
      bindMagnetic(s);
    }
  }

  function boot(){ bindAll(d); }

  if (d.readyState === 'loading'){
    d.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  d.addEventListener('shopify:section:load', function (ev){
    var target = ev && ev.target;
    if (!target) return;
    bindAll(target);
  });

  attachMQ(reduceMQ, rebindAll);
  attachMQ(coarseMQ, rebindAll);

  w.HH = Object.assign(w.HH || {}, {
    adoptionGrid: {
      boot: boot,
      bindNew: bindSection,
      rebind: rebindAll
    }
  });
})(window, document);

/* Cycle 278 :: HH.adoptionCta
   Editorial enhancement for sections/adoption-cta.liquid.
   - IO 0.18 fires .is-revealed once per [data-hh-adoption-cta] so the
     per-glyph H rise (--i) and per-card stagger (--ci) trigger.
   - rAF-throttled passive pointermove on each [data-hh-step-card] writes
     --mx/--my (CSS percentages) for the conic warm bloom. pointerleave
     resets vars.
   - Hooks form submit + form posted_successfully output: on success or
     submit, adds .is-active to [data-hh-cta-success], unhides the panel,
     triggers paw stroke cascade. aria-live polite is on the container.
   - HH.magnetic.bindNew(section) so cycle 259 binds the submit + cta link.
   - matchMedia gates: prefers-reduced-motion + pointer:coarse hard-disable
     bloom + tilt. Live re-bind on MQ change.
   - Idempotent flag __hhAdoptionCtaBound. shopify:section:load handler.
   ============================================================ */
(function (w, d) {
  if (!w || !d) return;
  if (w.__hhAdoptionCtaBound) return;
  w.__hhAdoptionCtaBound = true;

  var SECTION_SEL = '[data-hh-adoption-cta]';
  var STEP_SEL = '[data-hh-step-card]';
  var SUCCESS_SEL = '[data-hh-cta-success]';
  var FORM_SEL = 'form.hh-adopt-form, form#AdoptionInquiry';
  var SUBMIT_SEL = '.hh-cta__submit, .hh-adopt-form__submit';

  var reduceMQ = w.matchMedia ? w.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var coarseMQ = w.matchMedia ? w.matchMedia('(pointer: coarse)') : null;
  function prefersReduce(){ return !!(reduceMQ && reduceMQ.matches); }
  function isCoarse(){ return !!(coarseMQ && coarseMQ.matches); }

  function attachMQ(mq, handler){
    if (!mq) return;
    if (typeof mq.addEventListener === 'function'){
      mq.addEventListener('change', handler);
    } else if (typeof mq.addListener === 'function'){
      mq.addListener(handler);
    }
  }

  function readBool(section, attr, fallback){
    if (!section) return fallback;
    var v = section.getAttribute(attr);
    if (v == null) return fallback;
    return v === 'true' || v === '1';
  }

  function decorateSteps(section){
    if (!section) return;
    var steps = section.querySelectorAll(STEP_SEL);
    for (var i = 0; i < steps.length; i++){
      var step = steps[i];
      if (step.style.getPropertyValue('--ci') !== String(i)){
        try { step.style.setProperty('--ci', i); } catch(_e){}
      }
    }
    var submit = section.querySelector(SUBMIT_SEL);
    if (submit && !submit.hasAttribute('data-hh-magnetic')){
      submit.setAttribute('data-hh-magnetic', '');
    }
  }

  function bindReveal(section){
    if (!section || section.__hhAdoptionCtaRevealBound) return;
    section.__hhAdoptionCtaRevealBound = true;
    if (prefersReduce() || !w.IntersectionObserver){
      section.classList.add('is-revealed');
      return;
    }
    var io = new w.IntersectionObserver(function (entries){
      for (var i = 0; i < entries.length; i++){
        var en = entries[i];
        if (en.isIntersecting){
          section.classList.add('is-revealed');
          io.disconnect();
          break;
        }
      }
    }, { threshold: 0.18 });
    io.observe(section);
  }

  function bindStepBloom(section){
    if (!section || section.__hhAdoptionCtaBloomBound) return;
    if (prefersReduce() || isCoarse()) return;
    if (section.getAttribute('data-step-bloom') === '0') return;
    section.__hhAdoptionCtaBloomBound = true;

    var steps = section.querySelectorAll(STEP_SEL);
    for (var i = 0; i < steps.length; i++){
      bindOneStep(steps[i]);
    }
  }

  function bindOneStep(step){
    if (!step || step.__hhStepBloomBound) return;
    step.__hhStepBloomBound = true;
    var rafId = 0;
    var pending = null;

    function flush(){
      rafId = 0;
      if (!pending) return;
      try {
        step.style.setProperty('--mx', pending.x + '%');
        step.style.setProperty('--my', pending.y + '%');
      } catch(_e){}
      pending = null;
    }

    function onMove(ev){
      var rect = step.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      var px = ((ev.clientX - rect.left) / rect.width) * 100;
      var py = ((ev.clientY - rect.top) / rect.height) * 100;
      if (px < 0) px = 0; else if (px > 100) px = 100;
      if (py < 0) py = 0; else if (py > 100) py = 100;
      pending = { x: px, y: py };
      if (!rafId) rafId = w.requestAnimationFrame(flush);
    }

    function onLeave(){
      if (rafId){ try { w.cancelAnimationFrame(rafId); } catch(_e){} rafId = 0; }
      pending = null;
      try {
        step.style.setProperty('--mx', '50%');
        step.style.setProperty('--my', '50%');
      } catch(_e){}
    }

    step.addEventListener('pointermove', onMove, { passive: true });
    step.addEventListener('pointerleave', onLeave, { passive: true });
    step.__hhStepBloomMove = onMove;
    step.__hhStepBloomLeave = onLeave;
  }

  function unbindStepBloom(section){
    if (!section || !section.__hhAdoptionCtaBloomBound) return;
    var steps = section.querySelectorAll(STEP_SEL);
    for (var i = 0; i < steps.length; i++){
      var step = steps[i];
      if (step.__hhStepBloomMove) step.removeEventListener('pointermove', step.__hhStepBloomMove);
      if (step.__hhStepBloomLeave) step.removeEventListener('pointerleave', step.__hhStepBloomLeave);
      step.__hhStepBloomBound = false;
      step.__hhStepBloomMove = null;
      step.__hhStepBloomLeave = null;
    }
    section.__hhAdoptionCtaBloomBound = false;
  }

  function activateSuccess(section){
    if (!section) return;
    var panel = section.querySelector(SUCCESS_SEL);
    if (!panel) return;
    if (panel.hasAttribute('hidden')) panel.removeAttribute('hidden');
    if (!panel.classList.contains('is-active')){
      // Force a frame so transition fires from the new layout.
      w.requestAnimationFrame(function (){
        panel.classList.add('is-active');
      });
    }
  }

  function bindForm(section){
    if (!section || section.__hhAdoptionCtaFormBound) return;
    section.__hhAdoptionCtaFormBound = true;

    var form = section.querySelector(FORM_SEL);
    if (!form) return;

    // If Liquid already rendered the success panel as active (Shopify
    // posted_successfully?), trigger the cascade now.
    var existing = section.querySelector(SUCCESS_SEL + '.is-active');
    if (existing){
      // Re-trigger paw stroke draw once visible.
      w.requestAnimationFrame(function (){
        existing.classList.remove('is-active');
        w.requestAnimationFrame(function (){ existing.classList.add('is-active'); });
      });
    }

    function onSubmit(){
      // Optimistic UX: schema flag controls actual reveal; we don't
      // cancel the submit, we let Shopify round-trip then re-render with
      // form.posted_successfully?. The reveal triggers via the rendered
      // state above. As a graceful enhancement on networks with JS form
      // intercept (none here), we mark the panel for fade.
      var panel = section.querySelector(SUCCESS_SEL);
      if (panel){
        panel.removeAttribute('hidden');
      }
    }
    form.addEventListener('submit', onSubmit);
    section.__hhAdoptionCtaFormHandler = onSubmit;

    // MutationObserver: watch for posted_successfully? insertion of the
    // .is-active class (e.g., by external scripts or partial re-renders).
    if (w.MutationObserver){
      var panel = section.querySelector(SUCCESS_SEL);
      if (panel){
        var mo = new w.MutationObserver(function (records){
          for (var i = 0; i < records.length; i++){
            var r = records[i];
            if (r.type === 'attributes' && r.attributeName === 'class'){
              if (panel.classList.contains('is-active')){
                activateSuccess(section);
              }
            }
          }
        });
        try {
          mo.observe(panel, { attributes: true, attributeFilter: ['class', 'hidden'] });
          section.__hhAdoptionCtaSuccessMO = mo;
        } catch(_e){}
      }
    }
  }

  function bindMagnetic(section){
    if (!section || prefersReduce() || isCoarse()) return;
    if (w.HH && w.HH.magnetic && typeof w.HH.magnetic.bindNew === 'function'){
      try { w.HH.magnetic.bindNew(section); } catch(_e){}
    }
  }

  function bindSection(section){
    if (!section) return;
    decorateSteps(section);
    bindReveal(section);
    bindStepBloom(section);
    bindForm(section);
    bindMagnetic(section);
  }

  function bindAll(root){
    var scope = root || d;
    var sections = scope.querySelectorAll
      ? scope.querySelectorAll(SECTION_SEL)
      : [];
    for (var i = 0; i < sections.length; i++){
      bindSection(sections[i]);
    }
    if (root && root.matches && root.matches(SECTION_SEL)){
      bindSection(root);
    }
  }

  function rebindAll(){
    var sections = d.querySelectorAll(SECTION_SEL);
    for (var i = 0; i < sections.length; i++){
      var s = sections[i];
      if (prefersReduce() || isCoarse()){
        unbindStepBloom(s);
      } else {
        bindStepBloom(s);
      }
      bindMagnetic(s);
    }
  }

  function boot(){ bindAll(d); }

  if (d.readyState === 'loading'){
    d.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  d.addEventListener('shopify:section:load', function (ev){
    var target = ev && ev.target;
    if (!target) return;
    bindAll(target);
  });

  attachMQ(reduceMQ, rebindAll);
  attachMQ(coarseMQ, rebindAll);

  w.HH = Object.assign(w.HH || {}, {
    adoptionCta: {
      boot: boot,
      bindNew: bindSection,
      rebind: rebindAll,
      activateSuccess: activateSuccess
    }
  });
})(window, document);

/* Cycle 279 :: HH.adoptionHero
   Editorial deepening for the adoption hero.
   - Per-glyph headline reveal via IntersectionObserver
   - Count-up stats with rAF + Intl.NumberFormat thousand separators
   - Pointer-tracked golden-bloom corner via CSS vars
   - Magnetic CTA delegation to HH.magnetic.bindNew
   - prefers-reduced-motion + pointer:coarse gates
   - Idempotent boot via __hhAdoptionHeroBound flag
   - shopify:section:load rebind hook
*/
(function (w, d){
  'use strict';
  if (!w || !d) return;

  var SECTION_SEL = '[data-hh-adoption-hero]';
  var REVEAL_THRESHOLD = 0.18;
  var COUNT_DURATION = 900;
  var STAT_STAGGER = 60;

  var reduceMQ = w.matchMedia ? w.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var coarseMQ = w.matchMedia ? w.matchMedia('(pointer: coarse)')                : null;

  function prefersReduce(){ return !!(reduceMQ && reduceMQ.matches); }
  function isCoarse(){ return !!(coarseMQ && coarseMQ.matches); }

  function attachMQ(mq, fn){
    if (!mq) return;
    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', fn);
    else if (typeof mq.addListener === 'function') mq.addListener(fn);
  }

  var nf = null;
  function fmt(n){
    if (!nf){
      try { nf = new Intl.NumberFormat(); }
      catch(_e){ nf = { format: function(v){ return String(v); } }; }
    }
    return nf.format(n);
  }

  function easeOutCubic(t){
    var inv = 1 - t;
    return 1 - inv * inv * inv;
  }

  function readTarget(stat){
    var raw = stat && stat.getAttribute ? stat.getAttribute('data-target') : '0';
    var n = parseInt(raw, 10);
    return isFinite(n) && n >= 0 ? n : 0;
  }

  function setStatFinal(stat){
    var target = readTarget(stat);
    var node = stat.querySelector('[data-hh-stat-num]');
    if (node) node.textContent = fmt(target);
  }

  function countUpStat(stat, delay){
    var node = stat.querySelector('[data-hh-stat-num]');
    if (!node) return;
    var target = readTarget(stat);
    if (target <= 0){
      node.textContent = fmt(0);
      return;
    }
    var start = 0;
    var t0 = 0;
    function frame(ts){
      if (!t0) t0 = ts;
      var elapsed = ts - t0;
      if (elapsed < 0) elapsed = 0;
      var p = elapsed / COUNT_DURATION;
      if (p > 1) p = 1;
      var v = Math.round(start + (target - start) * easeOutCubic(p));
      node.textContent = fmt(v);
      if (p < 1) w.requestAnimationFrame(frame);
      else node.textContent = fmt(target);
    }
    if (delay > 0){
      w.setTimeout(function(){ w.requestAnimationFrame(frame); }, delay);
    } else {
      w.requestAnimationFrame(frame);
    }
  }

  function runCountUps(section){
    var stats = section.querySelectorAll('[data-hh-stat]');
    if (prefersReduce()){
      for (var i = 0; i < stats.length; i++) setStatFinal(stats[i]);
      return;
    }
    for (var j = 0; j < stats.length; j++){
      countUpStat(stats[j], j * STAT_STAGGER);
    }
  }

  function bindReveal(section){
    if (section.__hhAdoptionHeroRevealBound) return;
    section.__hhAdoptionHeroRevealBound = true;

    function reveal(){
      if (section.classList.contains('is-revealed')) return;
      section.classList.add('is-revealed');
      runCountUps(section);
    }

    if (!('IntersectionObserver' in w)){
      reveal();
      return;
    }
    var io = new IntersectionObserver(function(entries){
      for (var k = 0; k < entries.length; k++){
        if (entries[k].isIntersecting){
          reveal();
          io.disconnect();
          break;
        }
      }
    }, { threshold: REVEAL_THRESHOLD });
    io.observe(section);
    section.__hhAdoptionHeroIO = io;
  }

  function bindBloom(section){
    if (section.__hhAdoptionHeroBloomBound) return;
    section.__hhAdoptionHeroBloomBound = true;

    if (prefersReduce() || isCoarse()) return;

    var raf = 0;
    var pending = null;

    function flush(){
      raf = 0;
      if (!pending) return;
      var rect = section.getBoundingClientRect();
      if (!rect.width || !rect.height){ pending = null; return; }
      var mx = ((pending.x - rect.left) / rect.width) * 100;
      var my = ((pending.y - rect.top) / rect.height) * 100;
      if (mx < 0) mx = 0; else if (mx > 100) mx = 100;
      if (my < 0) my = 0; else if (my > 100) my = 100;
      section.style.setProperty('--mx', mx.toFixed(2));
      section.style.setProperty('--my', my.toFixed(2));
      pending = null;
    }

    function onMove(ev){
      pending = { x: ev.clientX, y: ev.clientY };
      if (!raf) raf = w.requestAnimationFrame(flush);
    }

    function onLeave(){
      if (raf){ w.cancelAnimationFrame(raf); raf = 0; }
      pending = null;
      section.style.removeProperty('--mx');
      section.style.removeProperty('--my');
    }

    section.addEventListener('pointermove', onMove, { passive: true });
    section.addEventListener('pointerleave', onLeave);
    section.__hhAdoptionHeroBloomOff = function(){
      section.removeEventListener('pointermove', onMove);
      section.removeEventListener('pointerleave', onLeave);
      if (raf) w.cancelAnimationFrame(raf);
      onLeave();
      section.__hhAdoptionHeroBloomBound = false;
    };
  }

  function unbindBloom(section){
    if (section.__hhAdoptionHeroBloomOff){
      try { section.__hhAdoptionHeroBloomOff(); } catch(_e){}
    }
  }

  function bindMagnetic(section){
    if (prefersReduce() || isCoarse()) return;
    if (w.HH && w.HH.magnetic && typeof w.HH.magnetic.bindNew === 'function'){
      try { w.HH.magnetic.bindNew(section); } catch(_e){}
    }
  }

  function bindSection(section){
    if (!section || section.__hhAdoptionHeroBound) return;
    section.__hhAdoptionHeroBound = true;
    bindReveal(section);
    bindBloom(section);
    bindMagnetic(section);
  }

  function bindAll(root){
    var scope = root || d;
    var sections = scope.querySelectorAll ? scope.querySelectorAll(SECTION_SEL) : [];
    for (var i = 0; i < sections.length; i++) bindSection(sections[i]);
    if (root && root.matches && root.matches(SECTION_SEL)) bindSection(root);
  }

  function rebindAll(){
    var sections = d.querySelectorAll(SECTION_SEL);
    for (var i = 0; i < sections.length; i++){
      var s = sections[i];
      if (prefersReduce() || isCoarse()){
        unbindBloom(s);
      } else {
        bindBloom(s);
      }
      bindMagnetic(s);
    }
  }

  function boot(){ bindAll(d); }

  if (d.readyState === 'loading'){
    d.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  d.addEventListener('shopify:section:load', function (ev){
    var target = ev && ev.target;
    if (!target) return;
    bindAll(target);
  });

  attachMQ(reduceMQ, rebindAll);
  attachMQ(coarseMQ, rebindAll);

  w.HH = Object.assign(w.HH || {}, {
    adoptionHero: {
      boot: boot,
      bindNew: bindSection,
      rebind: rebindAll
    }
  });
})(window, document);

/* Cycle 280 :: HH.scrollingBanner
   - IO toggles is-live to play marquee animation only when visible
   - Pointermove rAF passive on track sets --mx/--my for warm bloom
   - HH.magnetic.bindNew rebinds anchors inside segments
   - prefers-reduced-motion + pointer:coarse hard-disable bloom + magnetic
   - Idempotent flag __hhScrollingBannerBound
   - shopify:section:load handler keeps Theme Editor in sync
*/
(function (w, d){
  'use strict';
  if (!w || !d) return;

  var SECTION_SEL = '[data-hh-scrolling-banner]';
  var TRACK_SEL   = '[data-hh-banner-track]';
  var REVEAL_THRESHOLD = 0.1;

  var reduceMQ = w.matchMedia ? w.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var coarseMQ = w.matchMedia ? w.matchMedia('(pointer: coarse)')                : null;

  function prefersReduce(){ return !!(reduceMQ && reduceMQ.matches); }
  function isCoarse(){ return !!(coarseMQ && coarseMQ.matches); }

  function attachMQ(mq, fn){
    if (!mq) return;
    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', fn);
    else if (typeof mq.addListener === 'function') mq.addListener(fn);
  }

  function bindLive(section){
    if (section.__hhScrollingBannerLive) return;
    section.__hhScrollingBannerLive = true;

    if (!('IntersectionObserver' in w)){
      section.classList.add('is-live');
      return;
    }
    var io = new IntersectionObserver(function(entries){
      for (var i = 0; i < entries.length; i++){
        if (entries[i].isIntersecting){
          section.classList.add('is-live');
        } else {
          section.classList.remove('is-live');
        }
      }
    }, { threshold: REVEAL_THRESHOLD });
    io.observe(section);
    section.__hhScrollingBannerIO = io;
  }

  function bindBloom(section){
    if (section.__hhScrollingBannerBloomBound) return;
    if (prefersReduce() || isCoarse()) return;

    var track = section.querySelector(TRACK_SEL);
    if (!track) return;

    section.setAttribute('data-hh-bloom', '');
    section.__hhScrollingBannerBloomBound = true;

    var raf = 0;
    var pending = null;

    function flush(){
      raf = 0;
      if (!pending) return;
      var rect = section.getBoundingClientRect();
      if (!rect.width || !rect.height){ pending = null; return; }
      var mx = ((pending.x - rect.left) / rect.width)  * 100;
      var my = ((pending.y - rect.top)  / rect.height) * 100;
      if (mx < 0) mx = 0; else if (mx > 100) mx = 100;
      if (my < 0) my = 0; else if (my > 100) my = 100;
      section.style.setProperty('--mx', mx.toFixed(2));
      section.style.setProperty('--my', my.toFixed(2));
      pending = null;
    }

    function onMove(ev){
      pending = { x: ev.clientX, y: ev.clientY };
      if (!raf) raf = w.requestAnimationFrame(flush);
    }

    function onLeave(){
      if (raf){ w.cancelAnimationFrame(raf); raf = 0; }
      pending = null;
      section.style.removeProperty('--mx');
      section.style.removeProperty('--my');
    }

    section.addEventListener('pointermove', onMove, { passive: true });
    section.addEventListener('pointerleave', onLeave);

    section.__hhScrollingBannerBloomOff = function(){
      section.removeEventListener('pointermove', onMove);
      section.removeEventListener('pointerleave', onLeave);
      if (raf) w.cancelAnimationFrame(raf);
      onLeave();
      section.removeAttribute('data-hh-bloom');
      section.__hhScrollingBannerBloomBound = false;
    };
  }

  function unbindBloom(section){
    if (section.__hhScrollingBannerBloomOff){
      try { section.__hhScrollingBannerBloomOff(); } catch(_e){}
    }
  }

  function bindMagneticAnchors(section){
    if (prefersReduce() || isCoarse()) return;
    var anchors = section.querySelectorAll('[data-hh-banner-seg] a');
    for (var i = 0; i < anchors.length; i++){
      if (!anchors[i].hasAttribute('data-hh-magnetic')){
        anchors[i].setAttribute('data-hh-magnetic', '');
      }
    }
    if (w.HH && w.HH.magnetic && typeof w.HH.magnetic.bindNew === 'function'){
      try { w.HH.magnetic.bindNew(section); } catch(_e){}
    }
  }

  function bindSection(section){
    if (!section || section.__hhScrollingBannerBound) return;
    section.__hhScrollingBannerBound = true;
    bindLive(section);
    bindBloom(section);
    bindMagneticAnchors(section);
  }

  function bindAll(root){
    var scope = root || d;
    var sections = scope.querySelectorAll ? scope.querySelectorAll(SECTION_SEL) : [];
    for (var i = 0; i < sections.length; i++) bindSection(sections[i]);
    if (root && root.matches && root.matches(SECTION_SEL)) bindSection(root);
  }

  function rebindAll(){
    var sections = d.querySelectorAll(SECTION_SEL);
    for (var i = 0; i < sections.length; i++){
      var s = sections[i];
      if (prefersReduce() || isCoarse()){
        unbindBloom(s);
      } else {
        bindBloom(s);
        bindMagneticAnchors(s);
      }
    }
  }

  function boot(){ bindAll(d); }

  if (d.readyState === 'loading'){
    d.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  d.addEventListener('shopify:section:load', function (ev){
    var target = ev && ev.target;
    if (!target) return;
    bindAll(target);
  });

  attachMQ(reduceMQ, rebindAll);
  attachMQ(coarseMQ, rebindAll);

  w.HH = Object.assign(w.HH || {}, {
    scrollingBanner: {
      boot: boot,
      bindNew: bindSection,
      rebind: rebindAll
    }
  });
})(window, document);

/* Cycle 281 :: HH.article (Recipe C Manuscript editorial reading surface) */
(function(w, d){
  if (!w || !d) return;

  var reduceMQ = w.matchMedia ? w.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function reduced(){ return !!(reduceMQ && reduceMQ.matches); }

  function slugify(s){
    return String(s || '')
      .toLowerCase()
      .replace(/[^\w\s-]/g, '')
      .trim()
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .substring(0, 64) || ('h-' + Math.random().toString(36).slice(2, 8));
  }

  function splitGlyphs(node){
    if (!node || node.dataset.hhGlyphsBound === '1') return;
    var text = node.textContent || '';
    if (!text) return;
    var frag = d.createDocumentFragment();
    var i = 0;
    for (var k = 0; k < text.length; k++){
      var ch = text.charAt(k);
      var span = d.createElement('span');
      span.className = 'hh-article__glyph';
      span.style.setProperty('--i', String(i));
      span.textContent = ch === ' ' ? ' ' : ch;
      frag.appendChild(span);
      i++;
    }
    node.textContent = '';
    node.appendChild(frag);
    node.dataset.hhGlyphsBound = '1';
  }

  function buildToc(article){
    var list = article.querySelector('[data-hh-article-toc]');
    var body = article.querySelector('.hh-article__body');
    if (!list || !body) return null;
    var headings = body.querySelectorAll('h2');
    if (!headings.length){
      var nav = list.closest('.hh-article__rail-toc');
      if (nav) nav.style.display = 'none';
      return null;
    }
    var entries = [];
    headings.forEach(function(h){
      if (!h.id){
        var seed = slugify(h.textContent || 'section');
        var id = seed;
        var n = 2;
        while (d.getElementById(id) && d.getElementById(id) !== h){
          id = seed + '-' + n;
          n++;
        }
        h.id = id;
      }
      var li = d.createElement('li');
      var a = d.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent || '';
      a.dataset.hhArticleTocLink = h.id;
      a.addEventListener('click', function(ev){
        ev.preventDefault();
        var target = d.getElementById(h.id);
        if (!target) return;
        var behavior = reduced() ? 'auto' : 'smooth';
        try {
          target.scrollIntoView({ behavior: behavior, block: 'start' });
        } catch(_e){
          target.scrollIntoView();
        }
        try { history.replaceState(null, '', '#' + h.id); } catch(_e2){}
      });
      li.appendChild(a);
      list.appendChild(li);
      entries.push({ id: h.id, link: a, heading: h });
    });
    return entries;
  }

  function bindTocActiveState(article, entries){
    if (!entries || !entries.length || !('IntersectionObserver' in w)) return;
    var current = null;
    var io = new IntersectionObserver(function(items){
      items.forEach(function(item){
        if (!item.isIntersecting) return;
        var match = entries.filter(function(e){ return e.heading === item.target; })[0];
        if (!match) return;
        if (current && current !== match.link) current.classList.remove('is-current');
        match.link.classList.add('is-current');
        current = match.link;
      });
    }, { rootMargin: '-30% 0px -55% 0px', threshold: 0.4 });
    entries.forEach(function(e){ io.observe(e.heading); });
  }

  function bindScrollProgress(article){
    if (reduced()) return;
    var bar = d.querySelector('.hh-article__progress');
    if (!bar) return;
    var ticking = false;
    function tick(){
      ticking = false;
      var docH = (d.documentElement.scrollHeight || 0) - (w.innerHeight || 0);
      var p = docH > 0 ? Math.max(0, Math.min(1, (w.scrollY || w.pageYOffset || 0) / docH)) : 0;
      bar.style.setProperty('--p', String(p));
    }
    function onScroll(){
      if (ticking) return;
      ticking = true;
      w.requestAnimationFrame(tick);
    }
    w.addEventListener('scroll', onScroll, { passive: true });
    w.addEventListener('resize', onScroll, { passive: true });
    tick();
  }

  function findFirstPullquote(article){
    var body = article.querySelector('.hh-article__body');
    if (!body) return '';
    var q = body.querySelector('blockquote.pullquote, .pullquote, blockquote');
    if (!q) return '';
    return (q.textContent || '').trim().replace(/\s+/g, ' ').substring(0, 220);
  }

  function maybeFillPullquote(article){
    var slot = article.querySelector('[data-hh-article-pullquote]');
    if (!slot) return;
    var text = findFirstPullquote(article);
    if (!text) return;
    slot.textContent = '“' + text + '”';
    slot.classList.add('is-active');
    slot.removeAttribute('aria-hidden');
  }

  function bindCopyLink(article){
    var btn = article.querySelector('[data-hh-article-copy]');
    if (!btn) return;
    var label = btn.querySelector('[data-hh-article-copy-label]');
    var origText = label ? label.textContent : 'Copy link';
    btn.addEventListener('click', function(){
      var url = w.location && w.location.href ? w.location.href : '';
      var done = function(){
        btn.classList.add('is-copied');
        if (label) label.textContent = 'Copied';
        w.setTimeout(function(){
          btn.classList.remove('is-copied');
          if (label) label.textContent = origText;
        }, 1600);
      };
      try {
        if (w.navigator && w.navigator.clipboard && w.navigator.clipboard.writeText){
          w.navigator.clipboard.writeText(url).then(done, function(){
            done();
          });
        } else {
          var ta = d.createElement('textarea');
          ta.value = url;
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          d.body.appendChild(ta);
          ta.select();
          try { d.execCommand('copy'); } catch(_e){}
          d.body.removeChild(ta);
          done();
        }
      } catch(_e2){
        done();
      }
    });
  }

  function bindReveal(article){
    if (!('IntersectionObserver' in w)){
      article.classList.add('is-revealed');
      return;
    }
    var io = new IntersectionObserver(function(entries, obs){
      entries.forEach(function(entry){
        if (entry.isIntersecting){
          article.classList.add('is-revealed');
          obs.disconnect();
        }
      });
    }, { threshold: 0.18 });
    io.observe(article);
  }

  function bindArticle(article){
    if (!article || article.__hhArticleBound) return;
    article.__hhArticleBound = true;

    if (article.getAttribute('data-hh-recipe-c') === 'true'){
      article.classList.add('is-recipe-c');
    }
    if (article.getAttribute('data-hh-drop-cap') === 'true'){
      article.classList.add('has-drop-cap');
    }

    var glyphHost = article.querySelector('[data-hh-article-h-glyphs]');
    if (glyphHost) splitGlyphs(glyphHost);

    var entries = buildToc(article);
    bindTocActiveState(article, entries);

    maybeFillPullquote(article);
    bindCopyLink(article);
    bindScrollProgress(article);
    bindReveal(article);

    if (w.HH && w.HH.magnetic && typeof w.HH.magnetic.bindNew === 'function'){
      try { w.HH.magnetic.bindNew(article); } catch(_e){}
    }
  }

  function bindAll(root){
    var scope = root || d;
    var nodes = scope.querySelectorAll
      ? scope.querySelectorAll('[data-hh-article]')
      : [];
    nodes.forEach(function(n){ bindArticle(n); });
    if (scope !== d && scope.matches && scope.matches('[data-hh-article]')) bindArticle(scope);
  }

  function boot(){ bindAll(d); }

  if (d.readyState === 'loading'){
    d.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  d.addEventListener('shopify:section:load', function(ev){
    var t = ev && ev.target;
    if (!t) return;
    bindAll(t);
  });

  w.HH = Object.assign(w.HH || {}, {
    article: {
      boot: boot,
      bindNew: bindAll
    }
  });
})(window, document);

/* Cycle 282 :: HH.blog (main-blog editorial overhaul)
   - Per-glyph H1 split + IO reveal at 0.18 threshold
   - Card cascade reveal via --ci index var
   - Recipe D catalog tilt via has-offset class (gated by enable_recipe_d_offset)
   - Cursor warm bloom on each card (rAF passive pointermove sets --mx/--my)
   - Tag chips get data-hh-blog-chip + --i index for stagger
   - Selected tag chip gets is-selected (sienna) :: derived from .is-active
   - Pagination links + featured title link get data-hh-magnetic; HH.magnetic.bindNew(section)
   - prefers-reduced-motion + (pointer: coarse) hard-disable bloom + hover transform
   - Idempotent flag __hhBlogBound + shopify:section:load handler
*/
(function(w, d){
  'use strict';
  if (!w || !d) return;

  var SECTION_SEL = '[data-hh-blog]';
  var REVEAL_THRESHOLD = 0.18;

  var reduceMQ = w.matchMedia ? w.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var coarseMQ = w.matchMedia ? w.matchMedia('(pointer: coarse)')                : null;

  function prefersReduce(){ return !!(reduceMQ && reduceMQ.matches); }
  function isCoarse(){ return !!(coarseMQ && coarseMQ.matches); }

  function attachMQ(mq, fn){
    if (!mq) return;
    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', fn);
    else if (typeof mq.addListener === 'function') mq.addListener(fn);
  }

  function splitGlyphs(node){
    if (!node || node.dataset.hhBlogGlyphsBound === '1') return;
    var text = node.textContent || '';
    if (!text) return;
    var frag = d.createDocumentFragment();
    var i = 0;
    for (var k = 0; k < text.length; k++){
      var ch = text.charAt(k);
      var span = d.createElement('span');
      span.className = 'hh-blog__glyph';
      span.style.setProperty('--i', String(i));
      span.textContent = ch === ' ' ? ' ' : ch;
      frag.appendChild(span);
      i++;
    }
    node.textContent = '';
    node.appendChild(frag);
    node.dataset.hhBlogGlyphsBound = '1';
  }

  function bindKineticH(section){
    if (section.__hhBlogKineticBound) return;
    if (section.getAttribute('data-hh-blog-kinetic') !== '1') return;
    var glyphHosts = section.querySelectorAll('[data-hh-blog-h-glyphs]');
    for (var i = 0; i < glyphHosts.length; i++){
      splitGlyphs(glyphHosts[i]);
    }
    section.__hhBlogKineticBound = true;
  }

  function decorateCards(section){
    var cards = section.querySelectorAll('[data-hh-blog-card]');
    for (var i = 0; i < cards.length; i++){
      var c = cards[i];
      if (!c.style.getPropertyValue('--ci')){
        c.style.setProperty('--ci', String(i));
      }
      if (((i + 1) % 3) === 2){
        c.classList.add('is-offset');
      }
    }
  }

  function decorateChips(section){
    var chiprow = section.querySelector('[data-hh-blog-chiprow]');
    if (!chiprow) return;
    var chips = chiprow.querySelectorAll('a, button');
    for (var i = 0; i < chips.length; i++){
      var ch = chips[i];
      if (!ch.hasAttribute('data-hh-blog-chip')){
        ch.setAttribute('data-hh-blog-chip', '');
      }
      ch.style.setProperty('--i', String(i));
      if (ch.classList && ch.classList.contains('is-active')){
        ch.classList.add('is-selected');
      }
    }
  }

  function decorateMagnetic(section){
    if (prefersReduce() || isCoarse()) return;
    var nodes = [];
    var pgLinks = section.querySelectorAll('.hh-pg__ctrl, .hh-pg__page');
    for (var i = 0; i < pgLinks.length; i++){
      if (pgLinks[i].tagName === 'A') nodes.push(pgLinks[i]);
    }
    var titleLinks = section.querySelectorAll('.hh-blog__featured .hh-blogcard__title a, .hh-blog__featured .hh-blogcard__link');
    for (var j = 0; j < titleLinks.length; j++){
      nodes.push(titleLinks[j]);
    }
    for (var k = 0; k < nodes.length; k++){
      if (!nodes[k].hasAttribute('data-hh-magnetic')){
        nodes[k].setAttribute('data-hh-magnetic', '');
      }
    }
    if (w.HH && w.HH.magnetic && typeof w.HH.magnetic.bindNew === 'function'){
      try { w.HH.magnetic.bindNew(section); } catch(_e){}
    }
  }

  function bindCardBloom(card){
    if (card.__hhBlogBloomBound) return;
    if (prefersReduce() || isCoarse()) return;
    card.__hhBlogBloomBound = true;

    var raf = 0;
    var pending = null;

    function flush(){
      raf = 0;
      if (!pending) return;
      var rect = card.getBoundingClientRect();
      if (!rect.width || !rect.height){ pending = null; return; }
      var mx = ((pending.x - rect.left) / rect.width)  * 100;
      var my = ((pending.y - rect.top)  / rect.height) * 100;
      if (mx < 0) mx = 0; else if (mx > 100) mx = 100;
      if (my < 0) my = 0; else if (my > 100) my = 100;
      card.style.setProperty('--mx', mx.toFixed(2));
      card.style.setProperty('--my', my.toFixed(2));
      pending = null;
    }

    function onMove(ev){
      pending = { x: ev.clientX, y: ev.clientY };
      if (!raf) raf = w.requestAnimationFrame(flush);
    }

    function onLeave(){
      if (raf){ w.cancelAnimationFrame(raf); raf = 0; }
      pending = null;
      card.style.removeProperty('--mx');
      card.style.removeProperty('--my');
    }

    card.addEventListener('pointermove', onMove, { passive: true });
    card.addEventListener('pointerleave', onLeave);

    card.__hhBlogBloomOff = function(){
      card.removeEventListener('pointermove', onMove);
      card.removeEventListener('pointerleave', onLeave);
      if (raf) w.cancelAnimationFrame(raf);
      onLeave();
      card.__hhBlogBloomBound = false;
    };
  }

  function unbindCardBloom(card){
    if (card.__hhBlogBloomOff){
      try { card.__hhBlogBloomOff(); } catch(_e){}
    }
  }

  function bindBloom(section){
    if (section.getAttribute('data-hh-blog-bloom') !== '1') return;
    var cards = section.querySelectorAll('[data-hh-blog-card]');
    for (var i = 0; i < cards.length; i++) bindCardBloom(cards[i]);
  }

  function bindReveal(section){
    if (section.__hhBlogRevealBound) return;
    section.__hhBlogRevealBound = true;

    if (prefersReduce()){
      section.classList.add('is-revealed');
      return;
    }
    if (!('IntersectionObserver' in w)){
      section.classList.add('is-revealed');
      return;
    }
    var io = new IntersectionObserver(function(entries, obs){
      for (var i = 0; i < entries.length; i++){
        if (entries[i].isIntersecting){
          section.classList.add('is-revealed');
          obs.unobserve(entries[i].target);
        }
      }
    }, { threshold: REVEAL_THRESHOLD });
    io.observe(section);
    section.__hhBlogIO = io;
  }

  function applyOffsetFlag(section){
    if (section.getAttribute('data-hh-blog-offset') === '1'){
      section.classList.add('has-offset');
    } else {
      section.classList.remove('has-offset');
    }
  }

  function bindSection(section){
    if (!section || section.__hhBlogBound) return;
    section.__hhBlogBound = true;

    applyOffsetFlag(section);
    bindKineticH(section);
    decorateCards(section);
    decorateChips(section);
    decorateMagnetic(section);
    bindBloom(section);
    bindReveal(section);
  }

  function bindAll(root){
    var scope = root || d;
    var sections = scope.querySelectorAll ? scope.querySelectorAll(SECTION_SEL) : [];
    for (var i = 0; i < sections.length; i++) bindSection(sections[i]);
    if (root && root.matches && root.matches(SECTION_SEL)) bindSection(root);
  }

  function rebindMQ(){
    var sections = d.querySelectorAll(SECTION_SEL);
    for (var i = 0; i < sections.length; i++){
      var s = sections[i];
      var cards = s.querySelectorAll('[data-hh-blog-card]');
      if (prefersReduce() || isCoarse()){
        for (var j = 0; j < cards.length; j++) unbindCardBloom(cards[j]);
      } else {
        bindBloom(s);
        decorateMagnetic(s);
      }
    }
  }

  function boot(){ bindAll(d); }

  if (d.readyState === 'loading'){
    d.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  d.addEventListener('shopify:section:load', function(ev){
    var t = ev && ev.target;
    if (!t) return;
    bindAll(t);
  });

  attachMQ(reduceMQ, rebindMQ);
  attachMQ(coarseMQ, rebindMQ);

  w.HH = Object.assign(w.HH || {}, {
    blog: {
      boot: boot,
      bindNew: bindAll,
      rebind: rebindMQ
    }
  });
})(window, document);

/* Cycle 283 :: HH.mainCart (main-cart editorial polish)
   - Recipe A sash via is-recipe-a class
   - Per-glyph H split with --i index var
   - Line item stagger via --li index, IO 0.18 add is-revealed
   - Sticky-note plate jitter (CSS odd/even rotate)
   - Subtotal tabular numerics (CSS)
   - Summary card golden bloom tracking --mx/--my via rAF passive pointermove
   - Magnetic checkout button (delegates to HH.magnetic.bindNew)
   - Qty +/- buttons get spring-bump on click via is-bumped class for 240ms
   - Paw empty state stroke-dashoffset cascade via --si index
   - cart:refresh + MutationObserver re-stagger + re-bind magnetic on AJAX update
   - prefers-reduced-motion + (pointer: coarse) hard-disable bloom + jitter + lift + spring
   - Idempotent flag __hhMainCartBound + shopify:section:load handler
*/
(function(w, d){
  'use strict';
  if (!w || !d) return;

  var SECTION_SEL = '[data-hh-main-cart]';
  var REVEAL_THRESHOLD = 0.18;
  var BUMP_MS = 240;

  var reduceMQ = w.matchMedia ? w.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var coarseMQ = w.matchMedia ? w.matchMedia('(pointer: coarse)')                : null;

  function prefersReduce(){ return !!(reduceMQ && reduceMQ.matches); }
  function isCoarse(){ return !!(coarseMQ && coarseMQ.matches); }

  function attachMQ(mq, fn){
    if (!mq) return;
    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', fn);
    else if (typeof mq.addListener === 'function') mq.addListener(fn);
  }

  function splitGlyphs(node){
    if (!node || node.dataset.hhMainCartGlyphsBound === '1') return;
    var text = node.textContent || '';
    if (!text) return;
    var frag = d.createDocumentFragment();
    var i = 0;
    for (var k = 0; k < text.length; k++){
      var ch = text.charAt(k);
      var span = d.createElement('span');
      span.className = 'hh-cart__glyph';
      span.style.setProperty('--i', String(i));
      span.textContent = ch === ' ' ? ' ' : ch;
      frag.appendChild(span);
      i++;
    }
    node.textContent = '';
    node.appendChild(frag);
    node.dataset.hhMainCartGlyphsBound = '1';
  }

  function bindKineticH(section){
    var hosts = section.querySelectorAll('[data-hh-cart-h-glyphs]');
    for (var i = 0; i < hosts.length; i++) splitGlyphs(hosts[i]);
  }

  function decorateLines(section){
    var lines = section.querySelectorAll('[data-hh-cart-line]');
    for (var i = 0; i < lines.length; i++){
      // Canon: cap the stagger at 12, then restart as a second wave so a long
      // cart never produces runaway delays.
      lines[i].style.setProperty('--li', String(i < 12 ? i : i % 12));
    }
  }

  function decorateMagnetic(section){
    if (prefersReduce() || isCoarse()) return;
    if (w.HH && w.HH.magnetic && typeof w.HH.magnetic.bindNew === 'function'){
      try { w.HH.magnetic.bindNew(section); } catch(_e){}
    }
  }

  function bindBloom(section){
    var summary = section.querySelector('[data-hh-cart-summary]');
    if (!summary) return;
    if (summary.__hhMainCartBloomBound) return;
    if (prefersReduce() || isCoarse()) return;
    summary.__hhMainCartBloomBound = true;

    var raf = 0;
    var pending = null;

    function flush(){
      raf = 0;
      if (!pending) return;
      var rect = summary.getBoundingClientRect();
      if (!rect.width || !rect.height){ pending = null; return; }
      var mx = ((pending.x - rect.left) / rect.width)  * 100;
      var my = ((pending.y - rect.top)  / rect.height) * 100;
      if (mx < 0) mx = 0; else if (mx > 100) mx = 100;
      if (my < 0) my = 0; else if (my > 100) my = 100;
      summary.style.setProperty('--mx', mx.toFixed(2));
      summary.style.setProperty('--my', my.toFixed(2));
      pending = null;
    }

    function onMove(ev){
      pending = { x: ev.clientX, y: ev.clientY };
      if (!raf) raf = w.requestAnimationFrame(flush);
    }

    function onLeave(){
      if (raf){ w.cancelAnimationFrame(raf); raf = 0; }
      pending = null;
      summary.style.removeProperty('--mx');
      summary.style.removeProperty('--my');
    }

    summary.addEventListener('pointermove', onMove, { passive: true });
    summary.addEventListener('pointerleave', onLeave);

    summary.__hhMainCartBloomOff = function(){
      summary.removeEventListener('pointermove', onMove);
      summary.removeEventListener('pointerleave', onLeave);
      if (raf) w.cancelAnimationFrame(raf);
      onLeave();
      summary.__hhMainCartBloomBound = false;
    };
  }

  function unbindBloom(section){
    var summary = section.querySelector('[data-hh-cart-summary]');
    if (summary && summary.__hhMainCartBloomOff){
      try { summary.__hhMainCartBloomOff(); } catch(_e){}
    }
  }

  function decorateQtyBump(section){
    if (prefersReduce()) return;
    var btns = section.querySelectorAll('.hh-qty__btn, [data-hh-qty-up], [data-hh-qty-down]');
    for (var i = 0; i < btns.length; i++){
      var b = btns[i];
      if (!b.hasAttribute('data-hh-qty-bump')){
        b.setAttribute('data-hh-qty-bump', '');
      }
      if (b.__hhMainCartBumpBound) continue;
      b.__hhMainCartBumpBound = true;
      b.addEventListener('click', function(){
        var t = this;
        if (prefersReduce()) return;
        t.classList.add('is-bumped');
        w.setTimeout(function(){ t.classList.remove('is-bumped'); }, BUMP_MS);
      });
    }
  }

  function applyRecipeFlag(section){
    if (section.getAttribute('data-hh-recipe-a') === '1'){
      section.classList.add('is-recipe-a');
    } else {
      section.classList.remove('is-recipe-a');
    }
  }

  function bindReveal(section){
    if (section.__hhMainCartRevealBound) return;
    section.__hhMainCartRevealBound = true;

    if (prefersReduce()){
      section.classList.add('is-revealed');
      var emptyR = section.querySelector('.hh-cartpage__empty');
      if (emptyR) emptyR.classList.add('is-revealed');
      return;
    }
    if (!('IntersectionObserver' in w)){
      section.classList.add('is-revealed');
      var emptyN = section.querySelector('.hh-cartpage__empty');
      if (emptyN) emptyN.classList.add('is-revealed');
      return;
    }
    var io = new IntersectionObserver(function(entries, obs){
      for (var i = 0; i < entries.length; i++){
        if (entries[i].isIntersecting){
          section.classList.add('is-revealed');
          var emp = section.querySelector('.hh-cartpage__empty');
          if (emp) emp.classList.add('is-revealed');
          obs.unobserve(entries[i].target);
        }
      }
    }, { threshold: REVEAL_THRESHOLD });
    io.observe(section);
    section.__hhMainCartIO = io;
  }

  function rebindAjax(section){
    decorateLines(section);
    decorateQtyBump(section);
    decorateMagnetic(section);
    if (prefersReduce() || isCoarse()){
      unbindBloom(section);
    } else {
      bindBloom(section);
    }
  }

  function bindMutationObserver(section){
    if (section.__hhMainCartMOBound) return;
    var items = section.querySelector('[data-hh-cart-items]');
    if (!items || !('MutationObserver' in w)) return;
    section.__hhMainCartMOBound = true;
    var t = 0;
    var mo = new MutationObserver(function(){
      if (t) w.clearTimeout(t);
      t = w.setTimeout(function(){ rebindAjax(section); t = 0; }, 50);
    });
    mo.observe(items, { childList: true, subtree: true });
    section.__hhMainCartMO = mo;
  }

  function bindCartRefresh(section){
    if (section.__hhMainCartRefreshBound) return;
    section.__hhMainCartRefreshBound = true;
    function onRefresh(){ rebindAjax(section); }
    d.addEventListener('cart:refresh', onRefresh);
    section.__hhMainCartRefreshOff = function(){
      d.removeEventListener('cart:refresh', onRefresh);
    };
  }

  function bindSection(section){
    if (!section || section.__hhMainCartBound) return;
    section.__hhMainCartBound = true;

    applyRecipeFlag(section);
    bindKineticH(section);
    decorateLines(section);
    decorateQtyBump(section);
    decorateMagnetic(section);
    bindBloom(section);
    bindReveal(section);
    bindMutationObserver(section);
    bindCartRefresh(section);
  }

  function bindAll(root){
    var scope = root || d;
    var sections = scope.querySelectorAll ? scope.querySelectorAll(SECTION_SEL) : [];
    for (var i = 0; i < sections.length; i++) bindSection(sections[i]);
    if (root && root.matches && root.matches(SECTION_SEL)) bindSection(root);
  }

  function rebindMQ(){
    var sections = d.querySelectorAll(SECTION_SEL);
    for (var i = 0; i < sections.length; i++){
      var s = sections[i];
      if (prefersReduce() || isCoarse()){
        unbindBloom(s);
      } else {
        bindBloom(s);
        decorateMagnetic(s);
      }
    }
  }

  function boot(){ bindAll(d); }

  if (d.readyState === 'loading'){
    d.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  d.addEventListener('shopify:section:load', function(ev){
    var t = ev && ev.target;
    if (!t) return;
    bindAll(t);
  });

  attachMQ(reduceMQ, rebindMQ);
  attachMQ(coarseMQ, rebindMQ);

  w.HH = Object.assign(w.HH || {}, {
    mainCart: {
      boot: boot,
      bindNew: bindAll,
      rebind: rebindMQ,
      refresh: function(section){
        if (section) rebindAjax(section);
        else {
          var sections = d.querySelectorAll(SECTION_SEL);
          for (var i = 0; i < sections.length; i++) rebindAjax(sections[i]);
        }
      }
    }
  });
})(window, document);

/* Cycle 284 :: HH.collection (main-collection editorial polish)
   - Recipe D catalog tilt (every 3rd card translateY(28px)) via has-offset class
   - Per-glyph kinetic H split with --i index
   - Per-card --ci index for staggered reveal
   - Card golden-hour bloom tracking --mx/--my via rAF passive pointermove
   - Magnetic Prev/Next pagination via HH.magnetic.bindNew
   - Sort dropdown spring caret rotate on open
   - Paw empty state stroke-dashoffset cascade via --si
   - MutationObserver on grid: re-decorate cards (--ci, pointermove, magnetic) and re-trigger reveal cascade after AJAX swap
   - prefers-reduced-motion + (pointer: coarse) hard-disable bloom + tilt + spring
   - Idempotent flag __hhCollectionBound + shopify:section:load handler
*/
(function(w, d){
  'use strict';
  if (!w || !d) return;

  var SECTION_SEL = '[data-hh-collection]';
  var REVEAL_THRESHOLD = 0.18;

  var reduceMQ = w.matchMedia ? w.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var coarseMQ = w.matchMedia ? w.matchMedia('(pointer: coarse)')                : null;

  function prefersReduce(){ return !!(reduceMQ && reduceMQ.matches); }
  function isCoarse(){ return !!(coarseMQ && coarseMQ.matches); }

  function attachMQ(mq, fn){
    if (!mq) return;
    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', fn);
    else if (typeof mq.addListener === 'function') mq.addListener(fn);
  }

  function splitGlyphs(node){
    if (!node || node.dataset.hhCollectionGlyphsBound === '1') return;
    var text = node.textContent || '';
    if (!text) return;
    var frag = d.createDocumentFragment();
    for (var k = 0; k < text.length; k++){
      var ch = text.charAt(k);
      var span = d.createElement('span');
      span.className = 'hh-coll__glyph';
      span.style.setProperty('--i', String(k));
      span.textContent = ch === ' ' ? ' ' : ch;
      frag.appendChild(span);
    }
    node.textContent = '';
    node.appendChild(frag);
    node.dataset.hhCollectionGlyphsBound = '1';
  }

  function bindKineticH(section){
    var hosts = section.querySelectorAll('[data-hh-coll-h-glyphs]');
    for (var i = 0; i < hosts.length; i++) splitGlyphs(hosts[i]);
  }

  function applyOffsetFlag(section){
    if (section.getAttribute('data-hh-recipe-d') === '1'){
      section.classList.add('has-offset');
    } else {
      section.classList.remove('has-offset');
    }
  }

  function decorateMagnetic(section){
    if (prefersReduce() || isCoarse()) return;
    if (w.HH && w.HH.magnetic && typeof w.HH.magnetic.bindNew === 'function'){
      try { w.HH.magnetic.bindNew(section); } catch(_e){}
    }
  }

  function unbindCardBloom(card){
    if (card && card.__hhCollBloomOff){
      try { card.__hhCollBloomOff(); } catch(_e){}
    }
  }

  function bindCardBloom(card){
    if (!card) return;
    if (card.__hhCollBloomBound) return;
    if (prefersReduce() || isCoarse()) return;
    var section = card.closest ? card.closest('[data-hh-collection]') : null;
    if (section && section.getAttribute('data-hh-card-bloom') !== '1') return;
    card.__hhCollBloomBound = true;

    var raf = 0;
    var pending = null;

    function flush(){
      raf = 0;
      if (!pending) return;
      var rect = card.getBoundingClientRect();
      if (!rect.width || !rect.height){ pending = null; return; }
      var mx = ((pending.x - rect.left) / rect.width)  * 100;
      var my = ((pending.y - rect.top)  / rect.height) * 100;
      if (mx < 0) mx = 0; else if (mx > 100) mx = 100;
      if (my < 0) my = 0; else if (my > 100) my = 100;
      card.style.setProperty('--mx', mx.toFixed(2));
      card.style.setProperty('--my', my.toFixed(2));
      pending = null;
    }

    function onMove(ev){
      pending = { x: ev.clientX, y: ev.clientY };
      if (!raf) raf = w.requestAnimationFrame(flush);
    }

    function onLeave(){
      if (raf){ w.cancelAnimationFrame(raf); raf = 0; }
      pending = null;
      card.style.removeProperty('--mx');
      card.style.removeProperty('--my');
    }

    card.addEventListener('pointermove', onMove, { passive: true });
    card.addEventListener('pointerleave', onLeave);

    card.__hhCollBloomOff = function(){
      card.removeEventListener('pointermove', onMove);
      card.removeEventListener('pointerleave', onLeave);
      if (raf) w.cancelAnimationFrame(raf);
      onLeave();
      card.__hhCollBloomBound = false;
    };
  }

  function decorateCards(section){
    var cards = section.querySelectorAll('[data-hh-coll-card]');
    for (var i = 0; i < cards.length; i++){
      cards[i].style.setProperty('--ci', String(i));
      bindCardBloom(cards[i]);
    }
  }

  function bindSortCaret(section){
    var wrap = section.querySelector('[data-hh-coll-sort-wrap]');
    var sel = section.querySelector('[data-hh-coll-sort]');
    if (!wrap || !sel || sel.__hhCollSortBound) return;
    sel.__hhCollSortBound = true;

    function onFocus(){ wrap.classList.add('is-open'); }
    function onBlur(){ wrap.classList.remove('is-open'); }
    sel.addEventListener('focus', onFocus);
    sel.addEventListener('blur', onBlur);
    sel.addEventListener('mousedown', onFocus);
    sel.addEventListener('change', onBlur);
  }

  function decoratePaws(section){
    var empty = section.querySelector('[data-hh-coll-empty]');
    if (!empty) return;
    if (section.classList.contains('is-revealed')){
      empty.classList.add('is-empty');
    }
  }

  function bindReveal(section){
    if (section.__hhCollectionRevealBound) return;
    section.__hhCollectionRevealBound = true;

    if (prefersReduce()){
      section.classList.add('is-revealed');
      decoratePaws(section);
      return;
    }
    if (!('IntersectionObserver' in w)){
      section.classList.add('is-revealed');
      decoratePaws(section);
      return;
    }
    var io = new IntersectionObserver(function(entries, obs){
      for (var i = 0; i < entries.length; i++){
        if (entries[i].isIntersecting){
          section.classList.add('is-revealed');
          decoratePaws(section);
          obs.unobserve(entries[i].target);
        }
      }
    }, { threshold: REVEAL_THRESHOLD });
    io.observe(section);
    section.__hhCollectionIO = io;
  }

  function reTriggerRevealCascade(section){
    /* On AJAX grid swap: briefly remove is-revealed, force reflow, re-add to replay cascade. */
    if (prefersReduce()) return;
    var grid = section.querySelector('[data-hh-coll-grid]');
    if (!grid) return;
    section.classList.remove('is-revealed');
    /* Force reflow so transition can re-fire. */
    void grid.offsetWidth;
    w.requestAnimationFrame(function(){
      section.classList.add('is-revealed');
    });
  }

  function rebindAjax(section){
    var cards = section.querySelectorAll('[data-hh-coll-card]');
    for (var i = 0; i < cards.length; i++){
      var c = cards[i];
      unbindCardBloom(c);
    }
    decorateCards(section);
    decorateMagnetic(section);
    decoratePaws(section);
    reTriggerRevealCascade(section);
  }

  function bindMutationObserver(section){
    if (section.__hhCollectionMOBound) return;
    var grid = section.querySelector('[data-hh-coll-grid]');
    if (!grid || !('MutationObserver' in w)) return;
    section.__hhCollectionMOBound = true;
    var t = 0;
    var mo = new MutationObserver(function(){
      if (t) w.clearTimeout(t);
      t = w.setTimeout(function(){ rebindAjax(section); t = 0; }, 60);
    });
    mo.observe(grid, { childList: true, subtree: false });
    section.__hhCollectionMO = mo;
  }

  function bindSection(section){
    if (!section || section.__hhCollectionBound) return;
    section.__hhCollectionBound = true;

    applyOffsetFlag(section);
    if (section.getAttribute('data-hh-kinetic-h') === '1'){
      bindKineticH(section);
    }
    decorateCards(section);
    decorateMagnetic(section);
    bindSortCaret(section);
    bindReveal(section);
    bindMutationObserver(section);
  }

  function bindAll(root){
    var scope = root || d;
    var sections = scope.querySelectorAll ? scope.querySelectorAll(SECTION_SEL) : [];
    for (var i = 0; i < sections.length; i++) bindSection(sections[i]);
    if (root && root.matches && root.matches(SECTION_SEL)) bindSection(root);
  }

  function rebindMQ(){
    var sections = d.querySelectorAll(SECTION_SEL);
    for (var i = 0; i < sections.length; i++){
      var s = sections[i];
      var cards = s.querySelectorAll('[data-hh-coll-card]');
      for (var j = 0; j < cards.length; j++){
        if (prefersReduce() || isCoarse()){
          unbindCardBloom(cards[j]);
        } else {
          bindCardBloom(cards[j]);
        }
      }
      if (!(prefersReduce() || isCoarse())){
        decorateMagnetic(s);
      }
    }
  }

  function boot(){ bindAll(d); }

  if (d.readyState === 'loading'){
    d.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  d.addEventListener('shopify:section:load', function(ev){
    var t = ev && ev.target;
    if (!t) return;
    bindAll(t);
  });

  attachMQ(reduceMQ, rebindMQ);
  attachMQ(coarseMQ, rebindMQ);

  w.HH = Object.assign(w.HH || {}, {
    collection: {
      boot: boot,
      bindNew: bindAll,
      rebind: rebindMQ,
      refresh: function(section){
        if (section) rebindAjax(section);
        else {
          var sections = d.querySelectorAll(SECTION_SEL);
          for (var i = 0; i < sections.length; i++) rebindAjax(sections[i]);
        }
      }
    }
  });
})(window, document);

/* Cycle 285 :: HH.search (main-search editorial polish)
   - Recipe A sash sequence with per-glyph kinetic H1 (--i index) on data-hh-search-h-glyphs
   - Per-card --ci index for staggered reveal cascade
   - Card golden-hour bloom tracking --mx/--my via rAF passive pointermove
   - Magnetic decorations on result links + Prev/Next pagination via HH.magnetic.bindNew
   - Recipe D catalog tilt via has-offset class when data-hh-recipe-d=1
   - Paw empty state stroke-dashoffset cascade via --si
   - MutationObserver on results grid: re-decorate cards (--ci, pointermove, magnetic) and re-trigger reveal cascade after AJAX swap (back-button / theme editor)
   - prefers-reduced-motion + (pointer: coarse) hard-disable bloom + tilt
   - Idempotent flag __hhSearchBound + shopify:section:load handler
*/
(function(w, d){
  'use strict';
  if (!w || !d) return;

  var SECTION_SEL = '[data-hh-search]';
  var REVEAL_THRESHOLD = 0.18;

  var reduceMQ = w.matchMedia ? w.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var coarseMQ = w.matchMedia ? w.matchMedia('(pointer: coarse)')                : null;

  function prefersReduce(){ return !!(reduceMQ && reduceMQ.matches); }
  function isCoarse(){ return !!(coarseMQ && coarseMQ.matches); }

  function attachMQ(mq, fn){
    if (!mq) return;
    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', fn);
    else if (typeof mq.addListener === 'function') mq.addListener(fn);
  }

  function splitGlyphs(node){
    if (!node || node.dataset.hhSearchGlyphsBound === '1') return;
    var text = node.textContent || '';
    if (!text) return;
    var frag = d.createDocumentFragment();
    for (var k = 0; k < text.length; k++){
      var ch = text.charAt(k);
      var span = d.createElement('span');
      span.className = 'hh-search__glyph';
      span.style.setProperty('--i', String(k));
      span.textContent = ch === ' ' ? ' ' : ch;
      frag.appendChild(span);
    }
    node.textContent = '';
    node.appendChild(frag);
    node.dataset.hhSearchGlyphsBound = '1';
  }

  function bindKineticH(section){
    var hosts = section.querySelectorAll('[data-hh-search-h-glyphs]');
    for (var i = 0; i < hosts.length; i++) splitGlyphs(hosts[i]);
  }

  function applyOffsetFlag(section){
    if (section.getAttribute('data-hh-recipe-d') === '1'){
      section.classList.add('has-offset');
    } else {
      section.classList.remove('has-offset');
    }
  }

  function decorateMagnetic(section){
    if (prefersReduce() || isCoarse()) return;
    if (w.HH && w.HH.magnetic && typeof w.HH.magnetic.bindNew === 'function'){
      try { w.HH.magnetic.bindNew(section); } catch(_e){}
    }
  }

  function unbindCardBloom(card){
    if (card && card.__hhSearchBloomOff){
      try { card.__hhSearchBloomOff(); } catch(_e){}
    }
  }

  function bindCardBloom(card){
    if (!card) return;
    if (card.__hhSearchBloomBound) return;
    if (prefersReduce() || isCoarse()) return;
    var section = card.closest ? card.closest('[data-hh-search]') : null;
    if (section && section.getAttribute('data-hh-card-bloom') !== '1') return;
    card.__hhSearchBloomBound = true;

    var raf = 0;
    var pending = null;

    function flush(){
      raf = 0;
      if (!pending) return;
      var rect = card.getBoundingClientRect();
      if (!rect.width || !rect.height){ pending = null; return; }
      var mx = ((pending.x - rect.left) / rect.width)  * 100;
      var my = ((pending.y - rect.top)  / rect.height) * 100;
      if (mx < 0) mx = 0; else if (mx > 100) mx = 100;
      if (my < 0) my = 0; else if (my > 100) my = 100;
      card.style.setProperty('--mx', mx.toFixed(2));
      card.style.setProperty('--my', my.toFixed(2));
      pending = null;
    }

    function onMove(ev){
      pending = { x: ev.clientX, y: ev.clientY };
      if (!raf) raf = w.requestAnimationFrame(flush);
    }

    function onLeave(){
      if (raf){ w.cancelAnimationFrame(raf); raf = 0; }
      pending = null;
      card.style.removeProperty('--mx');
      card.style.removeProperty('--my');
    }

    card.addEventListener('pointermove', onMove, { passive: true });
    card.addEventListener('pointerleave', onLeave);

    card.__hhSearchBloomOff = function(){
      card.removeEventListener('pointermove', onMove);
      card.removeEventListener('pointerleave', onLeave);
      if (raf) w.cancelAnimationFrame(raf);
      onLeave();
      card.__hhSearchBloomBound = false;
    };
  }

  function decorateCards(section){
    var cards = section.querySelectorAll('[data-hh-search-card]');
    for (var i = 0; i < cards.length; i++){
      cards[i].style.setProperty('--ci', String(i));
      bindCardBloom(cards[i]);
    }
  }

  function decoratePaws(section){
    var empty = section.querySelector('[data-hh-search-empty]');
    if (!empty) return;
    if (section.classList.contains('is-revealed')){
      empty.classList.add('is-empty');
    }
  }

  function bindReveal(section){
    if (section.__hhSearchRevealBound) return;
    section.__hhSearchRevealBound = true;

    if (prefersReduce()){
      section.classList.add('is-revealed');
      decoratePaws(section);
      return;
    }
    if (!('IntersectionObserver' in w)){
      section.classList.add('is-revealed');
      decoratePaws(section);
      return;
    }
    var io = new IntersectionObserver(function(entries, obs){
      for (var i = 0; i < entries.length; i++){
        if (entries[i].isIntersecting){
          section.classList.add('is-revealed');
          decoratePaws(section);
          obs.unobserve(entries[i].target);
        }
      }
    }, { threshold: REVEAL_THRESHOLD });
    io.observe(section);
    section.__hhSearchIO = io;
  }

  function reTriggerRevealCascade(section){
    /* On AJAX swap of results: briefly remove is-revealed, force reflow, re-add to replay cascade. */
    if (prefersReduce()) return;
    var grid = section.querySelector('[data-hh-search-grid]');
    if (!grid) return;
    section.classList.remove('is-revealed');
    /* Force reflow so transition can re-fire. */
    void grid.offsetWidth;
    w.requestAnimationFrame(function(){
      section.classList.add('is-revealed');
    });
  }

  function rebindAjax(section){
    var cards = section.querySelectorAll('[data-hh-search-card]');
    for (var i = 0; i < cards.length; i++){
      unbindCardBloom(cards[i]);
    }
    decorateCards(section);
    decorateMagnetic(section);
    decoratePaws(section);
    reTriggerRevealCascade(section);
  }

  function bindMutationObserver(section){
    if (section.__hhSearchMOBound) return;
    var grid = section.querySelector('[data-hh-search-grid]');
    if (!grid || !('MutationObserver' in w)) return;
    section.__hhSearchMOBound = true;
    var t = 0;
    var mo = new MutationObserver(function(){
      if (t) w.clearTimeout(t);
      t = w.setTimeout(function(){ rebindAjax(section); t = 0; }, 60);
    });
    mo.observe(grid, { childList: true, subtree: false });
    section.__hhSearchMO = mo;
  }

  function bindSection(section){
    if (!section || section.__hhSearchBound) return;
    section.__hhSearchBound = true;

    applyOffsetFlag(section);
    if (section.getAttribute('data-hh-kinetic-h') === '1'){
      bindKineticH(section);
    }
    decorateCards(section);
    decorateMagnetic(section);
    bindReveal(section);
    bindMutationObserver(section);
  }

  function bindAll(root){
    var scope = root || d;
    var sections = scope.querySelectorAll ? scope.querySelectorAll(SECTION_SEL) : [];
    for (var i = 0; i < sections.length; i++) bindSection(sections[i]);
    if (root && root.matches && root.matches(SECTION_SEL)) bindSection(root);
  }

  function rebindMQ(){
    var sections = d.querySelectorAll(SECTION_SEL);
    for (var i = 0; i < sections.length; i++){
      var s = sections[i];
      var cards = s.querySelectorAll('[data-hh-search-card]');
      for (var j = 0; j < cards.length; j++){
        if (prefersReduce() || isCoarse()){
          unbindCardBloom(cards[j]);
        } else {
          bindCardBloom(cards[j]);
        }
      }
      if (!(prefersReduce() || isCoarse())){
        decorateMagnetic(s);
      }
    }
  }

  function boot(){ bindAll(d); }

  if (d.readyState === 'loading'){
    d.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  d.addEventListener('shopify:section:load', function(ev){
    var t = ev && ev.target;
    if (!t) return;
    bindAll(t);
  });

  attachMQ(reduceMQ, rebindMQ);
  attachMQ(coarseMQ, rebindMQ);

  w.HH = Object.assign(w.HH || {}, {
    search: {
      boot: boot,
      bindNew: bindAll,
      rebind: rebindMQ,
      refresh: function(section){
        if (section) rebindAjax(section);
        else {
          var sections = d.querySelectorAll(SECTION_SEL);
          for (var i = 0; i < sections.length; i++) rebindAjax(sections[i]);
        }
      }
    }
  });
})(window, document);

/* Cycle 286 :: HH.productSpecs
   PDP product-specs surface enhancement (paired with styles.css block).
   Mirrors the cycle 274 product-faq behavior on sections/product-specs.liquid.
   - IO 0.18 fires .is-revealed once on the section so per-glyph H reveal +
     row-by-row stagger trigger together (CSS handles the staggered timing
     via --i index vars).
   - Pointermove (rAF, passive) on each [data-hh-specs-row] but ONLY while
     open: writes --mx/--my as percentage CSS vars so the conic golden-hour
     bloom tracks the cursor on the active accordion panel. We attach on
     toggle then open and detach on toggle then close.
   - HH.magnetic.bindNew(section) for the optional spec-sheet CTA.
   - matchMedia gates: bypass bloom + smooth animation on
     (prefers-reduced-motion: reduce) or (pointer: coarse). Live re-bind on
     MQ change.
   - Idempotent flag __hhProductSpecsBound. shopify:section:load handler.
   ============================================================ */
(function (w, d) {
  if (!w || !d) return;
  if (w.__hhProductSpecsBound) return;
  w.__hhProductSpecsBound = true;

  var SECTION_SEL = '[data-hh-product-specs]';
  var ROW_SEL = '[data-hh-specs-row]';

  var reduceMQ = w.matchMedia ? w.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var coarseMQ = w.matchMedia ? w.matchMedia('(pointer: coarse)') : null;
  function prefersReduce(){ return !!(reduceMQ && reduceMQ.matches); }
  function isCoarse(){ return !!(coarseMQ && coarseMQ.matches); }

  function bindReveal(section){
    if (!section || section.__hhPsRevealBound) return;
    section.__hhPsRevealBound = true;
    if (prefersReduce() || !w.IntersectionObserver){
      section.classList.add('is-revealed');
      return;
    }
    var io = new w.IntersectionObserver(function (entries){
      for (var i = 0; i < entries.length; i++){
        var en = entries[i];
        if (en.isIntersecting){
          section.classList.add('is-revealed');
          io.disconnect();
          break;
        }
      }
    }, { threshold: 0.18 });
    io.observe(section);
  }

  function attachRowBloom(row){
    if (!row || row.__hhPsBloomNodeBound) return;
    row.__hhPsBloomNodeBound = true;

    var ticking = false;
    var pendingX = 50;
    var pendingY = 50;

    function flush(){
      ticking = false;
      try {
        row.style.setProperty('--mx', pendingX.toFixed(2) + '%');
        row.style.setProperty('--my', pendingY.toFixed(2) + '%');
      } catch(_e){}
    }

    function onMove(ev){
      var rect = row.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      var px = ((ev.clientX - rect.left) / rect.width) * 100;
      var py = ((ev.clientY - rect.top) / rect.height) * 100;
      if (px < 0) px = 0; else if (px > 100) px = 100;
      if (py < 0) py = 0; else if (py > 100) py = 100;
      pendingX = px;
      pendingY = py;
      if (!ticking){
        ticking = true;
        w.requestAnimationFrame(flush);
      }
    }

    function onLeave(){
      pendingX = 50;
      pendingY = 50;
      if (!ticking){
        ticking = true;
        w.requestAnimationFrame(flush);
      }
    }

    row.addEventListener('pointermove', onMove, { passive: true });
    row.addEventListener('pointerleave', onLeave, { passive: true });

    row.__hhPsBloomOff = function(){
      try { row.removeEventListener('pointermove', onMove); } catch(_e){}
      try { row.removeEventListener('pointerleave', onLeave); } catch(_e){}
      row.__hhPsBloomNodeBound = false;
    };
  }

  function detachRowBloom(row){
    if (!row) return;
    if (typeof row.__hhPsBloomOff === 'function') row.__hhPsBloomOff();
    try {
      row.style.removeProperty('--mx');
      row.style.removeProperty('--my');
    } catch(_e){}
  }

  function bindToggle(section){
    if (!section || section.__hhPsToggleBound) return;
    section.__hhPsToggleBound = true;
    section.addEventListener('toggle', function (ev){
      var tgt = ev.target;
      if (!tgt || !(tgt instanceof HTMLDetailsElement)) return;
      if (!tgt.matches || !tgt.matches(ROW_SEL)) return;
      if (prefersReduce() || isCoarse()) return;
      if (tgt.open){
        attachRowBloom(tgt);
      } else {
        detachRowBloom(tgt);
      }
    }, true);
  }

  function teardownAllBloom(section){
    if (!section) return;
    var rows = section.querySelectorAll(ROW_SEL);
    for (var i = 0; i < rows.length; i++) detachRowBloom(rows[i]);
  }

  function reattachOpenBloom(section){
    if (!section || prefersReduce() || isCoarse()) return;
    var rows = section.querySelectorAll(ROW_SEL);
    for (var i = 0; i < rows.length; i++){
      if (rows[i].open) attachRowBloom(rows[i]);
    }
  }

  function bindMagnetic(section){
    if (!section) return;
    if (w.HH && w.HH.magnetic && typeof w.HH.magnetic.bindNew === 'function'){
      try { w.HH.magnetic.bindNew(section); } catch(_e){}
    }
  }

  function bindSection(section){
    if (!section) return;
    bindReveal(section);
    bindToggle(section);
    reattachOpenBloom(section);
    bindMagnetic(section);
  }

  function rebind(){
    var sections = d.querySelectorAll(SECTION_SEL);
    for (var i = 0; i < sections.length; i++){
      var s = sections[i];
      teardownAllBloom(s);
      reattachOpenBloom(s);
    }
  }

  function attachMQ(mq, fn){
    if (!mq) return;
    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', fn);
    else if (typeof mq.addListener === 'function') mq.addListener(fn);
  }

  function boot(root){
    var scope = (root && root.querySelectorAll) ? root : d;
    var sections = scope.querySelectorAll(SECTION_SEL);
    for (var i = 0; i < sections.length; i++) bindSection(sections[i]);
  }

  if (d.readyState !== 'loading') boot(d);
  else d.addEventListener('DOMContentLoaded', function(){ boot(d); });

  d.addEventListener('shopify:section:load', function(ev){
    if (ev && ev.target){
      var root = ev.target;
      var inner = root.querySelector ? root.querySelector(SECTION_SEL) : null;
      if (inner){
        inner.__hhPsRevealBound = false;
        inner.__hhPsToggleBound = false;
        bindSection(inner);
      } else {
        boot(root);
      }
    }
  });

  attachMQ(reduceMQ, rebind);
  attachMQ(coarseMQ, rebind);

  w.HH = Object.assign(w.HH || {}, {
    productSpecs: {
      boot: boot,
      bindNew: bindSection,
      rebind: rebind
    }
  });
})(window, document);

/* =========================================================
   Cycle 287 :: HH.videoWithText
   Editorial polish for sections/video-with-text:
   - IO 0.18 -> add .is-revealed once (per-glyph H rises in)
   - Pointermove rAF passive on .hh-vwt__media -> --mx --my
     CSS vars drive the bloom corner tracking pointer
   - Custom paw-stamp play overlay :: click hides overlay,
     starts video, exposes native controls
   - is-recipe-b class added when section opted in
   - HH.magnetic.bindNew(section) wires CTA spring-back
   - matchMedia gates :: prefers-reduced-motion + pointer:coarse
     hard-disable bloom + autoplay
   - Idempotent flag __hhVwtBound. shopify:section:load handler.
   ========================================================= */
(function(w, d){
  'use strict';
  if (!w || !d) return;

  var SEL = '[data-hh-vwt]';

  var reduceMQ = w.matchMedia ? w.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var coarseMQ = w.matchMedia ? w.matchMedia('(pointer: coarse)') : null;

  function prefersReduce(){ return !!(reduceMQ && reduceMQ.matches); }
  function isCoarse(){ return !!(coarseMQ && coarseMQ.matches); }

  function attachMQ(mq, fn){
    if (!mq) return;
    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', fn);
    else if (typeof mq.addListener === 'function') mq.addListener(fn);
  }

  function bindReveal(section){
    if (!('IntersectionObserver' in w)){
      section.classList.add('is-revealed');
      return;
    }
    var io = new IntersectionObserver(function(entries){
      for (var i = 0; i < entries.length; i++){
        if (entries[i].isIntersecting){
          section.classList.add('is-revealed');
          io.disconnect();
          break;
        }
      }
    }, { threshold: 0.18 });
    io.observe(section);
  }

  function bindBloomTracking(section){
    if (prefersReduce() || isCoarse()) return;
    if (section.getAttribute('data-hh-vwt-bloom') !== '1') return;
    var media = section.querySelector('[data-hh-vwt-media]');
    if (!media) return;

    var rafPending = 0;
    var lastX = 0.7, lastY = 0.3;

    function onMove(ev){
      var rect = media.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      var pt = ev.touches && ev.touches[0] ? ev.touches[0] : ev;
      lastX = Math.min(1, Math.max(0, (pt.clientX - rect.left) / rect.width));
      lastY = Math.min(1, Math.max(0, (pt.clientY - rect.top) / rect.height));
      if (rafPending) return;
      rafPending = w.requestAnimationFrame(function(){
        rafPending = 0;
        media.style.setProperty('--mx', lastX.toFixed(3));
        media.style.setProperty('--my', lastY.toFixed(3));
      });
    }
    function onLeave(){
      if (rafPending){ w.cancelAnimationFrame(rafPending); rafPending = 0; }
      media.style.setProperty('--mx', '0.7');
      media.style.setProperty('--my', '0.3');
    }

    media.addEventListener('pointermove', onMove, { passive: true });
    media.addEventListener('pointerleave', onLeave, { passive: true });
  }

  function bindPawPlay(section){
    if (section.getAttribute('data-hh-vwt-paw') !== '1') return;
    var btn = section.querySelector('[data-hh-vwt-paw-btn]');
    var media = section.querySelector('[data-hh-vwt-media]');
    if (!btn || !media) return;
    var video = media.querySelector('video');
    if (!video) {
      btn.style.display = 'none';
      return;
    }

    function reveal(){
      btn.setAttribute('data-hh-vwt-paw-played', '1');
      try { video.setAttribute('controls', 'controls'); } catch(_e){}
      try {
        var p = video.play();
        if (p && typeof p.then === 'function'){
          p.catch(function(){ /* autoplay rejection :: leave controls */ });
        }
      } catch(_e){}
      // remove from tab order after the stamp animates out
      w.setTimeout(function(){
        if (btn && btn.parentNode){
          btn.setAttribute('aria-hidden', 'true');
          btn.tabIndex = -1;
          btn.style.display = 'none';
        }
      }, 380);
    }

    btn.addEventListener('click', function(ev){
      ev.preventDefault();
      reveal();
    });
    btn.addEventListener('keydown', function(ev){
      if (ev.key === 'Enter' || ev.key === ' '){
        ev.preventDefault();
        reveal();
      }
    });
  }

  function applyRecipeB(section){
    if (section.getAttribute('data-hh-vwt-recipe-b') === '1'){
      section.classList.add('is-recipe-b');
    }
  }

  function applyMotionGates(section){
    if (prefersReduce() || isCoarse()){
      // hard-disable bloom + autoplay :: reveal headline instantly
      section.classList.remove('is-bloom');
      section.classList.add('is-revealed');
      var v = section.querySelector('video');
      if (v){
        try { v.removeAttribute('autoplay'); } catch(_e){}
      }
    }
  }

  function bindSection(section){
    if (!section || section.__hhVwtBound) return;
    section.__hhVwtBound = true;

    applyRecipeB(section);
    applyMotionGates(section);
    bindReveal(section);
    bindBloomTracking(section);
    bindPawPlay(section);

    if (w.HH && w.HH.magnetic && typeof w.HH.magnetic.bindNew === 'function'){
      try { w.HH.magnetic.bindNew(section); } catch(_e){}
    }
  }

  function bootAll(root){
    var scope = root && root.querySelectorAll ? root : d;
    var nodes = scope.querySelectorAll(SEL);
    for (var i = 0; i < nodes.length; i++) bindSection(nodes[i]);
    // Also handle case where root itself is a section
    if (root && root.matches && root.matches(SEL)) bindSection(root);
  }

  function rebind(){
    var nodes = d.querySelectorAll(SEL);
    for (var i = 0; i < nodes.length; i++){
      var section = nodes[i];
      // re-apply motion gates on MQ change
      applyMotionGates(section);
    }
  }

  if (d.readyState !== 'loading') bootAll(d);
  else d.addEventListener('DOMContentLoaded', function(){ bootAll(d); });

  d.addEventListener('shopify:section:load', function(ev){
    if (ev && ev.target) bootAll(ev.target);
  });

  attachMQ(reduceMQ, rebind);
  attachMQ(coarseMQ, rebind);

  w.HH = Object.assign(w.HH || {}, {
    videoWithText: {
      boot: bootAll,
      bindNew: bootAll,
      bind: bindSection,
      rebind: rebind
    }
  });
})(window, document);

/* Cycle 288 :: HH.story
   Manuscript Recipe C wiring for sections/story-snippet.liquid.
   - IO 0.18 reveal once (per-glyph kinetic H)
   - Recipe C grid + drop-cap classes from data attrs
   - rAF pointermove for golden bloom corner (--mx/--my)
   - HH.magnetic.bindNew(section) for primary CTA
   - prefers-reduced-motion + pointer:coarse hard-disable bloom + sticky
   - Idempotent + shopify:section:load aware
*/
(function(w, d){
  if (!w || !d) return;
  var SEL = '[data-hh-story]';
  var reduceMQ = w.matchMedia ? w.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var coarseMQ = w.matchMedia ? w.matchMedia('(pointer: coarse)') : null;

  function prefersReduce(){ return !!(reduceMQ && reduceMQ.matches); }
  function isCoarse(){ return !!(coarseMQ && coarseMQ.matches); }

  function attachMQ(mq, fn){
    if (!mq || !fn) return;
    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', fn);
    else if (typeof mq.addListener === 'function') mq.addListener(fn);
  }

  function applyAttrClasses(section){
    if (section.getAttribute('data-hh-story-recipe-c') === '1'){
      section.classList.add('is-recipe-c');
    }
    if (section.getAttribute('data-hh-story-drop-cap') === '1'){
      section.classList.add('has-drop-cap');
    }
    if (section.getAttribute('data-hh-story-bloom') === '1'){
      section.classList.add('has-bloom-corner');
    }
  }

  function bindReveal(section){
    if (!('IntersectionObserver' in w)){
      section.classList.add('is-revealed');
      return;
    }
    var io = new IntersectionObserver(function(entries){
      for (var i = 0; i < entries.length; i++){
        var e = entries[i];
        if (e.isIntersecting){
          e.target.classList.add('is-revealed');
          io.unobserve(e.target);
        }
      }
    }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });
    io.observe(section);
  }

  function bindBloomTracking(section){
    if (prefersReduce() || isCoarse()) return;
    var bloom = section.querySelector('.hh-story__bloom');
    if (!bloom) return;
    var raf = 0;
    var nextX = 100, nextY = 0;
    function flush(){
      raf = 0;
      bloom.style.setProperty('--mx', nextX.toFixed(2));
      bloom.style.setProperty('--my', nextY.toFixed(2));
    }
    function onMove(ev){
      var rect = section.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      nextX = ((ev.clientX - rect.left) / rect.width) * 100;
      nextY = ((ev.clientY - rect.top) / rect.height) * 100;
      if (nextX < 0) nextX = 0; else if (nextX > 100) nextX = 100;
      if (nextY < 0) nextY = 0; else if (nextY > 100) nextY = 100;
      if (!raf) raf = w.requestAnimationFrame(flush);
    }
    section.addEventListener('pointermove', onMove, { passive: true });
    section.__hhStoryBloomBound = true;
  }

  function applyMotionGates(section){
    if (prefersReduce()){
      section.classList.add('is-revealed');
    }
    if (prefersReduce() || isCoarse()){
      var bloom = section.querySelector('.hh-story__bloom');
      if (bloom) bloom.style.display = 'none';
    }
  }

  function bindSection(section){
    if (!section || section.__hhStoryBound) return;
    section.__hhStoryBound = true;
    applyAttrClasses(section);
    applyMotionGates(section);
    bindReveal(section);
    bindBloomTracking(section);
    if (w.HH && w.HH.magnetic && typeof w.HH.magnetic.bindNew === 'function'){
      try { w.HH.magnetic.bindNew(section); } catch(_e){}
    }
  }

  function bootAll(root){
    var scope = root && root.querySelectorAll ? root : d;
    var nodes = scope.querySelectorAll(SEL);
    for (var i = 0; i < nodes.length; i++) bindSection(nodes[i]);
    if (root && root.matches && root.matches(SEL)) bindSection(root);
  }

  function rebind(){
    var nodes = d.querySelectorAll(SEL);
    for (var i = 0; i < nodes.length; i++){
      applyMotionGates(nodes[i]);
    }
  }

  if (d.readyState !== 'loading') bootAll(d);
  else d.addEventListener('DOMContentLoaded', function(){ bootAll(d); });

  d.addEventListener('shopify:section:load', function(ev){
    if (ev && ev.target) bootAll(ev.target);
  });

  attachMQ(reduceMQ, rebind);
  attachMQ(coarseMQ, rebind);

  w.HH = Object.assign(w.HH || {}, {
    story: {
      boot: bootAll,
      bindNew: bootAll,
      bind: bindSection,
      rebind: rebind
    }
  });
})(window, document);

/* Cycle 289 :: HH.animalPage
   Editorial enhancement for sections/main-metaobject-adoption.liquid.
   - IO 0.18 fires .is-revealed once per [data-hh-animal] so the per-glyph
     name reveal (--i) and per-tile gallery cascade (--ci) trigger.
   - Adds is-recipe-b to hero, is-recipe-c to body, has-tilt to gallery
     based on data attrs.
   - rAF-throttled passive pointermove on each [data-hh-gallery-tile] writes
     --mx/--my (0..100%) for the conic warm bloom AND --tx/--ty (-1..1) for
     perspective tilt clamped at +-4deg. pointerleave springs vars back.
   - Hero --mx/--my pointer track for golden bloom corner.
   - Inquiry form submit listener: marks panel hidden=false + .is-active to
     trigger paw cascade. MutationObserver picks up server-rendered success
     class (form.posted_successfully?).
   - HH.magnetic.bindNew(section) so cycle 259 binds CTA + submit.
   - matchMedia gates: prefers-reduced-motion + pointer:coarse hard-disable
     bloom + tilt + paw-cursor. Live re-bind on MQ change.
   - Optional paw-trail canvas confined to section (only when
     data-hh-paw-cursor true), capped at 24 stamps, alpha decay 0.92, IO
     suspended off-viewport.
   - Idempotent flag __hhAnimalPageBound. shopify:section:load handler.
   ============================================================ */
(function (w, d) {
  if (!w || !d) return;
  if (w.__hhAnimalPageBound) return;
  w.__hhAnimalPageBound = true;

  var SECTION_SEL = '[data-hh-animal]';
  var GALLERY_SEL = '[data-hh-animal-gallery]';
  var TILE_SEL = '[data-hh-gallery-tile]';
  var HERO_SEL = '.hh-animal__hero';
  var HERO_IMG_SEL = '.hh-animal__hero-img';
  var BODY_SEL = '.hh-animal__body';
  var INQUIRY_SEL = '[data-hh-animal-inquiry]';
  var SUCCESS_SEL = '[data-hh-animal-success]';
  var FORM_SEL = 'form.hh-adopt-form, form#AnimalInquiry';
  var SUBMIT_SEL = '[data-hh-animal-submit]';

  var reduceMQ = w.matchMedia ? w.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var coarseMQ = w.matchMedia ? w.matchMedia('(pointer: coarse)') : null;
  function prefersReduce(){ return !!(reduceMQ && reduceMQ.matches); }
  function isCoarse(){ return !!(coarseMQ && coarseMQ.matches); }

  function attachMQ(mq, handler){
    if (!mq) return;
    if (typeof mq.addEventListener === 'function'){
      mq.addEventListener('change', handler);
    } else if (typeof mq.addListener === 'function'){
      mq.addListener(handler);
    }
  }

  function readBool(el, attr, fallback){
    if (!el) return fallback;
    var v = el.getAttribute(attr);
    if (v == null) return fallback;
    return v === 'true' || v === '1';
  }

  function applyAttrClasses(section){
    if (!section) return;
    var hero = section.querySelector(HERO_SEL);
    if (hero && readBool(section, 'data-hh-recipe-b', true)){
      if (!hero.classList.contains('is-recipe-b')) hero.classList.add('is-recipe-b');
    }
    var body = section.querySelector(BODY_SEL);
    if (body && readBool(section, 'data-hh-recipe-c', true)){
      if (!body.classList.contains('is-recipe-c')) body.classList.add('is-recipe-c');
    }
    var gallery = section.querySelector(GALLERY_SEL);
    if (gallery && readBool(section, 'data-hh-gallery-tilt', true)){
      if (!gallery.classList.contains('has-tilt')) gallery.classList.add('has-tilt');
    }
    /* index gallery tiles with --ci */
    if (gallery){
      var tiles = gallery.querySelectorAll(TILE_SEL);
      for (var i = 0; i < tiles.length; i++){
        if (tiles[i].style.getPropertyValue('--ci') !== String(i)){
          try { tiles[i].style.setProperty('--ci', i); } catch(_e){}
        }
      }
    }
  }

  function bindReveal(section){
    if (!section || section.__hhAnimalRevealBound) return;
    section.__hhAnimalRevealBound = true;
    if (prefersReduce() || !w.IntersectionObserver){
      section.classList.add('is-revealed');
      return;
    }
    var io = new w.IntersectionObserver(function (entries){
      for (var i = 0; i < entries.length; i++){
        if (entries[i].isIntersecting){
          section.classList.add('is-revealed');
          io.disconnect();
          break;
        }
      }
    }, { threshold: 0.18 });
    io.observe(section);
  }

  function bindHeroBloom(section){
    if (!section || section.__hhAnimalHeroBound) return;
    if (prefersReduce() || isCoarse()) return;
    var heroImg = section.querySelector(HERO_IMG_SEL);
    if (!heroImg) return;
    section.__hhAnimalHeroBound = true;

    var rafId = 0;
    var nextX = 80, nextY = 30;
    function flush(){
      rafId = 0;
      try {
        heroImg.style.setProperty('--mx', nextX.toFixed(2) + '%');
        heroImg.style.setProperty('--my', nextY.toFixed(2) + '%');
      } catch(_e){}
    }
    function onMove(ev){
      var rect = heroImg.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      var rx = ((ev.clientX - rect.left) / rect.width) * 100;
      var ry = ((ev.clientY - rect.top) / rect.height) * 100;
      if (rx < 0) rx = 0; else if (rx > 100) rx = 100;
      if (ry < 0) ry = 0; else if (ry > 100) ry = 100;
      nextX = rx;
      nextY = ry;
      if (!rafId) rafId = w.requestAnimationFrame(flush);
    }
    function onLeave(){
      nextX = 80;
      nextY = 30;
      if (!rafId) rafId = w.requestAnimationFrame(flush);
    }
    var hero = section.querySelector(HERO_SEL) || heroImg;
    hero.addEventListener('pointermove', onMove, { passive: true });
    hero.addEventListener('pointerleave', onLeave, { passive: true });
    section.__hhAnimalHeroMove = onMove;
    section.__hhAnimalHeroLeave = onLeave;
    section.__hhAnimalHeroEl = hero;
  }

  function unbindHeroBloom(section){
    if (!section || !section.__hhAnimalHeroBound) return;
    var hero = section.__hhAnimalHeroEl;
    if (hero){
      if (section.__hhAnimalHeroMove) hero.removeEventListener('pointermove', section.__hhAnimalHeroMove);
      if (section.__hhAnimalHeroLeave) hero.removeEventListener('pointerleave', section.__hhAnimalHeroLeave);
    }
    section.__hhAnimalHeroBound = false;
    section.__hhAnimalHeroMove = null;
    section.__hhAnimalHeroLeave = null;
    section.__hhAnimalHeroEl = null;
  }

  function bindGalleryTiles(section){
    if (!section || section.__hhAnimalTilesBound) return;
    if (prefersReduce() || isCoarse()) return;
    if (!readBool(section, 'data-hh-gallery-tilt', true)) return;
    var gallery = section.querySelector(GALLERY_SEL);
    if (!gallery) return;
    section.__hhAnimalTilesBound = true;

    var tiles = gallery.querySelectorAll(TILE_SEL);
    for (var i = 0; i < tiles.length; i++){
      attachTile(tiles[i]);
    }
  }

  function attachTile(tile){
    if (!tile || tile.__hhAnimalTileBound) return;
    tile.__hhAnimalTileBound = true;

    var ticking = false;
    var pendingMx = 50, pendingMy = 30, pendingTx = 0, pendingTy = 0;

    function flush(){
      ticking = false;
      try {
        tile.style.setProperty('--mx', pendingMx.toFixed(2) + '%');
        tile.style.setProperty('--my', pendingMy.toFixed(2) + '%');
        tile.style.setProperty('--tx', pendingTx.toFixed(3));
        tile.style.setProperty('--ty', pendingTy.toFixed(3));
      } catch(_e){}
    }

    function onMove(ev){
      var rect = tile.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      var rx = (ev.clientX - rect.left) / rect.width;
      var ry = (ev.clientY - rect.top) / rect.height;
      if (rx < 0) rx = 0; else if (rx > 1) rx = 1;
      if (ry < 0) ry = 0; else if (ry > 1) ry = 1;
      pendingMx = rx * 100;
      pendingMy = ry * 100;
      /* clamped at +-1 which maps to +-4deg in CSS calc */
      pendingTx = (rx - 0.5) * 2;
      pendingTy = (ry - 0.5) * 2;
      if (!ticking){
        ticking = true;
        w.requestAnimationFrame(flush);
      }
    }

    function onLeave(){
      pendingMx = 50;
      pendingMy = 30;
      pendingTx = 0;
      pendingTy = 0;
      if (!ticking){
        ticking = true;
        w.requestAnimationFrame(flush);
      }
    }

    tile.addEventListener('pointermove', onMove, { passive: true });
    tile.addEventListener('pointerleave', onLeave, { passive: true });
    tile.__hhAnimalTileMove = onMove;
    tile.__hhAnimalTileLeave = onLeave;
  }

  function unbindGalleryTiles(section){
    if (!section || !section.__hhAnimalTilesBound) return;
    var tiles = section.querySelectorAll(TILE_SEL);
    for (var i = 0; i < tiles.length; i++){
      var t = tiles[i];
      if (t.__hhAnimalTileMove) t.removeEventListener('pointermove', t.__hhAnimalTileMove);
      if (t.__hhAnimalTileLeave) t.removeEventListener('pointerleave', t.__hhAnimalTileLeave);
      t.__hhAnimalTileBound = false;
      t.__hhAnimalTileMove = null;
      t.__hhAnimalTileLeave = null;
    }
    section.__hhAnimalTilesBound = false;
  }

  function activateSuccess(section){
    if (!section) return;
    var panel = section.querySelector(SUCCESS_SEL);
    if (!panel) return;
    if (panel.hasAttribute('hidden')) panel.removeAttribute('hidden');
    if (!panel.classList.contains('is-active')){
      w.requestAnimationFrame(function (){
        panel.classList.add('is-active');
      });
    }
  }

  function bindForm(section){
    if (!section || section.__hhAnimalFormBound) return;
    section.__hhAnimalFormBound = true;

    var inquiry = section.querySelector(INQUIRY_SEL) || section;
    var form = inquiry.querySelector(FORM_SEL);
    if (!form) return;

    /* Pre-rendered success state (Shopify form.posted_successfully?) */
    var existing = inquiry.querySelector(SUCCESS_SEL);
    if (existing && !existing.hasAttribute('hidden')){
      w.requestAnimationFrame(function (){
        existing.classList.add('is-active');
      });
    }

    function onSubmit(){
      var panel = inquiry.querySelector(SUCCESS_SEL);
      if (panel && panel.hasAttribute('hidden')){
        /* Optimistic show. Shopify roundtrip will re-render with the final
           server message; class persists across that cycle via Liquid. */
        panel.removeAttribute('hidden');
      }
    }
    form.addEventListener('submit', onSubmit);
    section.__hhAnimalFormHandler = onSubmit;

    /* MutationObserver: catch external scripts toggling .is-active or hidden. */
    if (w.MutationObserver){
      var panel = inquiry.querySelector(SUCCESS_SEL);
      if (panel){
        var mo = new w.MutationObserver(function (records){
          for (var i = 0; i < records.length; i++){
            var r = records[i];
            if (r.type === 'attributes'){
              if (r.attributeName === 'class' && panel.classList.contains('is-active')){
                activateSuccess(section);
              }
              if (r.attributeName === 'hidden' && !panel.hasAttribute('hidden')){
                activateSuccess(section);
              }
            }
          }
        });
        try {
          mo.observe(panel, { attributes: true, attributeFilter: ['class', 'hidden'] });
          section.__hhAnimalSuccessMO = mo;
        } catch(_e){}
      }
    }
  }

  function bindMagnetic(section){
    if (!section || prefersReduce() || isCoarse()) return;
    if (w.HH && w.HH.magnetic && typeof w.HH.magnetic.bindNew === 'function'){
      try { w.HH.magnetic.bindNew(section); } catch(_e){}
    }
  }

  /* Optional paw-trail canvas confined to section. */
  function bindPawCursor(section){
    if (!section || section.__hhAnimalPawBound) return;
    if (prefersReduce() || isCoarse()) return;
    if (!readBool(section, 'data-hh-paw-cursor', false)) return;
    if (!w.requestAnimationFrame) return;

    section.__hhAnimalPawBound = true;

    var canvas = d.createElement('canvas');
    canvas.setAttribute('data-hh-animal-paw-canvas', '');
    canvas.setAttribute('aria-hidden', 'true');
    section.appendChild(canvas);

    var ctx = canvas.getContext && canvas.getContext('2d');
    if (!ctx){
      try { section.removeChild(canvas); } catch(_e){}
      return;
    }

    var stamps = [];
    var MAX_STAMPS = 24;
    var rafId = 0;
    var visible = true;
    var dpr = w.devicePixelRatio || 1;
    var lastX = -1, lastY = -1;
    var MIN_DIST = 24;

    function size(){
      var rect = section.getBoundingClientRect();
      canvas.width = Math.max(1, Math.floor(rect.width * dpr));
      canvas.height = Math.max(1, Math.floor(rect.height * dpr));
      canvas.style.width = rect.width + 'px';
      canvas.style.height = rect.height + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    function drawPaw(x, y, alpha, angle){
      ctx.save();
      ctx.globalAlpha = alpha;
      ctx.translate(x, y);
      ctx.rotate(angle);
      ctx.fillStyle = '#7a3a1f';
      ctx.beginPath();
      ctx.ellipse(0, 4, 7, 9, 0, 0, Math.PI * 2);
      ctx.fill();
      var toes = [
        { x: -8, y: -4, rx: 3, ry: 4 },
        { x: -3, y: -10, rx: 3, ry: 4 },
        { x:  3, y: -10, rx: 3, ry: 4 },
        { x:  8, y: -4, rx: 3, ry: 4 }
      ];
      for (var i = 0; i < toes.length; i++){
        var t = toes[i];
        ctx.beginPath();
        ctx.ellipse(t.x, t.y, t.rx, t.ry, 0, 0, Math.PI * 2);
        ctx.fill();
      }
      ctx.restore();
    }

    function tick(){
      rafId = 0;
      ctx.clearRect(0, 0, canvas.width / dpr, canvas.height / dpr);
      var alive = false;
      for (var i = 0; i < stamps.length; i++){
        var s = stamps[i];
        if (s.alpha <= 0.02) continue;
        drawPaw(s.x, s.y, s.alpha, s.angle);
        s.alpha *= 0.92;
        alive = true;
      }
      if (stamps.length > MAX_STAMPS){
        stamps = stamps.slice(stamps.length - MAX_STAMPS);
      }
      if (alive && visible){
        rafId = w.requestAnimationFrame(tick);
      }
    }

    function schedule(){
      if (!rafId && visible){
        rafId = w.requestAnimationFrame(tick);
      }
    }

    function onMove(ev){
      var rect = section.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      var x = ev.clientX - rect.left;
      var y = ev.clientY - rect.top;
      if (lastX >= 0){
        var dx = x - lastX;
        var dy = y - lastY;
        if ((dx * dx + dy * dy) < (MIN_DIST * MIN_DIST)) return;
      }
      var angle = lastX >= 0 ? Math.atan2(y - lastY, x - lastX) : 0;
      lastX = x;
      lastY = y;
      stamps.push({ x: x, y: y, alpha: 0.85, angle: angle });
      if (stamps.length > MAX_STAMPS) stamps.shift();
      schedule();
    }
    function onLeave(){ lastX = -1; lastY = -1; }

    section.addEventListener('pointermove', onMove, { passive: true });
    section.addEventListener('pointerleave', onLeave, { passive: true });

    if (w.IntersectionObserver){
      var io = new w.IntersectionObserver(function (entries){
        for (var i = 0; i < entries.length; i++){
          visible = entries[i].isIntersecting;
        }
        if (visible) schedule();
      }, { threshold: 0.05 });
      io.observe(section);
    }
    if (w.ResizeObserver){
      var ro = new w.ResizeObserver(size);
      try { ro.observe(section); } catch(_e){}
    } else {
      w.addEventListener('resize', size, { passive: true });
    }
    size();
  }

  function bindSection(section){
    if (!section) return;
    applyAttrClasses(section);
    bindReveal(section);
    bindHeroBloom(section);
    bindGalleryTiles(section);
    bindForm(section);
    bindMagnetic(section);
    bindPawCursor(section);
  }

  function bindAll(root){
    var scope = root || d;
    var sections = scope.querySelectorAll
      ? scope.querySelectorAll(SECTION_SEL)
      : [];
    for (var i = 0; i < sections.length; i++){
      bindSection(sections[i]);
    }
    if (root && root.matches && root.matches(SECTION_SEL)){
      bindSection(root);
    }
  }

  function rebindAll(){
    var sections = d.querySelectorAll(SECTION_SEL);
    for (var i = 0; i < sections.length; i++){
      var s = sections[i];
      if (prefersReduce() || isCoarse()){
        unbindGalleryTiles(s);
        unbindHeroBloom(s);
      } else {
        bindGalleryTiles(s);
        bindHeroBloom(s);
      }
      bindMagnetic(s);
    }
  }

  function boot(){ bindAll(d); }

  if (d.readyState === 'loading'){
    d.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  d.addEventListener('shopify:section:load', function (ev){
    var target = ev && ev.target;
    if (!target) return;
    bindAll(target);
  });

  attachMQ(reduceMQ, rebindAll);
  attachMQ(coarseMQ, rebindAll);

  w.HH = Object.assign(w.HH || {}, {
    animalPage: {
      boot: boot,
      bindNew: bindSection,
      rebind: rebindAll,
      activateSuccess: activateSuccess
    }
  });
})(window, document);

/* Cycle 291 :: HH.megaMenu (editorial overhaul, canon section 2 section 3 section 5 section 6 section 8) */
(function (w, d) {
  if (w.__hhMegaMenuBound) return;
  w.__hhMegaMenuBound = true;

  var reduceMQ = w.matchMedia ? w.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var coarseMQ = w.matchMedia ? w.matchMedia('(pointer: coarse)') : null;
  function reduced(){ return !!(reduceMQ && reduceMQ.matches); }
  function coarse(){ return !!(coarseMQ && coarseMQ.matches); }

  function splitGlyphs(headingLink){
    if (!headingLink || headingLink.dataset.hhGlyphSplit === '1') return;
    var raw = headingLink.getAttribute('data-hh-glyph-text') || headingLink.textContent || '';
    raw = raw.replace(/\s+/g, ' ').trim();
    if (!raw) return;
    headingLink.textContent = '';
    var i = 0;
    for (var ci = 0; ci < raw.length; ci++) {
      var ch = raw.charAt(ci);
      var span = d.createElement('span');
      span.className = 'hh-mega__glyph';
      span.style.setProperty('--i', String(i));
      span.textContent = ch;
      span.setAttribute('aria-hidden', 'true');
      headingLink.appendChild(span);
      i++;
    }
    var sr = d.createElement('span');
    sr.className = 'visually-hidden';
    sr.style.cssText = 'position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;';
    sr.textContent = raw;
    headingLink.appendChild(sr);
    headingLink.dataset.hhGlyphSplit = '1';
  }

  function indexSublinks(panel){
    var lis = panel.querySelectorAll('.hh-mega__sublinks > li');
    for (var i = 0; i < lis.length; i++) {
      lis[i].style.setProperty('--si', String(i));
    }
  }

  function initPanel(panel){
    if (!panel || panel.dataset.hhMegaInit === '1') return;
    panel.dataset.hhMegaInit = '1';

    var headings = panel.querySelectorAll('.hh-mega__col-h a');
    for (var h = 0; h < headings.length; h++) splitGlyphs(headings[h]);
    indexSublinks(panel);

    if (w.HH && w.HH.magnetic && typeof w.HH.magnetic.bindNew === 'function') {
      try { w.HH.magnetic.bindNew(panel); } catch (e) { /* noop */ }
    }

    // Pointer-tracked bloom (rAF-throttled, passive). Disabled on reduced/coarse.
    var bloomActive = !reduced() && !coarse();
    if (bloomActive) {
      var ticking = false;
      var lastX = 85, lastY = 12;
      panel.addEventListener('pointermove', function (ev){
        if (ticking) return;
        var rect = panel.getBoundingClientRect();
        var px = ((ev.clientX - rect.left) / rect.width) * 100;
        var py = ((ev.clientY - rect.top) / rect.height) * 100;
        if (!isFinite(px) || !isFinite(py)) return;
        lastX = Math.max(0, Math.min(100, px));
        lastY = Math.max(0, Math.min(100, py));
        ticking = true;
        w.requestAnimationFrame(function (){
          panel.style.setProperty('--mx', lastX + '%');
          panel.style.setProperty('--my', lastY + '%');
          ticking = false;
        });
      }, { passive: true });
    }
  }

  function findPanelHosts(scope){
    var root = scope && scope.querySelectorAll ? scope : d;
    return root.querySelectorAll('[data-hh-mega-panel]');
  }

  function syncOpenState(){
    // The existing wireDesktopMenuKeys logic toggles aria-expanded on the root link
    // and adds .open to the parent .hh-nav__item. Mirror that into is-open on the
    // inner [data-hh-mega-panel] for the editorial reveal.
    var items = d.querySelectorAll('.hh-nav__item');
    for (var i = 0; i < items.length; i++) {
      var li = items[i];
      var panel = li.querySelector('[data-hh-mega-panel]');
      if (!panel) continue;
      var isOpen = li.classList.contains('open') ||
                   li.matches(':focus-within') ||
                   li.matches(':hover');
      panel.classList.toggle('is-open', !!isOpen);
    }
  }

  function watchTriggers(){
    var roots = d.querySelectorAll('.hh-nav__link.hh-nav__link--root[aria-haspopup="true"]');
    if (!roots.length) return;
    var mo = new MutationObserver(function (){ syncOpenState(); });
    for (var i = 0; i < roots.length; i++) {
      mo.observe(roots[i], { attributes: true, attributeFilter: ['aria-expanded'] });
    }
    // Class-list changes on the parent li (e.g., .open toggled by hover handler)
    var items = d.querySelectorAll('.hh-nav__item');
    for (var j = 0; j < items.length; j++) {
      mo.observe(items[j], { attributes: true, attributeFilter: ['class'] });
      items[j].addEventListener('mouseenter', syncOpenState);
      items[j].addEventListener('mouseleave', syncOpenState);
      items[j].addEventListener('focusin', syncOpenState);
      items[j].addEventListener('focusout', function (){ w.setTimeout(syncOpenState, 0); });
    }
  }

  function boot(){
    var panels = findPanelHosts(d);
    for (var i = 0; i < panels.length; i++) initPanel(panels[i]);
    syncOpenState();
    watchTriggers();
  }

  function rebind(scope){
    var panels = findPanelHosts(scope || d);
    for (var i = 0; i < panels.length; i++) initPanel(panels[i]);
    syncOpenState();
  }

  if (d.readyState !== 'loading') boot();
  else d.addEventListener('DOMContentLoaded', boot);

  d.addEventListener('shopify:section:load', function (ev){
    var t = ev && ev.target;
    if (!t) return;
    rebind(t);
  });

  function attachMQ(mq, fn){
    if (!mq) return;
    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', fn);
    else if (typeof mq.addListener === 'function') mq.addListener(fn);
  }
  attachMQ(reduceMQ, function (){ /* re-eval bloom on reduce flip happens at next mount */ });
  attachMQ(coarseMQ, function (){ /* re-eval bloom on coarse flip happens at next mount */ });

  w.HH = Object.assign(w.HH || {}, {
    megaMenu: {
      boot: boot,
      rebind: rebind,
      sync: syncOpenState
    }
  });
})(window, document);

/* Cycle 293 :: HH.lookbook
   Editorial photo essay :: cinematic IO reveal, per-tile pointer tilt,
   warm bloom corner tracking, cursor-lens cinematic mask, optional paw trail.
   - Idempotent flag __hhLookbookBound; matchMedia hard-disable on
     prefers-reduced-motion + (pointer: coarse).
   - rAF-throttled passive pointermove; springs back on leave.
   - shopify:section:load rebind for editor live-reload.
   ========================================================= */
(function (w, d) {
  if (!w || !d) return;
  if (w.__hhLookbookBound) return;
  w.__hhLookbookBound = true;

  var SECTION_SEL = '[data-hh-lookbook]';
  var TILE_SEL = '[data-hh-lookbook-tile]';

  var reduceMQ = w.matchMedia ? w.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var coarseMQ = w.matchMedia ? w.matchMedia('(pointer: coarse)') : null;
  function prefersReduce(){ return !!(reduceMQ && reduceMQ.matches); }
  function isCoarse(){ return !!(coarseMQ && coarseMQ.matches); }

  var sections = [];

  function applyFlags(section){
    var recipeD = section.getAttribute('data-hh-lookbook-recipe-d') !== '0';
    var tilt = section.getAttribute('data-hh-lookbook-tilt') !== '0';
    var lens = section.getAttribute('data-hh-lookbook-lens') !== '0';
    if (recipeD) section.classList.add('has-recipe-d'); else section.classList.remove('has-recipe-d');
    if (tilt && !prefersReduce() && !isCoarse()) section.classList.add('has-tilt'); else section.classList.remove('has-tilt');
    if (lens && !prefersReduce() && !isCoarse()) section.classList.add('has-lens'); else section.classList.remove('has-lens');
  }

  function indexTiles(section){
    var tiles = section.querySelectorAll(TILE_SEL);
    for (var i = 0; i < tiles.length; i++){
      var t = tiles[i];
      // --ci is also written from Liquid; keep in sync.
      t.style.setProperty('--ci', String(i));
    }
    return tiles;
  }

  function bindLensSrc(tiles){
    for (var i = 0; i < tiles.length; i++){
      var tile = tiles[i];
      if (tile.__hhLookbookLensSrc) continue;
      var img = tile.querySelector('img');
      if (!img) continue;
      // Use currentSrc when available (responsive), fall back to src.
      var src = img.currentSrc || img.getAttribute('src') || '';
      if (!src) continue;
      var media = tile.querySelector('.hh-look__media');
      if (!media) continue;
      media.style.setProperty('--hh-lens-img', 'url("' + src.replace(/"/g, '\\"') + '")');
      tile.__hhLookbookLensSrc = true;
    }
  }

  function bindReveal(section){
    if (section.__hhLookbookRevealBound) return;
    section.__hhLookbookRevealBound = true;
    if (prefersReduce() || !('IntersectionObserver' in w)){
      section.classList.add('is-revealed');
      return;
    }
    var io = new IntersectionObserver(function(entries){
      for (var i = 0; i < entries.length; i++){
        var e = entries[i];
        if (e.isIntersecting){
          e.target.classList.add('is-revealed');
          io.unobserve(e.target);
        }
      }
    }, { threshold: 0.18, rootMargin: '0px 0px -6% 0px' });
    io.observe(section);
  }

  function bindBloom(section){
    if (section.__hhLookbookBloomBound) return;
    if (prefersReduce() || isCoarse()) return;
    section.__hhLookbookBloomBound = true;

    var ticking = false;
    var px = 0.8, py = 0.18;

    function flush(){
      ticking = false;
      section.style.setProperty('--mx', (px * 100).toFixed(2) + '%');
      section.style.setProperty('--my', (py * 100).toFixed(2) + '%');
    }

    function onMove(ev){
      var rect = section.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      var x = (ev.clientX - rect.left) / rect.width;
      var y = (ev.clientY - rect.top) / rect.height;
      if (x < 0) x = 0; else if (x > 1) x = 1;
      if (y < 0) y = 0; else if (y > 1) y = 1;
      px = x; py = y;
      if (!ticking){
        ticking = true;
        w.requestAnimationFrame(flush);
      }
    }

    section.addEventListener('pointermove', onMove, { passive: true });
    section.__hhLookbookBloomOff = function(){
      try { section.removeEventListener('pointermove', onMove); } catch(_e){}
      section.style.removeProperty('--mx');
      section.style.removeProperty('--my');
      section.__hhLookbookBloomBound = false;
    };
  }

  function bindTile(tile){
    if (!tile || tile.__hhLookbookTileBound) return;
    if (prefersReduce() || isCoarse()) return;
    tile.__hhLookbookTileBound = true;

    var ticking = false;
    var ntx = 0, nty = 0;     // normalized -1..1 for tilt
    var lxPct = 50, lyPct = 50; // lens position percent
    var springTimer = 0;

    function flush(){
      ticking = false;
      tile.style.setProperty('--tx', ntx.toFixed(4));
      tile.style.setProperty('--ty', nty.toFixed(4));
      tile.style.setProperty('--lx', lxPct.toFixed(2) + '%');
      tile.style.setProperty('--ly', lyPct.toFixed(2) + '%');
    }

    function onMove(ev){
      var rect = tile.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      var x = (ev.clientX - rect.left) / rect.width;
      var y = (ev.clientY - rect.top) / rect.height;
      if (x < 0) x = 0; else if (x > 1) x = 1;
      if (y < 0) y = 0; else if (y > 1) y = 1;
      ntx = (x - 0.5) * 2;
      nty = (y - 0.5) * 2;
      lxPct = x * 100;
      lyPct = y * 100;
      if (!ticking){
        ticking = true;
        w.requestAnimationFrame(flush);
      }
    }

    function onLeave(){
      ntx = 0; nty = 0;
      lxPct = 50; lyPct = 50;
      if (!ticking){
        ticking = true;
        w.requestAnimationFrame(flush);
      }
      if (springTimer) w.clearTimeout(springTimer);
      springTimer = w.setTimeout(function(){
        tile.style.removeProperty('--tx');
        tile.style.removeProperty('--ty');
      }, 360);
    }

    function onEnter(){
      if (springTimer){ w.clearTimeout(springTimer); springTimer = 0; }
    }

    tile.addEventListener('pointermove', onMove, { passive: true });
    tile.addEventListener('pointerenter', onEnter, { passive: true });
    tile.addEventListener('pointerleave', onLeave, { passive: true });

    tile.__hhLookbookTileOff = function(){
      try { tile.removeEventListener('pointermove', onMove); } catch(_e){}
      try { tile.removeEventListener('pointerenter', onEnter); } catch(_e){}
      try { tile.removeEventListener('pointerleave', onLeave); } catch(_e){}
      if (springTimer){ w.clearTimeout(springTimer); springTimer = 0; }
      tile.style.removeProperty('--tx');
      tile.style.removeProperty('--ty');
      tile.style.removeProperty('--lx');
      tile.style.removeProperty('--ly');
      tile.__hhLookbookTileBound = false;
    };
  }

  function bindPawTrail(section){
    if (section.__hhLookbookPawBound) return;
    if (prefersReduce() || isCoarse()) return;
    if (section.getAttribute('data-hh-lookbook-paw') !== '1') return;
    section.__hhLookbookPawBound = true;

    var canvas = d.createElement('canvas');
    canvas.className = 'hh-lookbook__paw-canvas';
    canvas.setAttribute('aria-hidden', 'true');
    section.appendChild(canvas);

    var ctx = canvas.getContext && canvas.getContext('2d');
    if (!ctx){ section.removeChild(canvas); return; }

    var stamps = [];
    var MAX_STAMPS = 24;
    var FADE = 0.92;
    var rafId = 0;
    var inView = true;
    var lastStampX = -9999, lastStampY = -9999;
    var STAMP_GAP = 26;

    function resize(){
      var rect = section.getBoundingClientRect();
      var dpr = w.devicePixelRatio || 1;
      canvas.width = Math.max(1, Math.floor(rect.width * dpr));
      canvas.height = Math.max(1, Math.floor(rect.height * dpr));
      canvas.style.width = rect.width + 'px';
      canvas.style.height = rect.height + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    function drawPaw(x, y, alpha, size){
      ctx.save();
      ctx.globalAlpha = alpha;
      ctx.fillStyle = '#7A4A2B';
      ctx.beginPath();
      ctx.ellipse(x, y, size * 0.55, size * 0.7, 0, 0, Math.PI * 2);
      ctx.fill();
      // 4 toe pads
      var dx = size * 0.7;
      ctx.beginPath();
      ctx.ellipse(x - dx, y - size * 0.6, size * 0.28, size * 0.34, 0, 0, Math.PI * 2);
      ctx.fill();
      ctx.beginPath();
      ctx.ellipse(x - dx * 0.4, y - size * 0.95, size * 0.28, size * 0.34, 0, 0, Math.PI * 2);
      ctx.fill();
      ctx.beginPath();
      ctx.ellipse(x + dx * 0.4, y - size * 0.95, size * 0.28, size * 0.34, 0, 0, Math.PI * 2);
      ctx.fill();
      ctx.beginPath();
      ctx.ellipse(x + dx, y - size * 0.6, size * 0.28, size * 0.34, 0, 0, Math.PI * 2);
      ctx.fill();
      ctx.restore();
    }

    function tick(){
      rafId = 0;
      if (!inView){ ctx.clearRect(0, 0, canvas.width, canvas.height); return; }
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      var alive = [];
      for (var i = 0; i < stamps.length; i++){
        var s = stamps[i];
        s.a *= FADE;
        if (s.a > 0.04){
          drawPaw(s.x, s.y, s.a, s.size);
          alive.push(s);
        }
      }
      stamps = alive;
      if (stamps.length){
        rafId = w.requestAnimationFrame(tick);
      }
    }

    function onMove(ev){
      var rect = section.getBoundingClientRect();
      var x = ev.clientX - rect.left;
      var y = ev.clientY - rect.top;
      var dx = x - lastStampX, dy = y - lastStampY;
      if (dx * dx + dy * dy < STAMP_GAP * STAMP_GAP) return;
      lastStampX = x; lastStampY = y;
      stamps.push({ x: x, y: y, a: 0.65, size: 10 + Math.random() * 4 });
      if (stamps.length > MAX_STAMPS) stamps.splice(0, stamps.length - MAX_STAMPS);
      if (!rafId) rafId = w.requestAnimationFrame(tick);
    }

    section.addEventListener('pointermove', onMove, { passive: true });

    var io = ('IntersectionObserver' in w) ? new IntersectionObserver(function(entries){
      for (var i = 0; i < entries.length; i++){
        inView = entries[i].isIntersecting;
        if (inView && stamps.length && !rafId) rafId = w.requestAnimationFrame(tick);
      }
    }, { threshold: 0 }) : null;
    if (io) io.observe(section);

    var ro = ('ResizeObserver' in w) ? new ResizeObserver(resize) : null;
    if (ro) ro.observe(section);
    else w.addEventListener('resize', resize, { passive: true });

    resize();

    section.__hhLookbookPawOff = function(){
      try { section.removeEventListener('pointermove', onMove); } catch(_e){}
      try { if (io) io.disconnect(); } catch(_e){}
      try { if (ro) ro.disconnect(); } catch(_e){}
      if (rafId){ w.cancelAnimationFrame(rafId); rafId = 0; }
      try { if (canvas.parentNode) canvas.parentNode.removeChild(canvas); } catch(_e){}
      section.__hhLookbookPawBound = false;
    };
  }

  function bindSection(section){
    if (!section || section.__hhLookbookSectionBound) return;
    section.__hhLookbookSectionBound = true;

    applyFlags(section);
    var tiles = indexTiles(section);
    bindReveal(section);
    bindBloom(section);
    bindLensSrc(tiles);
    for (var i = 0; i < tiles.length; i++) bindTile(tiles[i]);
    bindPawTrail(section);

    if (w.HH && w.HH.magnetic && typeof w.HH.magnetic.bindNew === 'function'){
      try { w.HH.magnetic.bindNew(section); } catch(_e){}
    }
  }

  function unbindSection(section){
    var tiles = section.querySelectorAll(TILE_SEL);
    for (var i = 0; i < tiles.length; i++){
      var t = tiles[i];
      if (typeof t.__hhLookbookTileOff === 'function') t.__hhLookbookTileOff();
      t.__hhLookbookLensSrc = false;
    }
    if (typeof section.__hhLookbookBloomOff === 'function') section.__hhLookbookBloomOff();
    if (typeof section.__hhLookbookPawOff === 'function') section.__hhLookbookPawOff();
    section.__hhLookbookRevealBound = false;
    section.classList.remove('is-revealed', 'has-recipe-d', 'has-tilt', 'has-lens');
    section.__hhLookbookSectionBound = false;
  }

  function boot(){
    var nodes = d.querySelectorAll(SECTION_SEL);
    sections = Array.prototype.slice.call(nodes);
    for (var i = 0; i < sections.length; i++) bindSection(sections[i]);
  }

  function rebind(scope){
    var root = scope || d;
    var nodes = (root === d) ? d.querySelectorAll(SECTION_SEL) : (root.matches && root.matches(SECTION_SEL) ? [root] : root.querySelectorAll(SECTION_SEL));
    for (var i = 0; i < nodes.length; i++){
      unbindSection(nodes[i]);
      bindSection(nodes[i]);
      if (sections.indexOf(nodes[i]) === -1) sections.push(nodes[i]);
    }
  }

  function attachMQ(mq, fn){
    if (!mq) return;
    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', fn);
    else if (typeof mq.addListener === 'function') mq.addListener(fn);
  }

  function reflowAll(){
    for (var i = 0; i < sections.length; i++){
      unbindSection(sections[i]);
      bindSection(sections[i]);
    }
  }

  attachMQ(reduceMQ, reflowAll);
  attachMQ(coarseMQ, reflowAll);

  if (d.readyState !== 'loading') boot();
  else d.addEventListener('DOMContentLoaded', boot);

  d.addEventListener('shopify:section:load', function (ev){
    var t = ev && ev.target;
    if (!t) return;
    rebind(t);
  });

  w.HH = Object.assign(w.HH || {}, {
    lookbook: {
      boot: boot,
      rebind: rebind
    }
  });
})(window, document);

/* Cycle 294 :: HH.press
   Editorial press-kit binding.
   - IO 0.18 to add is-revealed once on the section.
   - Sets --qi on quotes + --di on download rows (defensive; liquid sets these too).
   - rAF-throttled pointermove on contact card + quote tiles to set --mx/--my (0..100).
   - Email-copy button: navigator.clipboard.writeText, "Copied" feedback for 1600ms.
   - Magnetic CTAs: defers to HH.magnetic.bindNew once section is visible.
   - matchMedia gates: prefers-reduced-motion + pointer:coarse hard-disable bloom.
   - Idempotent flag __hhPressBound + shopify:section:load handler. */
(function (w, d){
  'use strict';
  if (!w || !d) return;

  var SECTION_SEL = '[data-hh-press]';
  var COPY_FEEDBACK_MS = 1600;

  var reduceMQ = w.matchMedia ? w.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var coarseMQ = w.matchMedia ? w.matchMedia('(pointer: coarse)') : null;

  function reduce(){ return !!(reduceMQ && reduceMQ.matches); }
  function coarse(){ return !!(coarseMQ && coarseMQ.matches); }
  function bloomDisabled(){ return reduce() || coarse(); }

  var sections = [];

  function setIndices(section){
    var quotes = section.querySelectorAll('.hh-press__quote');
    for (var i = 0; i < quotes.length; i++){
      if (!quotes[i].style.getPropertyValue('--qi')){
        quotes[i].style.setProperty('--qi', String(i));
      }
    }
    var rows = section.querySelectorAll('.hh-press__download-row');
    for (var j = 0; j < rows.length; j++){
      if (!rows[j].style.getPropertyValue('--di')){
        rows[j].style.setProperty('--di', String(j));
      }
    }
  }

  function bindBloomTracker(el){
    if (!el || el.__hhPressBloomBound) return;
    el.__hhPressBloomBound = true;

    var raf = 0;
    var pending = null;
    var rect = null;

    function refresh(){ rect = el.getBoundingClientRect(); }

    function flush(){
      raf = 0;
      if (!pending || !rect) return;
      var dx = pending.x - rect.left;
      var dy = pending.y - rect.top;
      var mx = Math.max(0, Math.min(100, (dx / rect.width) * 100));
      var my = Math.max(0, Math.min(100, (dy / rect.height) * 100));
      pending = null;
      el.style.setProperty('--mx', mx.toFixed(2));
      el.style.setProperty('--my', my.toFixed(2));
    }

    function onMove(ev){
      if (bloomDisabled()) return;
      if (!rect) refresh();
      pending = { x: ev.clientX, y: ev.clientY };
      if (!raf) raf = w.requestAnimationFrame(flush);
    }

    function onEnter(){ if (!bloomDisabled()) refresh(); }
    function onLeave(){
      if (raf){ w.cancelAnimationFrame(raf); raf = 0; }
      pending = null;
      el.style.removeProperty('--mx');
      el.style.removeProperty('--my');
    }

    el.addEventListener('pointerenter', onEnter, { passive: true });
    el.addEventListener('pointermove', onMove, { passive: true });
    el.addEventListener('pointerleave', onLeave, { passive: true });
    el.addEventListener('pointercancel', onLeave, { passive: true });

    el.__hhPressBloomOff = function(){
      el.removeEventListener('pointerenter', onEnter);
      el.removeEventListener('pointermove', onMove);
      el.removeEventListener('pointerleave', onLeave);
      el.removeEventListener('pointercancel', onLeave);
      if (raf) w.cancelAnimationFrame(raf);
      el.style.removeProperty('--mx');
      el.style.removeProperty('--my');
      el.__hhPressBloomBound = false;
    };
  }

  function bindCopyButton(btn){
    if (!btn || btn.__hhPressCopyBound) return;
    btn.__hhPressCopyBound = true;

    var labelEl = btn.querySelector('[data-hh-press-copy-label]');
    var originalLabel = labelEl ? labelEl.textContent : '';
    var resetTimer = 0;

    function showCopied(){
      if (labelEl) labelEl.textContent = 'Copied';
      btn.setAttribute('data-hh-press-copied', '1');
      if (resetTimer) w.clearTimeout(resetTimer);
      resetTimer = w.setTimeout(function(){
        if (labelEl) labelEl.textContent = originalLabel;
        btn.removeAttribute('data-hh-press-copied');
        resetTimer = 0;
      }, COPY_FEEDBACK_MS);
    }

    function fallbackCopy(text){
      try{
        var ta = d.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        d.body.appendChild(ta);
        ta.select();
        try { d.execCommand('copy'); } catch(_e){}
        d.body.removeChild(ta);
      } catch(_err){}
    }

    function onClick(ev){
      ev.preventDefault();
      var email = btn.getAttribute('data-hh-press-email') || '';
      if (!email) return;
      if (w.navigator && w.navigator.clipboard && w.navigator.clipboard.writeText){
        w.navigator.clipboard.writeText(email).then(showCopied, function(){
          fallbackCopy(email);
          showCopied();
        });
      } else {
        fallbackCopy(email);
        showCopied();
      }
    }

    btn.addEventListener('click', onClick);

    btn.__hhPressCopyOff = function(){
      btn.removeEventListener('click', onClick);
      if (resetTimer) w.clearTimeout(resetTimer);
      if (labelEl) labelEl.textContent = originalLabel;
      btn.removeAttribute('data-hh-press-copied');
      btn.__hhPressCopyBound = false;
    };
  }

  function reveal(section){
    if (section.__hhPressRevealed) return;
    section.__hhPressRevealed = true;
    section.classList.add('is-revealed');
    if (w.HH && w.HH.magnetic && typeof w.HH.magnetic.bindNew === 'function'){
      try { w.HH.magnetic.bindNew(section); } catch(_e){}
    }
  }

  function bindSection(section){
    if (!section || section.__hhPressBound) return;
    section.__hhPressBound = true;

    setIndices(section);

    if (!bloomDisabled()){
      var quotes = section.querySelectorAll('.hh-press__quote');
      for (var i = 0; i < quotes.length; i++) bindBloomTracker(quotes[i]);
      var contact = section.querySelector('[data-hh-press-contact]');
      if (contact) bindBloomTracker(contact);
    }

    var copy = section.querySelector('[data-hh-press-copy]');
    if (copy) bindCopyButton(copy);

    if (reduce() || !('IntersectionObserver' in w)){
      reveal(section);
      return;
    }

    var io = new w.IntersectionObserver(function(entries){
      for (var k = 0; k < entries.length; k++){
        if (entries[k].isIntersecting){
          reveal(section);
          io.disconnect();
          break;
        }
      }
    }, { threshold: 0.18 });
    io.observe(section);
    section.__hhPressIO = io;
  }

  function unbindSection(section){
    if (!section || !section.__hhPressBound) return;
    var bloomNodes = section.querySelectorAll('[data-hh-press-contact], .hh-press__quote');
    for (var i = 0; i < bloomNodes.length; i++){
      var n = bloomNodes[i];
      if (typeof n.__hhPressBloomOff === 'function') n.__hhPressBloomOff();
    }
    var copy = section.querySelector('[data-hh-press-copy]');
    if (copy && typeof copy.__hhPressCopyOff === 'function') copy.__hhPressCopyOff();
    if (section.__hhPressIO){
      try { section.__hhPressIO.disconnect(); } catch(_e){}
      section.__hhPressIO = null;
    }
    section.classList.remove('is-revealed');
    section.__hhPressRevealed = false;
    section.__hhPressBound = false;
  }

  function boot(){
    var nodes = d.querySelectorAll(SECTION_SEL);
    sections = Array.prototype.slice.call(nodes);
    for (var i = 0; i < sections.length; i++) bindSection(sections[i]);
  }

  function rebind(scope){
    var root = scope || d;
    var nodes;
    if (root === d){
      nodes = d.querySelectorAll(SECTION_SEL);
    } else if (root.matches && root.matches(SECTION_SEL)){
      nodes = [root];
    } else {
      nodes = root.querySelectorAll ? root.querySelectorAll(SECTION_SEL) : [];
    }
    for (var i = 0; i < nodes.length; i++){
      unbindSection(nodes[i]);
      bindSection(nodes[i]);
      if (sections.indexOf(nodes[i]) === -1) sections.push(nodes[i]);
    }
  }

  function attachMQ(mq, fn){
    if (!mq) return;
    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', fn);
    else if (typeof mq.addListener === 'function') mq.addListener(fn);
  }

  function reflowAll(){
    for (var i = 0; i < sections.length; i++){
      unbindSection(sections[i]);
      bindSection(sections[i]);
    }
  }

  attachMQ(reduceMQ, reflowAll);
  attachMQ(coarseMQ, reflowAll);

  if (d.readyState !== 'loading') boot();
  else d.addEventListener('DOMContentLoaded', boot);

  d.addEventListener('shopify:section:load', function(ev){
    var t = ev && ev.target;
    if (!t) return;
    rebind(t);
  });

  w.HH = Object.assign(w.HH || {}, {
    press: {
      boot: boot,
      rebind: rebind
    }
  });
})(window, document);

/* Cycle 295 :: HH.login */
(function(w, d){
  if (!w || !d) return;

  var SECTION_SEL = '[data-hh-login]';
  var sections = [];

  var reduceMQ = w.matchMedia ? w.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var coarseMQ = w.matchMedia ? w.matchMedia('(pointer: coarse)') : null;

  function reduce(){ return !!(reduceMQ && reduceMQ.matches); }
  function coarse(){ return !!(coarseMQ && coarseMQ.matches); }

  function reveal(section){
    if (!section || section.__hhLoginRevealed) return;
    section.classList.add('is-revealed');
    section.__hhLoginRevealed = true;
  }

  function bindFloatingLabels(section){
    var inputs = section.querySelectorAll('[data-hh-login-input]');
    for (var i = 0; i < inputs.length; i++){
      (function(input){
        var field = input.closest('[data-hh-login-field]');
        if (!field) return;
        function sync(){
          if (input.value && input.value.length > 0){
            field.classList.add('is-filled');
          } else {
            field.classList.remove('is-filled');
          }
        }
        sync();
        input.addEventListener('input', sync);
        input.addEventListener('change', sync);
        input.addEventListener('blur', sync);
        input.__hhLoginLabelOff = function(){
          input.removeEventListener('input', sync);
          input.removeEventListener('change', sync);
          input.removeEventListener('blur', sync);
        };
      })(inputs[i]);
    }
  }

  function bindRecoverToggle(section){
    var recover = section.querySelector('[data-hh-login-recover]');
    if (!recover) return;
    var triggers = section.querySelectorAll('[data-hh-login-recover-trigger]');
    var closers = section.querySelectorAll('[data-hh-login-recover-close]');
    var lastTrigger = null;

    function open(){
      recover.classList.add('is-open');
      recover.style.removeProperty('grid-template-rows');
      recover.inert = false;
      var f = recover.querySelector('input[type="email"]');
      if (f){
        try { f.focus({ preventScroll: true }); } catch(_e){ try { f.focus(); } catch(_ee){} }
      }
    }
    function close(){
      recover.classList.remove('is-open');
      recover.style.removeProperty('grid-template-rows');
      recover.inert = true;
      if (lastTrigger && typeof lastTrigger.focus === 'function'){
        try { lastTrigger.focus({ preventScroll: true }); } catch(_e){ try { lastTrigger.focus(); } catch(_ee){} }
      }
    }
    function onTrigger(e){
      e.preventDefault();
      lastTrigger = e.currentTarget;
      if (recover.classList.contains('is-open')) close();
      else open();
    }
    function onClose(e){
      e.preventDefault();
      close();
    }

    for (var i = 0; i < triggers.length; i++){
      triggers[i].addEventListener('click', onTrigger);
    }
    for (var k = 0; k < closers.length; k++){
      closers[k].addEventListener('click', onClose);
    }

    if (w.location && w.location.hash === '#recover'){ open(); }
    var hasRecoverAlert = recover.querySelector('.hh-login__error, .hh-login__success');
    if (hasRecoverAlert){ open(); }

    section.__hhLoginRecoverOff = function(){
      for (var i = 0; i < triggers.length; i++){
        triggers[i].removeEventListener('click', onTrigger);
      }
      for (var k = 0; k < closers.length; k++){
        closers[k].removeEventListener('click', onClose);
      }
    };
  }

  function bindSection(section){
    if (!section || section.__hhLoginBound) return;
    section.__hhLoginBound = true;

    if (section.dataset.recipeA === 'true') section.classList.add('is-recipe-a');
    if (section.dataset.corduroy === 'true') section.classList.add('is-corduroy');
    if (section.dataset.kineticH === 'true') section.classList.add('is-kinetic');

    bindFloatingLabels(section);
    bindRecoverToggle(section);

    if (w.HH && w.HH.magnetic && typeof w.HH.magnetic.bindNew === 'function'){
      try { w.HH.magnetic.bindNew(section); } catch(_e){}
    }

    if (reduce() || coarse() || !('IntersectionObserver' in w)){
      reveal(section);
      return;
    }

    var io = new w.IntersectionObserver(function(entries){
      for (var i = 0; i < entries.length; i++){
        if (entries[i].isIntersecting){
          reveal(section);
          io.disconnect();
          break;
        }
      }
    }, { threshold: 0.18 });
    io.observe(section);
    section.__hhLoginIO = io;
  }

  function unbindSection(section){
    if (!section || !section.__hhLoginBound) return;
    if (section.__hhLoginIO){
      try { section.__hhLoginIO.disconnect(); } catch(_e){}
      section.__hhLoginIO = null;
    }
    if (typeof section.__hhLoginRecoverOff === 'function'){
      try { section.__hhLoginRecoverOff(); } catch(_e){}
    }
    var inputs = section.querySelectorAll('[data-hh-login-input]');
    for (var i = 0; i < inputs.length; i++){
      if (typeof inputs[i].__hhLoginLabelOff === 'function'){
        try { inputs[i].__hhLoginLabelOff(); } catch(_e){}
      }
    }
    section.classList.remove('is-revealed');
    section.__hhLoginRevealed = false;
    section.__hhLoginBound = false;
  }

  function boot(){
    var nodes = d.querySelectorAll(SECTION_SEL);
    sections = Array.prototype.slice.call(nodes);
    for (var i = 0; i < sections.length; i++) bindSection(sections[i]);
  }

  function rebind(scope){
    var root = scope || d;
    var nodes;
    if (root === d){
      nodes = d.querySelectorAll(SECTION_SEL);
    } else if (root.matches && root.matches(SECTION_SEL)){
      nodes = [root];
    } else {
      nodes = root.querySelectorAll ? root.querySelectorAll(SECTION_SEL) : [];
    }
    for (var i = 0; i < nodes.length; i++){
      unbindSection(nodes[i]);
      bindSection(nodes[i]);
      if (sections.indexOf(nodes[i]) === -1) sections.push(nodes[i]);
    }
  }

  function attachMQ(mq, fn){
    if (!mq) return;
    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', fn);
    else if (typeof mq.addListener === 'function') mq.addListener(fn);
  }
  function reflowAll(){
    for (var i = 0; i < sections.length; i++){
      unbindSection(sections[i]);
      bindSection(sections[i]);
    }
  }
  attachMQ(reduceMQ, reflowAll);
  attachMQ(coarseMQ, reflowAll);

  if (d.readyState !== 'loading') boot();
  else d.addEventListener('DOMContentLoaded', boot);

  d.addEventListener('shopify:section:load', function(ev){
    var t = ev && ev.target;
    if (!t) return;
    rebind(t);
  });

  w.HH = Object.assign(w.HH || {}, {
    login: {
      boot: boot,
      rebind: rebind
    }
  });
})(window, document);

/* Cycle 129 :: cart-PAGE line edit. The server-rendered .hh-line__form is
   HTML5-illegally nested inside the outer #cart form, so its Remove/qty
   controls reparent to /cart with the wrong shape and never work without JS.
   Additive delegated handler scoped to [data-hh-main-cart]: intercept, POST
   /cart/change.js, reload. Drawer has its own path; this is page-only. */
(function(){
  'use strict';
  var d = document;
  function bindCartPageLines(){
    var mc = d.querySelector('[data-hh-main-cart]');
    if (!mc || mc.dataset.hhLineEditBound === '1') return;
    mc.dataset.hhLineEditBound = '1';
    function change(id, q){
      if (!id) return;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: id, quantity: q })
      }).then(function(r){ return r && r.ok ? r.json() : null; })
        .then(function(){ window.location.reload(); })
        .catch(function(){ window.location.reload(); });
    }
    mc.addEventListener('submit', function(e){
      var f = e.target && e.target.closest ? e.target.closest('.hh-line__form') : null;
      if (!f) return;
      e.preventDefault();
      var ide = f.querySelector('[name="id"]');
      var id = ide ? ide.value : '';
      var s = e.submitter;
      var q;
      if (s && s.name === 'update'){ q = 0; }
      else { var qe = f.querySelector('[name="quantity"]'); q = qe ? Math.max(0, parseInt(qe.value || '1', 10)) : 1; }
      change(id, q);
    });
    var qTimer;
    mc.addEventListener('input', function(e){
      var t = e.target;
      if (!t || !t.matches || !t.matches('.hh-line__form [name="quantity"]')) return;
      var f = t.closest('.hh-line__form');
      var ide = f && f.querySelector('[name="id"]');
      var id = ide ? ide.value : '';
      var raw = t.value;
      if (qTimer) clearTimeout(qTimer);
      qTimer = setTimeout(function(){
        change(id, Math.max(0, parseInt(raw || '1', 10)));
      }, 450);
    });
  }
  if (d.readyState !== 'loading') bindCartPageLines();
  else d.addEventListener('DOMContentLoaded', bindCartPageLines);
})();
